import { ResponseContext, RequestContext, HttpFile } from '../http/http';
import { Configuration} from '../configuration'
import { Observable, of, from } from '../rxjsStub';
import {mergeMap, map} from  '../rxjsStub';
import { AddAudienceRequest } from '../models/AddAudienceRequest';
import { AddCreativeRequest } from '../models/AddCreativeRequest';
import { AdvertisingPlatformServiceAddAccountRepRequest } from '../models/AdvertisingPlatformServiceAddAccountRepRequest';
import { AdvertisingPlatformServiceAddCommissionGroupRequest } from '../models/AdvertisingPlatformServiceAddCommissionGroupRequest';
import { AdvertisingPlatformServiceAddSalesRepRequest } from '../models/AdvertisingPlatformServiceAddSalesRepRequest';
import { AdvertisingPlatformServiceAddUserRequest } from '../models/AdvertisingPlatformServiceAddUserRequest';
import { AdvertisingPlatformServiceAppendOrderLineNoteRequest } from '../models/AdvertisingPlatformServiceAppendOrderLineNoteRequest';
import { AdvertisingPlatformServiceBatchAddAudiencesRequest } from '../models/AdvertisingPlatformServiceBatchAddAudiencesRequest';
import { AdvertisingPlatformServiceBatchAddCreativesRequest } from '../models/AdvertisingPlatformServiceBatchAddCreativesRequest';
import { AdvertisingPlatformServiceBatchRemoveAudiencesRequest } from '../models/AdvertisingPlatformServiceBatchRemoveAudiencesRequest';
import { AdvertisingPlatformServiceBatchRemoveCreativesRequest } from '../models/AdvertisingPlatformServiceBatchRemoveCreativesRequest';
import { AdvertisingPlatformServiceCloneOrderLineRequest } from '../models/AdvertisingPlatformServiceCloneOrderLineRequest';
import { AdvertisingPlatformServiceCreateOrgNoteRequest } from '../models/AdvertisingPlatformServiceCreateOrgNoteRequest';
import { AdvertisingPlatformServiceDeactivateOrderLineNoteRequest } from '../models/AdvertisingPlatformServiceDeactivateOrderLineNoteRequest';
import { AdvertisingPlatformServicePauseSchedulesRequest } from '../models/AdvertisingPlatformServicePauseSchedulesRequest';
import { AdvertisingPlatformServicePlaySchedulesRequest } from '../models/AdvertisingPlatformServicePlaySchedulesRequest';
import { AdvertisingPlatformServiceRemoveCommissionGroupRequest } from '../models/AdvertisingPlatformServiceRemoveCommissionGroupRequest';
import { AdvertisingPlatformServiceRemoveUserRequest } from '../models/AdvertisingPlatformServiceRemoveUserRequest';
import { AdvertisingPlatformServiceRetryReportRunRequest } from '../models/AdvertisingPlatformServiceRetryReportRunRequest';
import { AdvertisingPlatformServiceRunOneSubscriptionRequest } from '../models/AdvertisingPlatformServiceRunOneSubscriptionRequest';
import { AdvertisingPlatformServiceRunReportRequest } from '../models/AdvertisingPlatformServiceRunReportRequest';
import { AdvertisingPlatformServiceTriggerRouteRequest } from '../models/AdvertisingPlatformServiceTriggerRouteRequest';
import { AdvertisingPlatformServiceUpdateAssetRequest } from '../models/AdvertisingPlatformServiceUpdateAssetRequest';
import { AdvertisingPlatformServiceUpdateEmailMappingRequest } from '../models/AdvertisingPlatformServiceUpdateEmailMappingRequest';
import { AdvertisingPlatformServiceUpdateFTPRequest } from '../models/AdvertisingPlatformServiceUpdateFTPRequest';
import { AdvertisingPlatformServiceUpdateOrderLineNoteRequest } from '../models/AdvertisingPlatformServiceUpdateOrderLineNoteRequest';
import { AdvertisingPlatformServiceUpdatePixelRequest } from '../models/AdvertisingPlatformServiceUpdatePixelRequest';
import { AdvertisingPlatformServiceUpdatePublisherRequest } from '../models/AdvertisingPlatformServiceUpdatePublisherRequest';
import { AdvertisingPlatformServiceUpdatePublisherSubscriptionRequest } from '../models/AdvertisingPlatformServiceUpdatePublisherSubscriptionRequest';
import { AdvertisingPlatformServiceUpdateRouteRequest } from '../models/AdvertisingPlatformServiceUpdateRouteRequest';
import { AdvertisingPlatformServiceUpdateRuleRequest } from '../models/AdvertisingPlatformServiceUpdateRuleRequest';
import { AdvertisingPlatformServiceUpdateRuleSetRequest } from '../models/AdvertisingPlatformServiceUpdateRuleSetRequest';
import { AdvertisingPlatformServiceUpdateSubscriptionRequest } from '../models/AdvertisingPlatformServiceUpdateSubscriptionRequest';
import { ApproveOrderLineRequest } from '../models/ApproveOrderLineRequest';
import { Apqsv1Checks } from '../models/Apqsv1Checks';
import { Apqsv1Dependency } from '../models/Apqsv1Dependency';
import { Apqsv1HealthCheck } from '../models/Apqsv1HealthCheck';
import { Apqsv1HealthCondition } from '../models/Apqsv1HealthCondition';
import { Apqsv1Miscellanea } from '../models/Apqsv1Miscellanea';
import { Apqsv1SystemStat } from '../models/Apqsv1SystemStat';
import { Billingservicev1Checks } from '../models/Billingservicev1Checks';
import { Billingservicev1CommissionGroup } from '../models/Billingservicev1CommissionGroup';
import { Billingservicev1Dependency } from '../models/Billingservicev1Dependency';
import { Billingservicev1HealthCheck } from '../models/Billingservicev1HealthCheck';
import { Billingservicev1HealthCondition } from '../models/Billingservicev1HealthCondition';
import { Billingservicev1Invoice } from '../models/Billingservicev1Invoice';
import { Billingservicev1InvoiceStatus } from '../models/Billingservicev1InvoiceStatus';
import { Billingservicev1ListInvoicesResponse } from '../models/Billingservicev1ListInvoicesResponse';
import { Billingservicev1Miscellanea } from '../models/Billingservicev1Miscellanea';
import { Billingservicev1Org } from '../models/Billingservicev1Org';
import { Billingservicev1SystemStat } from '../models/Billingservicev1SystemStat';
import { Billingservicev2Invoice } from '../models/Billingservicev2Invoice';
import { Billingservicev2InvoiceStatus } from '../models/Billingservicev2InvoiceStatus';
import { Billingservicev2ListInvoicesResponse } from '../models/Billingservicev2ListInvoicesResponse';
import { CPMContainsInformationRelatingToAClientCpmanization } from '../models/CPMContainsInformationRelatingToAClientCpmanization';
import { Campaignservicev1AdType } from '../models/Campaignservicev1AdType';
import { Campaignservicev1Audience } from '../models/Campaignservicev1Audience';
import { Campaignservicev1Campaign } from '../models/Campaignservicev1Campaign';
import { Campaignservicev1Checks } from '../models/Campaignservicev1Checks';
import { Campaignservicev1Creative } from '../models/Campaignservicev1Creative';
import { Campaignservicev1Dependency } from '../models/Campaignservicev1Dependency';
import { Campaignservicev1HealthCheck } from '../models/Campaignservicev1HealthCheck';
import { Campaignservicev1HealthCondition } from '../models/Campaignservicev1HealthCondition';
import { Campaignservicev1JobStatus } from '../models/Campaignservicev1JobStatus';
import { Campaignservicev1ListCampaignsResponse } from '../models/Campaignservicev1ListCampaignsResponse';
import { Campaignservicev1Miscellanea } from '../models/Campaignservicev1Miscellanea';
import { Campaignservicev1Note } from '../models/Campaignservicev1Note';
import { Campaignservicev1NoteType } from '../models/Campaignservicev1NoteType';
import { Campaignservicev1OrderLine } from '../models/Campaignservicev1OrderLine';
import { Campaignservicev1Status } from '../models/Campaignservicev1Status';
import { Campaignservicev1SystemStat } from '../models/Campaignservicev1SystemStat';
import { CancelOrderLineDeploymentRequest } from '../models/CancelOrderLineDeploymentRequest';
import { Contact } from '../models/Contact';
import { CreateCreditCardRequest } from '../models/CreateCreditCardRequest';
import { CreateDeploymentRequest } from '../models/CreateDeploymentRequest';
import { Creativeservicev1AdType } from '../models/Creativeservicev1AdType';
import { Creativeservicev1Audit } from '../models/Creativeservicev1Audit';
import { Creativeservicev1AuditResult } from '../models/Creativeservicev1AuditResult';
import { Creativeservicev1AuditStatus } from '../models/Creativeservicev1AuditStatus';
import { Creativeservicev1Checks } from '../models/Creativeservicev1Checks';
import { Creativeservicev1Creative } from '../models/Creativeservicev1Creative';
import { Creativeservicev1Dependency } from '../models/Creativeservicev1Dependency';
import { Creativeservicev1DeploymentType } from '../models/Creativeservicev1DeploymentType';
import { Creativeservicev1Destination } from '../models/Creativeservicev1Destination';
import { Creativeservicev1FileType } from '../models/Creativeservicev1FileType';
import { Creativeservicev1FolderStats } from '../models/Creativeservicev1FolderStats';
import { Creativeservicev1HealthCheck } from '../models/Creativeservicev1HealthCheck';
import { Creativeservicev1HealthCondition } from '../models/Creativeservicev1HealthCondition';
import { Creativeservicev1ListCreativesResponse } from '../models/Creativeservicev1ListCreativesResponse';
import { Creativeservicev1Miscellanea } from '../models/Creativeservicev1Miscellanea';
import { Creativeservicev1NativeMetadata } from '../models/Creativeservicev1NativeMetadata';
import { Creativeservicev1OrderLine } from '../models/Creativeservicev1OrderLine';
import { Creativeservicev1Status } from '../models/Creativeservicev1Status';
import { Creativeservicev1SystemStat } from '../models/Creativeservicev1SystemStat';
import { Creativeservicev1Type } from '../models/Creativeservicev1Type';
import { CreditCard } from '../models/CreditCard';
import { CreditCard1 } from '../models/CreditCard1';
import { DeployMetadataDeployedCPM } from '../models/DeployMetadataDeployedCPM';
import { DeployOrderLineRequest } from '../models/DeployOrderLineRequest';
import { Deployservicev3Audit } from '../models/Deployservicev3Audit';
import { Deployservicev3AuditResult } from '../models/Deployservicev3AuditResult';
import { Deployservicev3AuditStatus } from '../models/Deployservicev3AuditStatus';
import { Deployservicev3Campaign } from '../models/Deployservicev3Campaign';
import { Deployservicev3Checks } from '../models/Deployservicev3Checks';
import { Deployservicev3Creative } from '../models/Deployservicev3Creative';
import { Deployservicev3CreativeID } from '../models/Deployservicev3CreativeID';
import { Deployservicev3Dependency } from '../models/Deployservicev3Dependency';
import { Deployservicev3Deployment } from '../models/Deployservicev3Deployment';
import { Deployservicev3DeploymentType } from '../models/Deployservicev3DeploymentType';
import { Deployservicev3Destination } from '../models/Deployservicev3Destination';
import { Deployservicev3HealthCheck } from '../models/Deployservicev3HealthCheck';
import { Deployservicev3HealthCondition } from '../models/Deployservicev3HealthCondition';
import { Deployservicev3ListCampaignsResponse } from '../models/Deployservicev3ListCampaignsResponse';
import { Deployservicev3ListCreativesResponse } from '../models/Deployservicev3ListCreativesResponse';
import { Deployservicev3Miscellanea } from '../models/Deployservicev3Miscellanea';
import { Deployservicev3NativeMetadata } from '../models/Deployservicev3NativeMetadata';
import { Deployservicev3Status } from '../models/Deployservicev3Status';
import { Deployservicev3SystemStat } from '../models/Deployservicev3SystemStat';
import { Deployservicev3Value } from '../models/Deployservicev3Value';
import { DeviceStatsRequestWillHoldThePOSTRequestVarsForCustomizingDeviceStatisticsQueries } from '../models/DeviceStatsRequestWillHoldThePOSTRequestVarsForCustomizingDeviceStatisticsQueries';
import { ExistingUserWithNewFieldValues } from '../models/ExistingUserWithNewFieldValues';
import { GetDefaultTemplateRequest } from '../models/GetDefaultTemplateRequest';
import { GlobalSearchResponseCount } from '../models/GlobalSearchResponseCount';
import { GoogleprotobufAny } from '../models/GoogleprotobufAny';
import { GooglerpcStatus } from '../models/GooglerpcStatus';
import { Hagridv1Checks } from '../models/Hagridv1Checks';
import { Hagridv1Dependency } from '../models/Hagridv1Dependency';
import { Hagridv1FileMetaData } from '../models/Hagridv1FileMetaData';
import { Hagridv1HealthCheck } from '../models/Hagridv1HealthCheck';
import { Hagridv1HealthCondition } from '../models/Hagridv1HealthCondition';
import { Hagridv1ListUsersResponse } from '../models/Hagridv1ListUsersResponse';
import { Hagridv1Miscellanea } from '../models/Hagridv1Miscellanea';
import { Hagridv1SystemStat } from '../models/Hagridv1SystemStat';
import { Hagridv1User } from '../models/Hagridv1User';
import { Job } from '../models/Job';
import { LockOrderLineRequest } from '../models/LockOrderLineRequest';
import { MoveOrgsRequest } from '../models/MoveOrgsRequest';
import { Notification } from '../models/Notification';
import { Notificationservicev1Checks } from '../models/Notificationservicev1Checks';
import { Notificationservicev1Dependency } from '../models/Notificationservicev1Dependency';
import { Notificationservicev1HealthCheck } from '../models/Notificationservicev1HealthCheck';
import { Notificationservicev1HealthCondition } from '../models/Notificationservicev1HealthCondition';
import { Notificationservicev1Miscellanea } from '../models/Notificationservicev1Miscellanea';
import { Notificationservicev1SystemStat } from '../models/Notificationservicev1SystemStat';
import { Notificationservicev1Type } from '../models/Notificationservicev1Type';
import { OrderLineJobErrorDetail } from '../models/OrderLineJobErrorDetail';
import { OrderLineViantAdelphicIDsSetAudienceID } from '../models/OrderLineViantAdelphicIDsSetAudienceID';
import { Orgmanagerv1Checks } from '../models/Orgmanagerv1Checks';
import { Orgmanagerv1CommissionGroup } from '../models/Orgmanagerv1CommissionGroup';
import { Orgmanagerv1Contact } from '../models/Orgmanagerv1Contact';
import { Orgmanagerv1Dependency } from '../models/Orgmanagerv1Dependency';
import { Orgmanagerv1HealthCheck } from '../models/Orgmanagerv1HealthCheck';
import { Orgmanagerv1HealthCondition } from '../models/Orgmanagerv1HealthCondition';
import { Orgmanagerv1Miscellanea } from '../models/Orgmanagerv1Miscellanea';
import { Orgmanagerv1Note } from '../models/Orgmanagerv1Note';
import { Orgmanagerv1NoteType } from '../models/Orgmanagerv1NoteType';
import { Orgmanagerv1Org } from '../models/Orgmanagerv1Org';
import { Orgmanagerv1Status } from '../models/Orgmanagerv1Status';
import { Orgmanagerv1SystemStat } from '../models/Orgmanagerv1SystemStat';
import { Orgmanagerv1Timeframe } from '../models/Orgmanagerv1Timeframe';
import { Orgmanagerv1User } from '../models/Orgmanagerv1User';
import { Orgmanagerv2ListUsersResponse } from '../models/Orgmanagerv2ListUsersResponse';
import { Orgmanagerv2User } from '../models/Orgmanagerv2User';
import { PauseOrderLineRequest } from '../models/PauseOrderLineRequest';
import { PayInvoiceRequest } from '../models/PayInvoiceRequest';
import { PaySetUpFeeRequest } from '../models/PaySetUpFeeRequest';
import { PixelNote } from '../models/PixelNote';
import { PlayOrderLineRequest } from '../models/PlayOrderLineRequest';
import { PrepayRequest } from '../models/PrepayRequest';
import { ProtobufNullValue } from '../models/ProtobufNullValue';
import { RejectOrderLineRequest } from '../models/RejectOrderLineRequest';
import { RemoveAudienceRequest } from '../models/RemoveAudienceRequest';
import { RemoveCreativeRequest } from '../models/RemoveCreativeRequest';
import { RequestReviewRequest } from '../models/RequestReviewRequest';
import { SetDistributionRequest } from '../models/SetDistributionRequest';
import { StartReviewRequest } from '../models/StartReviewRequest';
import { StatsRequestWillHoldThePOSTRequestVarsForCustomizingStatisticsQueries } from '../models/StatsRequestWillHoldThePOSTRequestVarsForCustomizingStatisticsQueries';
import { StreamResultOfV1DownloadAudienceFileResponse } from '../models/StreamResultOfV1DownloadAudienceFileResponse';
import { StreamResultOfV1DownloadBundleResponse } from '../models/StreamResultOfV1DownloadBundleResponse';
import { StreamResultOfV1DownloadCreativeFileResponse } from '../models/StreamResultOfV1DownloadCreativeFileResponse';
import { StreamResultOfV1DownloadExclusionAddressesResponse } from '../models/StreamResultOfV1DownloadExclusionAddressesResponse';
import { StreamResultOfV1DownloadJobFileResponse } from '../models/StreamResultOfV1DownloadJobFileResponse';
import { StreamResultOfV1DownloadTOSAgreementResponse } from '../models/StreamResultOfV1DownloadTOSAgreementResponse';
import { StreamResultOfV2DownloadTargetFileResponse } from '../models/StreamResultOfV2DownloadTargetFileResponse';
import { SubscriptionNote } from '../models/SubscriptionNote';
import { Targetjobservicev1Audience } from '../models/Targetjobservicev1Audience';
import { Targetjobservicev1Checks } from '../models/Targetjobservicev1Checks';
import { Targetjobservicev1Column } from '../models/Targetjobservicev1Column';
import { Targetjobservicev1Dependency } from '../models/Targetjobservicev1Dependency';
import { Targetjobservicev1Deployment } from '../models/Targetjobservicev1Deployment';
import { Targetjobservicev1FolderStats } from '../models/Targetjobservicev1FolderStats';
import { Targetjobservicev1HealthCheck } from '../models/Targetjobservicev1HealthCheck';
import { Targetjobservicev1HealthCondition } from '../models/Targetjobservicev1HealthCondition';
import { Targetjobservicev1JobStatus } from '../models/Targetjobservicev1JobStatus';
import { Targetjobservicev1Miscellanea } from '../models/Targetjobservicev1Miscellanea';
import { Targetjobservicev1Note } from '../models/Targetjobservicev1Note';
import { Targetjobservicev1NoteType } from '../models/Targetjobservicev1NoteType';
import { Targetjobservicev1SystemStat } from '../models/Targetjobservicev1SystemStat';
import { Targetjobservicev1Timeframe } from '../models/Targetjobservicev1Timeframe';
import { Targetorchestratorv2Checks } from '../models/Targetorchestratorv2Checks';
import { Targetorchestratorv2Column } from '../models/Targetorchestratorv2Column';
import { Targetorchestratorv2Dependency } from '../models/Targetorchestratorv2Dependency';
import { Targetorchestratorv2FileMetaData } from '../models/Targetorchestratorv2FileMetaData';
import { Targetorchestratorv2FileType } from '../models/Targetorchestratorv2FileType';
import { Targetorchestratorv2FolderStats } from '../models/Targetorchestratorv2FolderStats';
import { Targetorchestratorv2HealthCheck } from '../models/Targetorchestratorv2HealthCheck';
import { Targetorchestratorv2HealthCondition } from '../models/Targetorchestratorv2HealthCondition';
import { Targetorchestratorv2Location } from '../models/Targetorchestratorv2Location';
import { Targetorchestratorv2Miscellanea } from '../models/Targetorchestratorv2Miscellanea';
import { Targetorchestratorv2SystemStat } from '../models/Targetorchestratorv2SystemStat';
import { TheAdvertiserToCreate } from '../models/TheAdvertiserToCreate';
import { TheAudienceToUpdate } from '../models/TheAudienceToUpdate';
import { TheAutomationToUpdate } from '../models/TheAutomationToUpdate';
import { TheCampaignToCreate } from '../models/TheCampaignToCreate';
import { TheCampaignToUpdate } from '../models/TheCampaignToUpdate';
import { TheCreativeToCreate } from '../models/TheCreativeToCreate';
import { TheCreativeToUpdate } from '../models/TheCreativeToUpdate';
import { TheDeploymentToCreate } from '../models/TheDeploymentToCreate';
import { TheNoteToUpdate } from '../models/TheNoteToUpdate';
import { TheOrderLineToUpdate } from '../models/TheOrderLineToUpdate';
import { TheOrganizationToUpdate } from '../models/TheOrganizationToUpdate';
import { TheReportToUpdateMustIncludeIdIdentifiesWhichReportAndTheNewValuesForEveryFieldListedInUpdateMask } from '../models/TheReportToUpdateMustIncludeIdIdentifiesWhichReportAndTheNewValuesForEveryFieldListedInUpdateMask';
import { TheScheduleToUpdateMustIncludeIdIdentifiesWhichScheduleAndTheNewValuesForEveryFieldListedInUpdateMask } from '../models/TheScheduleToUpdateMustIncludeIdIdentifiesWhichScheduleAndTheNewValuesForEveryFieldListedInUpdateMask';
import { TheSegmentToCreate } from '../models/TheSegmentToCreate';
import { TheTargetToUpdate } from '../models/TheTargetToUpdate';
import { TypeDate } from '../models/TypeDate';
import { TypeMoney } from '../models/TypeMoney';
import { UnlockOrderLineRequest } from '../models/UnlockOrderLineRequest';
import { UpdateCPMsRequest } from '../models/UpdateCPMsRequest';
import { UpdateDeploymentRequest } from '../models/UpdateDeploymentRequest';
import { V1AccountingJob } from '../models/V1AccountingJob';
import { V1AccountingJobKind } from '../models/V1AccountingJobKind';
import { V1AdditionalArguments } from '../models/V1AdditionalArguments';
import { V1AdminInvoice } from '../models/V1AdminInvoice';
import { V1AdminListNotificationsResponse } from '../models/V1AdminListNotificationsResponse';
import { V1ArchiveCampaignRequest } from '../models/V1ArchiveCampaignRequest';
import { V1ArchiveCreativeRequest } from '../models/V1ArchiveCreativeRequest';
import { V1ArchiveOrderLineRequest } from '../models/V1ArchiveOrderLineRequest';
import { V1Asset } from '../models/V1Asset';
import { V1AssetType } from '../models/V1AssetType';
import { V1Assignment } from '../models/V1Assignment';
import { V1AttachExcludedAddressesRequest } from '../models/V1AttachExcludedAddressesRequest';
import { V1Attachment } from '../models/V1Attachment';
import { V1AudienceAdded } from '../models/V1AudienceAdded';
import { V1AudienceFileType } from '../models/V1AudienceFileType';
import { V1AudienceRemoved } from '../models/V1AudienceRemoved';
import { V1AudienceStatus } from '../models/V1AudienceStatus';
import { V1AudienceSubType } from '../models/V1AudienceSubType';
import { V1AudienceType } from '../models/V1AudienceType';
import { V1AuditConditions } from '../models/V1AuditConditions';
import { V1Authorization } from '../models/V1Authorization';
import { V1Automation } from '../models/V1Automation';
import { V1AutomationType } from '../models/V1AutomationType';
import { V1AuxiliaryFileFilter } from '../models/V1AuxiliaryFileFilter';
import { V1Balance } from '../models/V1Balance';
import { V1BatchAddAudiencesRequestAudience } from '../models/V1BatchAddAudiencesRequestAudience';
import { V1BatchUpdateOrderLinesRequest } from '../models/V1BatchUpdateOrderLinesRequest';
import { V1BatchUpdateOrderLinesResponse } from '../models/V1BatchUpdateOrderLinesResponse';
import { V1BatchUpdateOrgsRequest } from '../models/V1BatchUpdateOrgsRequest';
import { V1BatchUpdateOrgsResponse } from '../models/V1BatchUpdateOrgsResponse';
import { V1BrandingMode } from '../models/V1BrandingMode';
import { V1BundleRequest } from '../models/V1BundleRequest';
import { V1CPM } from '../models/V1CPM';
import { V1CPMOverride } from '../models/V1CPMOverride';
import { V1CampaignArchived } from '../models/V1CampaignArchived';
import { V1CampaignCreated } from '../models/V1CampaignCreated';
import { V1CampaignDeleted } from '../models/V1CampaignDeleted';
import { V1CampaignEvent } from '../models/V1CampaignEvent';
import { V1CampaignFlightDatesSet } from '../models/V1CampaignFlightDatesSet';
import { V1CampaignJobIdSet } from '../models/V1CampaignJobIdSet';
import { V1CampaignNameSet } from '../models/V1CampaignNameSet';
import { V1CampaignOrderLine } from '../models/V1CampaignOrderLine';
import { V1CampaignPoIdSet } from '../models/V1CampaignPoIdSet';
import { V1CampaignPoliticalIndependentExpenditureFormPathSet } from '../models/V1CampaignPoliticalIndependentExpenditureFormPathSet';
import { V1CampaignPoliticalIndependentExpenditureStateSet } from '../models/V1CampaignPoliticalIndependentExpenditureStateSet';
import { V1CampaignPoliticalTransparencySet } from '../models/V1CampaignPoliticalTransparencySet';
import { V1CampaignRefIDSet } from '../models/V1CampaignRefIDSet';
import { V1CampaignSearch } from '../models/V1CampaignSearch';
import { V1CampaignUnarchived } from '../models/V1CampaignUnarchived';
import { V1CancelAudienceGenerationRequest } from '../models/V1CancelAudienceGenerationRequest';
import { V1ClientRoles } from '../models/V1ClientRoles';
import { V1CloneAudienceRequest } from '../models/V1CloneAudienceRequest';
import { V1CombinationRule } from '../models/V1CombinationRule';
import { V1CommissionType } from '../models/V1CommissionType';
import { V1ComponentResult } from '../models/V1ComponentResult';
import { V1ComponentResults } from '../models/V1ComponentResults';
import { V1CostRange } from '../models/V1CostRange';
import { V1CpmPlus } from '../models/V1CpmPlus';
import { V1CreateEmailMappingRequest } from '../models/V1CreateEmailMappingRequest';
import { V1CreateReportResponse } from '../models/V1CreateReportResponse';
import { V1CreateRouteRequest } from '../models/V1CreateRouteRequest';
import { V1CreativeAdded } from '../models/V1CreativeAdded';
import { V1CreativeFile } from '../models/V1CreativeFile';
import { V1CreativeFileMetadata } from '../models/V1CreativeFileMetadata';
import { V1CreativeRemoved } from '../models/V1CreativeRemoved';
import { V1CreativeSearch } from '../models/V1CreativeSearch';
import { V1CredentialRepresentation } from '../models/V1CredentialRepresentation';
import { V1CreditCard } from '../models/V1CreditCard';
import { V1CronResponse } from '../models/V1CronResponse';
import { V1CsvExportConfig } from '../models/V1CsvExportConfig';
import { V1DataProduct } from '../models/V1DataProduct';
import { V1DataSource } from '../models/V1DataSource';
import { V1DataSourcesHighestUpcharge } from '../models/V1DataSourcesHighestUpcharge';
import { V1DayOfWeek } from '../models/V1DayOfWeek';
import { V1DeployMetadata } from '../models/V1DeployMetadata';
import { V1DestinationAllocation } from '../models/V1DestinationAllocation';
import { V1DetachExcludedAddressesRequest } from '../models/V1DetachExcludedAddressesRequest';
import { V1DeviceMainDetails } from '../models/V1DeviceMainDetails';
import { V1DeviceResultIDs } from '../models/V1DeviceResultIDs';
import { V1DeviceResults } from '../models/V1DeviceResults';
import { V1DeviceStatsResponse } from '../models/V1DeviceStatsResponse';
import { V1DeviceSubDetails } from '../models/V1DeviceSubDetails';
import { V1Distribution } from '../models/V1Distribution';
import { V1DownloadAudienceFileResponse } from '../models/V1DownloadAudienceFileResponse';
import { V1DownloadBundleResponse } from '../models/V1DownloadBundleResponse';
import { V1DownloadCreativeFileResponse } from '../models/V1DownloadCreativeFileResponse';
import { V1DownloadExclusionAddressesResponse } from '../models/V1DownloadExclusionAddressesResponse';
import { V1DownloadJobFileResponse } from '../models/V1DownloadJobFileResponse';
import { V1DownloadTOSAgreementResponse } from '../models/V1DownloadTOSAgreementResponse';
import { V1EmailDestinations } from '../models/V1EmailDestinations';
import { V1EmailMapping } from '../models/V1EmailMapping';
import { V1EmailTemplateConfig } from '../models/V1EmailTemplateConfig';
import { V1Entry } from '../models/V1Entry';
import { V1Excludes } from '../models/V1Excludes';
import { V1ExclusionAddresses } from '../models/V1ExclusionAddresses';
import { V1ExclusionAddressesAttached } from '../models/V1ExclusionAddressesAttached';
import { V1ExclusionAddressesDetached } from '../models/V1ExclusionAddressesDetached';
import { V1ExclusionAddressesFileMetaData } from '../models/V1ExclusionAddressesFileMetaData';
import { V1ExportConfig } from '../models/V1ExportConfig';
import { V1ExportDataResponse } from '../models/V1ExportDataResponse';
import { V1ExportType } from '../models/V1ExportType';
import { V1FTP } from '../models/V1FTP';
import { V1FileFilters } from '../models/V1FileFilters';
import { V1FileSubType } from '../models/V1FileSubType';
import { V1FrequencyConfig } from '../models/V1FrequencyConfig';
import { V1GetNewMoverMatchCountResponse } from '../models/V1GetNewMoverMatchCountResponse';
import { V1GetNotificationsResponse } from '../models/V1GetNotificationsResponse';
import { V1GetTemplateResponse } from '../models/V1GetTemplateResponse';
import { V1GetUserIPResponse } from '../models/V1GetUserIPResponse';
import { V1GlobalSearchResponse } from '../models/V1GlobalSearchResponse';
import { V1HighestCPMAudience } from '../models/V1HighestCPMAudience';
import { V1Includes } from '../models/V1Includes';
import { V1IntervalUnit } from '../models/V1IntervalUnit';
import { V1JWT } from '../models/V1JWT';
import { V1Job } from '../models/V1Job';
import { V1JobFileType } from '../models/V1JobFileType';
import { V1JobSearch } from '../models/V1JobSearch';
import { V1JobSubType } from '../models/V1JobSubType';
import { V1JobTemplate } from '../models/V1JobTemplate';
import { V1JobType } from '../models/V1JobType';
import { V1ListAccountingJobsResponse } from '../models/V1ListAccountingJobsResponse';
import { V1ListAssetsResponse } from '../models/V1ListAssetsResponse';
import { V1ListAudienceFoldersResponse } from '../models/V1ListAudienceFoldersResponse';
import { V1ListAudiencesResponse } from '../models/V1ListAudiencesResponse';
import { V1ListCampaignEventsResponse } from '../models/V1ListCampaignEventsResponse';
import { V1ListCommissionGroupsResponse } from '../models/V1ListCommissionGroupsResponse';
import { V1ListCreativeFoldersResponse } from '../models/V1ListCreativeFoldersResponse';
import { V1ListCreditCardsResponse } from '../models/V1ListCreditCardsResponse';
import { V1ListEmailMappingsResponse } from '../models/V1ListEmailMappingsResponse';
import { V1ListExclusionAddressesResponse } from '../models/V1ListExclusionAddressesResponse';
import { V1ListOfString } from '../models/V1ListOfString';
import { V1ListOrderLineEventsResponse } from '../models/V1ListOrderLineEventsResponse';
import { V1ListOrderLineJobsResponse } from '../models/V1ListOrderLineJobsResponse';
import { V1ListOrderLinesResponse } from '../models/V1ListOrderLinesResponse';
import { V1ListOrgSubscriptionsResponse } from '../models/V1ListOrgSubscriptionsResponse';
import { V1ListOrgUsersResponse } from '../models/V1ListOrgUsersResponse';
import { V1ListOrgsResponse } from '../models/V1ListOrgsResponse';
import { V1ListPixelsResponse } from '../models/V1ListPixelsResponse';
import { V1ListPublisherSubscriptionsResponse } from '../models/V1ListPublisherSubscriptionsResponse';
import { V1ListPublishersResponse } from '../models/V1ListPublishersResponse';
import { V1ListReportRunsResponse } from '../models/V1ListReportRunsResponse';
import { V1ListReportsResponse } from '../models/V1ListReportsResponse';
import { V1ListRoutesResponse } from '../models/V1ListRoutesResponse';
import { V1ListRulesResponse } from '../models/V1ListRulesResponse';
import { V1ListSchedulesResponse } from '../models/V1ListSchedulesResponse';
import { V1ListStatsResponse } from '../models/V1ListStatsResponse';
import { V1ListSubscriptionsResponse } from '../models/V1ListSubscriptionsResponse';
import { V1ListTOSAgreementsResponse } from '../models/V1ListTOSAgreementsResponse';
import { V1ListTotalStatsResponse } from '../models/V1ListTotalStatsResponse';
import { V1MainDetails } from '../models/V1MainDetails';
import { V1MatchMode } from '../models/V1MatchMode';
import { V1MatchScope } from '../models/V1MatchScope';
import { V1Medium } from '../models/V1Medium';
import { V1Message } from '../models/V1Message';
import { V1MessageType } from '../models/V1MessageType';
import { V1Metrics } from '../models/V1Metrics';
import { V1MetricsGranularity } from '../models/V1MetricsGranularity';
import { V1MonthlyFrequencyConfig } from '../models/V1MonthlyFrequencyConfig';
import { V1MoverMatchCount } from '../models/V1MoverMatchCount';
import { V1Notification } from '../models/V1Notification';
import { V1OAuthTokenRequest } from '../models/V1OAuthTokenRequest';
import { V1OrderLineAdTypeSet } from '../models/V1OrderLineAdTypeSet';
import { V1OrderLineApproved } from '../models/V1OrderLineApproved';
import { V1OrderLineArchived } from '../models/V1OrderLineArchived';
import { V1OrderLineAuditConditionsSet } from '../models/V1OrderLineAuditConditionsSet';
import { V1OrderLineCPMOverrideRemoved } from '../models/V1OrderLineCPMOverrideRemoved';
import { V1OrderLineCPMOverriden } from '../models/V1OrderLineCPMOverriden';
import { V1OrderLineCPMSet } from '../models/V1OrderLineCPMSet';
import { V1OrderLineCampaign } from '../models/V1OrderLineCampaign';
import { V1OrderLineClickThroughURLSet } from '../models/V1OrderLineClickThroughURLSet';
import { V1OrderLineCloneRequestFailed } from '../models/V1OrderLineCloneRequestFailed';
import { V1OrderLineCloneRequestSucceeded } from '../models/V1OrderLineCloneRequestSucceeded';
import { V1OrderLineCloned } from '../models/V1OrderLineCloned';
import { V1OrderLineCompleted } from '../models/V1OrderLineCompleted';
import { V1OrderLineCostSet } from '../models/V1OrderLineCostSet';
import { V1OrderLineCreated } from '../models/V1OrderLineCreated';
import { V1OrderLineDeleted } from '../models/V1OrderLineDeleted';
import { V1OrderLineDeployed } from '../models/V1OrderLineDeployed';
import { V1OrderLineDeployedToDestinationRTB } from '../models/V1OrderLineDeployedToDestinationRTB';
import { V1OrderLineDeployedToDestinationStackAdapt } from '../models/V1OrderLineDeployedToDestinationStackAdapt';
import { V1OrderLineDeployedToDestinationXandrCurate } from '../models/V1OrderLineDeployedToDestinationXandrCurate';
import { V1OrderLineDeployedToDestinationXandrInvest } from '../models/V1OrderLineDeployedToDestinationXandrInvest';
import { V1OrderLineDeployedWithConfig } from '../models/V1OrderLineDeployedWithConfig';
import { V1OrderLineDeploymentCancelled } from '../models/V1OrderLineDeploymentCancelled';
import { V1OrderLineDeploymentCancelling } from '../models/V1OrderLineDeploymentCancelling';
import { V1OrderLineDeploymentDestinationSet } from '../models/V1OrderLineDeploymentDestinationSet';
import { V1OrderLineDestinationRTBCreated } from '../models/V1OrderLineDestinationRTBCreated';
import { V1OrderLineDestinationRTBSet } from '../models/V1OrderLineDestinationRTBSet';
import { V1OrderLineDestinationStackAdaptCreated } from '../models/V1OrderLineDestinationStackAdaptCreated';
import { V1OrderLineDestinationStackAdaptSet } from '../models/V1OrderLineDestinationStackAdaptSet';
import { V1OrderLineDestinationXandrCurateCreated } from '../models/V1OrderLineDestinationXandrCurateCreated';
import { V1OrderLineDestinationXandrCurateSet } from '../models/V1OrderLineDestinationXandrCurateSet';
import { V1OrderLineDestinationXandrInvestCreated } from '../models/V1OrderLineDestinationXandrInvestCreated';
import { V1OrderLineDestinationXandrInvestSet } from '../models/V1OrderLineDestinationXandrInvestSet';
import { V1OrderLineDistributionSet } from '../models/V1OrderLineDistributionSet';
import { V1OrderLineEndTimeSet } from '../models/V1OrderLineEndTimeSet';
import { V1OrderLineErroredDeployingToDestinationRTB } from '../models/V1OrderLineErroredDeployingToDestinationRTB';
import { V1OrderLineErroredDeployingToDestinationStackAdapt } from '../models/V1OrderLineErroredDeployingToDestinationStackAdapt';
import { V1OrderLineErroredDeployingToDestinationXandrCurate } from '../models/V1OrderLineErroredDeployingToDestinationXandrCurate';
import { V1OrderLineErroredDeployingToDestinationXandrInvest } from '../models/V1OrderLineErroredDeployingToDestinationXandrInvest';
import { V1OrderLineEvent } from '../models/V1OrderLineEvent';
import { V1OrderLineFreeImpressionsSet } from '../models/V1OrderLineFreeImpressionsSet';
import { V1OrderLineImpressionsPerDaySet } from '../models/V1OrderLineImpressionsPerDaySet';
import { V1OrderLineImpressionsSet } from '../models/V1OrderLineImpressionsSet';
import { V1OrderLineJob } from '../models/V1OrderLineJob';
import { V1OrderLineJobIdSet } from '../models/V1OrderLineJobIdSet';
import { V1OrderLineLocked } from '../models/V1OrderLineLocked';
import { V1OrderLineMigrated } from '../models/V1OrderLineMigrated';
import { V1OrderLineMinimumImpressionsSet } from '../models/V1OrderLineMinimumImpressionsSet';
import { V1OrderLineNameSet } from '../models/V1OrderLineNameSet';
import { V1OrderLineNoteAppended } from '../models/V1OrderLineNoteAppended';
import { V1OrderLineNoteDeactivated } from '../models/V1OrderLineNoteDeactivated';
import { V1OrderLineNoteUpdated } from '../models/V1OrderLineNoteUpdated';
import { V1OrderLinePaidSet } from '../models/V1OrderLinePaidSet';
import { V1OrderLinePaused } from '../models/V1OrderLinePaused';
import { V1OrderLinePlayed } from '../models/V1OrderLinePlayed';
import { V1OrderLinePoIdSet } from '../models/V1OrderLinePoIdSet';
import { V1OrderLinePoliticalFieldsSet } from '../models/V1OrderLinePoliticalFieldsSet';
import { V1OrderLinePrepaySet } from '../models/V1OrderLinePrepaySet';
import { V1OrderLineRedeployVerificationFailed } from '../models/V1OrderLineRedeployVerificationFailed';
import { V1OrderLineRefIdSet } from '../models/V1OrderLineRefIdSet';
import { V1OrderLineRejected } from '../models/V1OrderLineRejected';
import { V1OrderLineReviewStarted } from '../models/V1OrderLineReviewStarted';
import { V1OrderLineSearch } from '../models/V1OrderLineSearch';
import { V1OrderLineSegmentConfigSet } from '../models/V1OrderLineSegmentConfigSet';
import { V1OrderLineStartTimeSet } from '../models/V1OrderLineStartTimeSet';
import { V1OrderLineStateSetToActive } from '../models/V1OrderLineStateSetToActive';
import { V1OrderLineStateSetToPaused } from '../models/V1OrderLineStateSetToPaused';
import { V1OrderLineStatus } from '../models/V1OrderLineStatus';
import { V1OrderLineStatusSetToDeploying } from '../models/V1OrderLineStatusSetToDeploying';
import { V1OrderLineStatusSetToDraft } from '../models/V1OrderLineStatusSetToDraft';
import { V1OrderLineStatusSetToPrevious } from '../models/V1OrderLineStatusSetToPrevious';
import { V1OrderLineStepFunctionSet } from '../models/V1OrderLineStepFunctionSet';
import { V1OrderLineTemplateTypeSet } from '../models/V1OrderLineTemplateTypeSet';
import { V1OrderLineUnarchived } from '../models/V1OrderLineUnarchived';
import { V1OrderLineUnlocked } from '../models/V1OrderLineUnlocked';
import { V1OrderLineViantAdelphicConfigurationSet } from '../models/V1OrderLineViantAdelphicConfigurationSet';
import { V1OrderLineViantAdelphicIDsSet } from '../models/V1OrderLineViantAdelphicIDsSet';
import { V1OrderLineViantAdelphicIDsSetCreativeID } from '../models/V1OrderLineViantAdelphicIDsSetCreativeID';
import { V1OrgData } from '../models/V1OrgData';
import { V1OrgLogo } from '../models/V1OrgLogo';
import { V1PayOrderLinesRequest } from '../models/V1PayOrderLinesRequest';
import { V1PdfExportConfig } from '../models/V1PdfExportConfig';
import { V1Pixel } from '../models/V1Pixel';
import { V1PixelCreated } from '../models/V1PixelCreated';
import { V1PixelNote } from '../models/V1PixelNote';
import { V1PixelUpdated } from '../models/V1PixelUpdated';
import { V1PoliticalFields } from '../models/V1PoliticalFields';
import { V1PoliticalTransparency } from '../models/V1PoliticalTransparency';
import { V1ProductType } from '../models/V1ProductType';
import { V1Publisher } from '../models/V1Publisher';
import { V1PublisherSubscription } from '../models/V1PublisherSubscription';
import { V1QueueDetails } from '../models/V1QueueDetails';
import { V1QueueHealth } from '../models/V1QueueHealth';
import { V1RebuildGlobalSearchRequest } from '../models/V1RebuildGlobalSearchRequest';
import { V1RebuildGlobalSearchResourceType } from '../models/V1RebuildGlobalSearchResourceType';
import { V1Report } from '../models/V1Report';
import { V1ReportGranularity } from '../models/V1ReportGranularity';
import { V1ReportRun } from '../models/V1ReportRun';
import { V1ReportRunStatus } from '../models/V1ReportRunStatus';
import { V1ReportType } from '../models/V1ReportType';
import { V1RequestOrgNameChangeRequest } from '../models/V1RequestOrgNameChangeRequest';
import { V1RequestSupportRequest } from '../models/V1RequestSupportRequest';
import { V1Result } from '../models/V1Result';
import { V1ResultIDs } from '../models/V1ResultIDs';
import { V1ResultMetrics } from '../models/V1ResultMetrics';
import { V1Results } from '../models/V1Results';
import { V1ReviewRequested } from '../models/V1ReviewRequested';
import { V1Route } from '../models/V1Route';
import { V1RouteJobReport } from '../models/V1RouteJobReport';
import { V1Rule } from '../models/V1Rule';
import { V1RuleSet } from '../models/V1RuleSet';
import { V1RunCommissionsRequest } from '../models/V1RunCommissionsRequest';
import { V1RunCommissionsResponse } from '../models/V1RunCommissionsResponse';
import { V1RunInvoicingRequest } from '../models/V1RunInvoicingRequest';
import { V1RunInvoicingResponse } from '../models/V1RunInvoicingResponse';
import { V1Schedule } from '../models/V1Schedule';
import { V1ScheduleFrequency } from '../models/V1ScheduleFrequency';
import { V1ScheduleStatus } from '../models/V1ScheduleStatus';
import { V1SendMessageRequest } from '../models/V1SendMessageRequest';
import { V1SetCampaignPoliticalFormRequest } from '../models/V1SetCampaignPoliticalFormRequest';
import { V1SlackTemplateConfig } from '../models/V1SlackTemplateConfig';
import { V1State } from '../models/V1State';
import { V1Stats } from '../models/V1Stats';
import { V1StatsResponse } from '../models/V1StatsResponse';
import { V1StringList } from '../models/V1StringList';
import { V1SubDetails } from '../models/V1SubDetails';
import { V1Subscription } from '../models/V1Subscription';
import { V1SubscriptionCreated } from '../models/V1SubscriptionCreated';
import { V1SubscriptionNote } from '../models/V1SubscriptionNote';
import { V1SubscriptionUpdated } from '../models/V1SubscriptionUpdated';
import { V1TOSAgreement } from '../models/V1TOSAgreement';
import { V1TargetJobSearch } from '../models/V1TargetJobSearch';
import { V1TargetSearch } from '../models/V1TargetSearch';
import { V1TemplateConfigType } from '../models/V1TemplateConfigType';
import { V1TemplateReport } from '../models/V1TemplateReport';
import { V1TemplateType } from '../models/V1TemplateType';
import { V1TemplateVariableValue } from '../models/V1TemplateVariableValue';
import { V1TimeframePreset } from '../models/V1TimeframePreset';
import { V1TriggerRouteResponse } from '../models/V1TriggerRouteResponse';
import { V1UnarchiveCreativeRequest } from '../models/V1UnarchiveCreativeRequest';
import { V1UnarchiveOrderLineRequest } from '../models/V1UnarchiveOrderLineRequest';
import { V1Upcharge } from '../models/V1Upcharge';
import { V1UpdateOrderLineRequest } from '../models/V1UpdateOrderLineRequest';
import { V1UpdateOrgRequest } from '../models/V1UpdateOrgRequest';
import { V1UploadAssetMetadata } from '../models/V1UploadAssetMetadata';
import { V1UploadAssetRequest } from '../models/V1UploadAssetRequest';
import { V1UploadCreativeFileRequest } from '../models/V1UploadCreativeFileRequest';
import { V1UploadExclusionAddressesRequest } from '../models/V1UploadExclusionAddressesRequest';
import { V1UploadOrderLineJobRequest } from '../models/V1UploadOrderLineJobRequest';
import { V1UploadOrgLogoMetadata } from '../models/V1UploadOrgLogoMetadata';
import { V1UploadTOSAgreementRequest } from '../models/V1UploadTOSAgreementRequest';
import { V1WebToHomeEvent } from '../models/V1WebToHomeEvent';
import { V1WebToHomeNoteType } from '../models/V1WebToHomeNoteType';
import { V1WeeklyFrequencyConfig } from '../models/V1WeeklyFrequencyConfig';
import { V2ArchiveTargetRequest } from '../models/V2ArchiveTargetRequest';
import { V2CreateJsonTargetRequest } from '../models/V2CreateJsonTargetRequest';
import { V2DownloadTargetFileResponse } from '../models/V2DownloadTargetFileResponse';
import { V2ListTargetFoldersResponse } from '../models/V2ListTargetFoldersResponse';
import { V2ListTargetsResponse } from '../models/V2ListTargetsResponse';
import { V2ReplaceFileMetaData } from '../models/V2ReplaceFileMetaData';
import { V2ReplaceTargetFileRequest } from '../models/V2ReplaceTargetFileRequest';
import { V2Target } from '../models/V2Target';
import { V2TargetJob } from '../models/V2TargetJob';
import { V2TargetStatus } from '../models/V2TargetStatus';
import { V2UnarchiveTargetRequest } from '../models/V2UnarchiveTargetRequest';
import { V2UploadTargetFileRequest } from '../models/V2UploadTargetFileRequest';
import { V3Advertiser } from '../models/V3Advertiser';
import { V3AuctionEvent } from '../models/V3AuctionEvent';
import { V3AugmentedLineItem } from '../models/V3AugmentedLineItem';
import { V3BrowserTarget } from '../models/V3BrowserTarget';
import { V3BudgetInterval } from '../models/V3BudgetInterval';
import { V3BudgetSchedulingSettings } from '../models/V3BudgetSchedulingSettings';
import { V3BuyerSeat } from '../models/V3BuyerSeat';
import { V3CampaignCreative } from '../models/V3CampaignCreative';
import { V3CampaignDeviceCaps } from '../models/V3CampaignDeviceCaps';
import { V3Condition } from '../models/V3Condition';
import { V3ConsoleCampaign } from '../models/V3ConsoleCampaign';
import { V3ContextualTargeting } from '../models/V3ContextualTargeting';
import { V3CountryTarget } from '../models/V3CountryTarget';
import { V3CreativeType } from '../models/V3CreativeType';
import { V3CurateCampaign } from '../models/V3CurateCampaign';
import { V3CustomDateRange } from '../models/V3CustomDateRange';
import { V3DaypartTarget } from '../models/V3DaypartTarget';
import { V3Deal } from '../models/V3Deal';
import { V3DealConfig } from '../models/V3DealConfig';
import { V3DealList } from '../models/V3DealList';
import { V3DealType } from '../models/V3DealType';
import { V3DeploySegmentsToCurateRequest } from '../models/V3DeploySegmentsToCurateRequest';
import { V3DeploymentDestinationConfigurations } from '../models/V3DeploymentDestinationConfigurations';
import { V3DirectMailCampaign } from '../models/V3DirectMailCampaign';
import { V3DirectMailConfiguration } from '../models/V3DirectMailConfiguration';
import { V3DomainListTarget } from '../models/V3DomainListTarget';
import { V3EngagementRateTarget } from '../models/V3EngagementRateTarget';
import { V3GenericDeployRequest } from '../models/V3GenericDeployRequest';
import { V3GovernmentLevel } from '../models/V3GovernmentLevel';
import { V3InventoryAttributeTarget } from '../models/V3InventoryAttributeTarget';
import { V3InventoryListTarget } from '../models/V3InventoryListTarget';
import { V3InvestCampaign } from '../models/V3InvestCampaign';
import { V3Language } from '../models/V3Language';
import { V3LanguageTarget } from '../models/V3LanguageTarget';
import { V3LegacyCampaign } from '../models/V3LegacyCampaign';
import { V3LineItem } from '../models/V3LineItem';
import { V3LineItemDeal } from '../models/V3LineItemDeal';
import { V3LineItemPixel } from '../models/V3LineItemPixel';
import { V3ListAdvertisersResponse } from '../models/V3ListAdvertisersResponse';
import { V3ListDeploymentsResponse } from '../models/V3ListDeploymentsResponse';
import { V3ListSegmentsResponse } from '../models/V3ListSegmentsResponse';
import { V3ListXandrDealListsResponse } from '../models/V3ListXandrDealListsResponse';
import { V3ListXandrDealsResponse } from '../models/V3ListXandrDealsResponse';
import { V3ListXandrLanguagesResponse } from '../models/V3ListXandrLanguagesResponse';
import { V3ListXandrRegionsResponse } from '../models/V3ListXandrRegionsResponse';
import { V3MemberDataSharing } from '../models/V3MemberDataSharing';
import { V3MemberDataSharingSegment } from '../models/V3MemberDataSharingSegment';
import { V3NonSeamlessInsertionOrder } from '../models/V3NonSeamlessInsertionOrder';
import { V3PacingStrategies } from '../models/V3PacingStrategies';
import { V3PoliticalContent } from '../models/V3PoliticalContent';
import { V3Position } from '../models/V3Position';
import { V3PositionTargets } from '../models/V3PositionTargets';
import { V3Profile } from '../models/V3Profile';
import { V3QueueRequest } from '../models/V3QueueRequest';
import { V3RTBCampaign } from '../models/V3RTBCampaign';
import { V3RTBConfiguration } from '../models/V3RTBConfiguration';
import { V3RTBCreativeMap } from '../models/V3RTBCreativeMap';
import { V3RTBCreativeMapping } from '../models/V3RTBCreativeMapping';
import { V3RTBOrderLine } from '../models/V3RTBOrderLine';
import { V3RTBOrderLineUpdateStatus } from '../models/V3RTBOrderLineUpdateStatus';
import { V3Region } from '../models/V3Region';
import { V3RegionTarget } from '../models/V3RegionTarget';
import { V3RegistrationForm } from '../models/V3RegistrationForm';
import { V3ResolveSegmentorIncidentResponse } from '../models/V3ResolveSegmentorIncidentResponse';
import { V3SGSegment } from '../models/V3SGSegment';
import { V3SeamlessInsertionOrder } from '../models/V3SeamlessInsertionOrder';
import { V3Segment } from '../models/V3Segment';
import { V3SegmentConfig } from '../models/V3SegmentConfig';
import { V3SegmentGroupTarget } from '../models/V3SegmentGroupTarget';
import { V3SegmentType } from '../models/V3SegmentType';
import { V3SegmentorDeploymentResults } from '../models/V3SegmentorDeploymentResults';
import { V3Split } from '../models/V3Split';
import { V3StackAdaptAd } from '../models/V3StackAdaptAd';
import { V3StackAdaptAudience } from '../models/V3StackAdaptAudience';
import { V3StackAdaptBidFactor } from '../models/V3StackAdaptBidFactor';
import { V3StackAdaptCampaign } from '../models/V3StackAdaptCampaign';
import { V3StackAdaptCampaignConfig } from '../models/V3StackAdaptCampaignConfig';
import { V3StackAdaptCampaignFlight } from '../models/V3StackAdaptCampaignFlight';
import { V3StackAdaptCampaignGoal } from '../models/V3StackAdaptCampaignGoal';
import { V3StackAdaptCampaignGroupConfig } from '../models/V3StackAdaptCampaignGroupConfig';
import { V3StackAdaptCampaignUpdateStatus } from '../models/V3StackAdaptCampaignUpdateStatus';
import { V3StackAdaptConfiguration } from '../models/V3StackAdaptConfiguration';
import { V3StackAdaptCreative } from '../models/V3StackAdaptCreative';
import { V3StackAdaptCreativeAdMapping } from '../models/V3StackAdaptCreativeAdMapping';
import { V3StackAdaptCreativeAdMappingStatus } from '../models/V3StackAdaptCreativeAdMappingStatus';
import { V3StackAdaptCreativeMap } from '../models/V3StackAdaptCreativeMap';
import { V3StackAdaptCreativeMapping } from '../models/V3StackAdaptCreativeMapping';
import { V3StackAdaptCreativeTactic } from '../models/V3StackAdaptCreativeTactic';
import { V3StackAdaptCreativeTag } from '../models/V3StackAdaptCreativeTag';
import { V3StackAdaptDayOption } from '../models/V3StackAdaptDayOption';
import { V3StackAdaptDayOptions } from '../models/V3StackAdaptDayOptions';
import { V3StackAdaptDayParting } from '../models/V3StackAdaptDayParting';
import { V3StackAdaptDeviceTypeRule } from '../models/V3StackAdaptDeviceTypeRule';
import { V3StackAdaptFlight } from '../models/V3StackAdaptFlight';
import { V3StackAdaptGeoTargeting } from '../models/V3StackAdaptGeoTargeting';
import { V3StackAdaptGlobalZipTargeting } from '../models/V3StackAdaptGlobalZipTargeting';
import { V3StackAdaptGoal } from '../models/V3StackAdaptGoal';
import { V3StackAdaptHourlyParting } from '../models/V3StackAdaptHourlyParting';
import { V3StackAdaptInventoryConfig } from '../models/V3StackAdaptInventoryConfig';
import { V3StackAdaptLibraryAd } from '../models/V3StackAdaptLibraryAd';
import { V3StackAdaptSegmentMap } from '../models/V3StackAdaptSegmentMap';
import { V3StackAdaptSegmentMapping } from '../models/V3StackAdaptSegmentMapping';
import { V3StackAdaptTacticAd } from '../models/V3StackAdaptTacticAd';
import { V3StackAdaptTacticCustomSegmentRule } from '../models/V3StackAdaptTacticCustomSegmentRule';
import { V3StackAdaptTacticDateRule } from '../models/V3StackAdaptTacticDateRule';
import { V3StackAdaptTacticDayTimeRule } from '../models/V3StackAdaptTacticDayTimeRule';
import { V3StackAdaptTacticLanguageRule } from '../models/V3StackAdaptTacticLanguageRule';
import { V3StackAdaptTacticWeekDayRule } from '../models/V3StackAdaptTacticWeekDayRule';
import { V3StackAdaptTimeSlot } from '../models/V3StackAdaptTimeSlot';
import { V3StackAdaptUserMetadata } from '../models/V3StackAdaptUserMetadata';
import { V3StackAdaptVastMedia } from '../models/V3StackAdaptVastMedia';
import { V3StackAdaptVastMediaData } from '../models/V3StackAdaptVastMediaData';
import { V3StackAdaptVastTracker } from '../models/V3StackAdaptVastTracker';
import { V3StackAdaptWeekdayParting } from '../models/V3StackAdaptWeekdayParting';
import { V3StartSegmentorIncidentRequest } from '../models/V3StartSegmentorIncidentRequest';
import { V3StartSegmentorIncidentResponse } from '../models/V3StartSegmentorIncidentResponse';
import { V3SupplyStrategies } from '../models/V3SupplyStrategies';
import { V3UserInfo } from '../models/V3UserInfo';
import { V3Valuation } from '../models/V3Valuation';
import { V3Values } from '../models/V3Values';
import { V3ViantAdelphicConfiguration } from '../models/V3ViantAdelphicConfiguration';
import { V3ViantCreativeConfig } from '../models/V3ViantCreativeConfig';
import { V3ViantSegmentConfig } from '../models/V3ViantSegmentConfig';
import { V3XandrConsoleConfiguration } from '../models/V3XandrConsoleConfiguration';
import { V3XandrCurateConfiguration } from '../models/V3XandrCurateConfiguration';
import { V3XandrInvestConfiguration } from '../models/V3XandrInvestConfiguration';

import { AdvertisingPlatformServiceApiRequestFactory, AdvertisingPlatformServiceApiResponseProcessor} from "../apis/AdvertisingPlatformServiceApi";
export class ObservableAdvertisingPlatformServiceApi {
    private requestFactory: AdvertisingPlatformServiceApiRequestFactory;
    private responseProcessor: AdvertisingPlatformServiceApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: AdvertisingPlatformServiceApiRequestFactory,
        responseProcessor?: AdvertisingPlatformServiceApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new AdvertisingPlatformServiceApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new AdvertisingPlatformServiceApiResponseProcessor();
    }

    /**
     * @param deal 
     */
    public advertisingPlatformServiceCreateXandrDeal(deal: V3Deal, _options?: Configuration): Observable<V3Deal> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateXandrDeal(deal, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateXandrDeal(rsp)));
            }));
    }

    /**
     * @param dealList 
     */
    public advertisingPlatformServiceCreateXandrDealList(dealList: V3DealList, _options?: Configuration): Observable<V3DealList> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateXandrDealList(dealList, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateXandrDealList(rsp)));
            }));
    }

    /**
     * @param id 
     */
    public advertisingPlatformServiceDeleteXandrDeal(id: number, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteXandrDeal(id, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteXandrDeal(rsp)));
            }));
    }

    /**
     * @param id 
     */
    public advertisingPlatformServiceDeleteXandrDealList(id: number, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteXandrDealList(id, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteXandrDealList(rsp)));
            }));
    }

    /**
     * @param id 
     */
    public advertisingPlatformServiceGetXandrDeal(id: number, _options?: Configuration): Observable<V3Deal> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetXandrDeal(id, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetXandrDeal(rsp)));
            }));
    }

    /**
     * @param id 
     */
    public advertisingPlatformServiceGetXandrLanguage(id: number, _options?: Configuration): Observable<V3Language> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetXandrLanguage(id, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetXandrLanguage(rsp)));
            }));
    }

    /**
     * @param id 
     */
    public advertisingPlatformServiceGetXandrRegion(id: number, _options?: Configuration): Observable<V3Region> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetXandrRegion(id, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetXandrRegion(rsp)));
            }));
    }

    /**
     * @param name View a deal list by name and deals it contain.
     * @param id View a specific deal list and deals it contain.
     * @param advertiserId View a deal list by advertiser id and deals it contain.
     * @param dealId View all deal lists containing a deal.
     * @param search Search a deal list by id or name as search term.
     * @param lineItemId View all deal lists targeted by a line item.
     */
    public advertisingPlatformServiceListXandrDealLists(name?: string, id?: number, advertiserId?: number, dealId?: number, search?: string, lineItemId?: number, _options?: Configuration): Observable<V3ListXandrDealListsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListXandrDealLists(name, id, advertiserId, dealId, search, lineItemId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListXandrDealLists(rsp)));
            }));
    }

    /**
     */
    public advertisingPlatformServiceListXandrDeals(_options?: Configuration): Observable<V3ListXandrDealsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListXandrDeals(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListXandrDeals(rsp)));
            }));
    }

    /**
     * @param search 
     * @param name 
     */
    public advertisingPlatformServiceListXandrLanguages(search?: string, name?: string, _options?: Configuration): Observable<V3ListXandrLanguagesResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListXandrLanguages(search, name, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListXandrLanguages(rsp)));
            }));
    }

    /**
     * @param name 
     * @param code 
     */
    public advertisingPlatformServiceListXandrRegions(name?: string, code?: string, _options?: Configuration): Observable<V3ListXandrRegionsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListXandrRegions(name, code, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListXandrRegions(rsp)));
            }));
    }

    /**
     * @param body 
     */
    public advertisingPlatformServiceRebuildGlobalSearch(body: V1RebuildGlobalSearchRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceRebuildGlobalSearch(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceRebuildGlobalSearch(rsp)));
            }));
    }

    /**
     * Resolve a segmentor incident and automatically redeploy affected segments
     * @param body 
     */
    public advertisingPlatformServiceResolveSegmentorIncident(body: any, _options?: Configuration): Observable<V3ResolveSegmentorIncidentResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceResolveSegmentorIncident(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceResolveSegmentorIncident(rsp)));
            }));
    }

    /**
     * Start a segmentor incident (triggered by monitoring alerts or manually)
     * @param body 
     */
    public advertisingPlatformServiceStartSegmentorIncident(body: V3StartSegmentorIncidentRequest, _options?: Configuration): Observable<V3StartSegmentorIncidentResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceStartSegmentorIncident(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceStartSegmentorIncident(rsp)));
            }));
    }

    /**
     * @param deal 
     */
    public advertisingPlatformServiceUpdateXandrDeal(deal: V3Deal, _options?: Configuration): Observable<V3Deal> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateXandrDeal(deal, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateXandrDeal(rsp)));
            }));
    }

    /**
     * @param dealList 
     */
    public advertisingPlatformServiceUpdateXandrDealList(dealList: V3DealList, _options?: Configuration): Observable<V3DealList> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateXandrDealList(dealList, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateXandrDealList(rsp)));
            }));
    }

}

import { AssetsApiRequestFactory, AssetsApiResponseProcessor} from "../apis/AssetsApi";
export class ObservableAssetsApi {
    private requestFactory: AssetsApiRequestFactory;
    private responseProcessor: AssetsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: AssetsApiRequestFactory,
        responseProcessor?: AssetsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new AssetsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new AssetsApiResponseProcessor();
    }

    /**
     * Permanently removes an asset from an org
     * Delete an Asset
     * @param assetId 
     * @param orgId 
     */
    public advertisingPlatformServiceDeleteAsset(assetId: string, orgId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteAsset(assetId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteAsset(rsp)));
            }));
    }

    /**
     * Get an Asset from an Asset ID
     * Get Asset
     * @param assetId The ID of the Asset to retrieve.
     * @param orgId The ID of the Organization.
     */
    public advertisingPlatformServiceGetAsset(assetId: string, orgId: string, _options?: Configuration): Observable<V1Asset> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetAsset(assetId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetAsset(rsp)));
            }));
    }

    /**
     * List Assets
     * @param pageSize The maximum number of assets to return. The service may return fewer than this value.  If unspecified, at most &#x60;100&#x60; assets will be returned.  The maximum value is &#x60;100&#x60;; values above &#x60;100&#x60; will be coerced to &#x60;100&#x60;.
     * @param pageToken A page token, received from a previous &#x60;ListAssets&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListAssets&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListAssets(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Observable<V1ListAssetsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListAssets(pageSize, pageToken, orderBy, filter, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListAssets(rsp)));
            }));
    }

    /**
     * Update Asset
     * @param assetId ID of the asset
     * @param asset 
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdateAsset(assetId: string, asset: AdvertisingPlatformServiceUpdateAssetRequest, updateMask?: string, orgId?: string, _options?: Configuration): Observable<V1Asset> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateAsset(assetId, asset, updateMask, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateAsset(rsp)));
            }));
    }

    /**
     * Streams a single image file
     * Upload Asset
     * @param body  (streaming inputs)
     */
    public advertisingPlatformServiceUploadAsset(body: V1UploadAssetRequest, _options?: Configuration): Observable<V1Asset> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUploadAsset(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUploadAsset(rsp)));
            }));
    }

}

import { AudienceAutomationsApiRequestFactory, AudienceAutomationsApiResponseProcessor} from "../apis/AudienceAutomationsApi";
export class ObservableAudienceAutomationsApi {
    private requestFactory: AudienceAutomationsApiRequestFactory;
    private responseProcessor: AudienceAutomationsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: AudienceAutomationsApiRequestFactory,
        responseProcessor?: AudienceAutomationsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new AudienceAutomationsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new AudienceAutomationsApiResponseProcessor();
    }

    /**
     * ### Description Creates an Automation as a subresource of a Job. An Automation holds information used to automate recurring actions related to the job.  ### Key Points - **Allowed Product Types:** Currently, only audiences with the product type `PRODUCT_TYPE_PROSPECTING` can have automations. - **Deletion:** Deletion of automations is not supported at this time. - **Disabling Automations:** If you want to stop an automation from running, set `enabled` to `false` using the `UpdateAudienceAutomation` endpoint. - **Requoting Audiences:** Automations that requote an audience will only run if the audience has been generated at least once. - **Prospecting Audiences:** Automations for prospecting audiences will not run instantly; they will be queued in the default queue because their child audiences need to be quoted first.
     * Create  Audience Automation
     * @param audienceId The Audience this automation belongs to.
     * @param orgId The Organization where this Audience belongs to.
     * @param automation The automation to create.
     */
    public advertisingPlatformServiceCreateAudienceAutomation(audienceId: string, orgId: string, automation: V1Automation, _options?: Configuration): Observable<V1Automation> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateAudienceAutomation(audienceId, orgId, automation, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateAudienceAutomation(rsp)));
            }));
    }

    /**
     * Update Audience Automation
     * @param audienceId The Audience to which this automation belongs.
     * @param automationId The Automation&#39;s ID.
     * @param orgId The Organization to which this Audience belongs.
     * @param automation The automation to update.
     * @param updateMask The list of fields to update.
     */
    public advertisingPlatformServiceUpdateAudienceAutomation(audienceId: string, automationId: string, orgId: string, automation: TheAutomationToUpdate, updateMask?: string, _options?: Configuration): Observable<V1Automation> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateAudienceAutomation(audienceId, automationId, orgId, automation, updateMask, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateAudienceAutomation(rsp)));
            }));
    }

}

import { AudiencesApiRequestFactory, AudiencesApiResponseProcessor} from "../apis/AudiencesApi";
export class ObservableAudiencesApi {
    private requestFactory: AudiencesApiRequestFactory;
    private responseProcessor: AudiencesApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: AudiencesApiRequestFactory,
        responseProcessor?: AudiencesApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new AudiencesApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new AudiencesApiResponseProcessor();
    }

    /**
     * Cancel Audience Generation
     * @param body 
     */
    public advertisingPlatformServiceCancelAudienceGeneration(body: V1CancelAudienceGenerationRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCancelAudienceGeneration(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCancelAudienceGeneration(rsp)));
            }));
    }

    /**
     * Clone Audience
     * @param body 
     */
    public advertisingPlatformServiceCloneAudience(body: V1CloneAudienceRequest, _options?: Configuration): Observable<Targetjobservicev1Audience> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCloneAudience(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCloneAudience(rsp)));
            }));
    }

    /**
     * ### Description: This endpoint defines the audience that will be processed on your target. The time it takes to move to the next phase can vary based on audience generation complexity and other factors. It is recommended that the client calls the **GET audiences** endpoint to check if the audience is ready to move to the next phase, such as generating. This process may involve monitoring the status for several minutes, depending on the processing time of the audience job.  ### Expected Response: - **Status Code**: 200 or 202 - **Response Body**: Includes the JSON key `'status': 'AUDIENCE_STATUS_CREATING'`, indicating that the audience job is being created.  ### Unexpected Responses and scenarios: #### 500 (Internal Server Error): - **Action**: Wait briefly and retry once. - **Exponential Backoff**: If the issue persists after the retry, use an exponential backoff strategy (e.g., retry after 1s, 2s, 4s, and 8s). - **Escalation**: If still unresolved, submit a support ticket to ElToro, including the request CURL and file.  #### 503 (Service Unavailable): - **Action**: Retry up to 4 times using exponential backoff with increasing delay (e.g., retry after 1s, 2s, 4s, and 8s). - **Escalation**: If unresolved, submit a support ticket to ElToro with the request CURL and file.  #### 400 (Bad Request): - **Action**: Do not retry. Troubleshoot the request to resolve the issue before submitting again.  #### AUDIENCE_STATUS_ERRORED: - **Action**: Troubleshoot the request or file for issues. - **Escalation**: If the issue is not resolved, submit a support ticket with the audience ID and org ID.  #### AUDIENCE_STATUS_CREATING remains for more than 5 minutes: - **Action**: If the audience remains in this status without further progress for over 5 minutes, submit a support ticket to ElToro with the audience and org ID.  **Recommended polling strategy**: Use exponential backoff with increasing delay: - **Initial Delay**: Start with a 5-second delay between requests. - **Subsequent Delays**: Increase the delay progressively, e.g., 10s, 20s, 40s, up to 60s. - **Reset on Update**: After receiving an update, reset the delay to the initial 5-second interval for further polling.  ### Expected Status Progression: - **AUDIENCE_STATUS_CREATING**: Audience is in the creation phase. - **AUDIENCE_STATUS_CREATED**: The audience has been successfully created and is ready to move to the next phase (e.g., generating).  
     * Create Audience
     * @param orgId The Organization where this audience will be created.
     * @param audience The audience to create.
     */
    public advertisingPlatformServiceCreateAudience(orgId: string, audience: Targetjobservicev1Audience, _options?: Configuration): Observable<Targetjobservicev1Audience> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateAudience(orgId, audience, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateAudience(rsp)));
            }));
    }

    /**
     * Create Audience Note
     * @param audienceId The Audience this note belongs to.
     * @param orgId The Organization where this Audience belongs to.
     * @param note The note to create.
     */
    public advertisingPlatformServiceCreateAudienceNote(audienceId: string, orgId: string, note: Targetjobservicev1Note, _options?: Configuration): Observable<Targetjobservicev1Note> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateAudienceNote(audienceId, orgId, note, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateAudienceNote(rsp)));
            }));
    }

    /**
     * Delete Audience
     * @param audienceId The ID of the audience to delete.
     * @param orgId The Organization where this Audience belongs to.
     */
    public advertisingPlatformServiceDeleteAudience(audienceId: string, orgId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteAudience(audienceId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteAudience(rsp)));
            }));
    }

    /**
     * Delete Audience Note
     * @param audienceId The Audience this note belongs to.
     * @param noteId The id of the note to delete.
     * @param orgId The Organization where this Audience belongs to.
     */
    public advertisingPlatformServiceDeleteAudienceNote(audienceId: string, noteId: string, orgId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteAudienceNote(audienceId, noteId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteAudienceNote(rsp)));
            }));
    }

    /**
     * Download Audience File
     * @param audienceId The ID of the audience.
     * @param audienceFileType File type to download.   - AUDIENCE_FILE_TYPE_UNKNOWN: Unknown File Type.  - AUDIENCE_FILE_TYPE_ANNOTATED: File of the original source file data with a boolean that specifies whether the row was matched or not.  - AUDIENCE_FILE_TYPE_SELECTED: File of the ip addresses and ethashs.  - AUDIENCE_FILE_TYPE_VALIDATED: File of the validated addresses.  - AUDIENCE_FILE_TYPE_RESULTS: File of the results of digital canvas.  - AUDIENCE_FILE_TYPE_DIRECT_MAIL: File of direct mail addresses.  - AUDIENCE_FILE_TYPE_HOMES: File of the addresses of devices found in venue replay.  - AUDIENCE_FILE_TYPE_DEVICES_IN_HOMES_NOT_SEEN: File of the devices found in homes but not found with venue replay.  - AUDIENCE_FILE_TYPE_DEVICES_WITH_HOMES: File of the devices with homes found in venue replay.  - AUDIENCE_FILE_TYPE_DEVICES_WITHOUT_HOMES: File of the devices without homes found in venue replay.  - AUDIENCE_FILE_TYPE_MAIDS: File of MAIDS addresses.  - AUDIENCE_FILE_TYPE_ENRICHED: File of Enriched addresses.
     * @param orgId The ID of the target&#39;s org
     */
    public advertisingPlatformServiceDownloadAudienceFile(audienceId?: string, audienceFileType?: 'AUDIENCE_FILE_TYPE_UNKNOWN' | 'AUDIENCE_FILE_TYPE_ANNOTATED' | 'AUDIENCE_FILE_TYPE_SELECTED' | 'AUDIENCE_FILE_TYPE_VALIDATED' | 'AUDIENCE_FILE_TYPE_RESULTS' | 'AUDIENCE_FILE_TYPE_DIRECT_MAIL' | 'AUDIENCE_FILE_TYPE_HOMES' | 'AUDIENCE_FILE_TYPE_DEVICES_IN_HOMES_NOT_SEEN' | 'AUDIENCE_FILE_TYPE_DEVICES_WITH_HOMES' | 'AUDIENCE_FILE_TYPE_DEVICES_WITHOUT_HOMES' | 'AUDIENCE_FILE_TYPE_MAIDS' | 'AUDIENCE_FILE_TYPE_ENRICHED', orgId?: string, _options?: Configuration): Observable<StreamResultOfV1DownloadAudienceFileResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDownloadAudienceFile(audienceId, audienceFileType, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDownloadAudienceFile(rsp)));
            }));
    }

    /**
     * ### Description: The `generate` endpoint initiates the job to process the specified audience. The time required for this stage can vary significantly, depending on factors such as the job type and the size of the target file. Once the job is triggered, it is essential to monitor its progress using the `GET audiences` endpoint.  ---  ### Expected Response: - **Status Code**: 200 or 202 - **Response Body**: Includes the JSON key `'status': 'AUDIENCE_STATUS_QUEUED'`, indicating that the audience has been successfully added to the processing queue.  ---  ### Unexpected Responses: #### 500 (Internal Server Error): - **Action**: Perform a short wait and retry once. - **Escalation**: If the issue persists, submit a support ticket to ElToro, including the request CURL and associated file.  #### 503 (Service Unavailable): - **Action**: Retry the request up to 4 times using exponential backoff (e.g., wait 1s, 2s, 4s, 8s between retries). - **Escalation**: If unresolved, submit a ticket to ElToro with the request CURL and file.  #### Other Status Codes (e.g., 400): - **Action**: Do not retry. Investigate and troubleshoot the request before attempting again.  #### AUDIENCE_STATUS_ERRORED: - **Action**: Submit a support ticket with the audience ID and org ID for investigation.  #### Status remains `AUDIENCE_STATUS_RUNNING` or `AUDIENCE_STATUS_QUEUED` for more than 60 minutes: - **Action**: Submit a ticket to ElToro with the audience ID and org ID.  ---  ### Recommended Polling Strategy: - **Initial Delay**: Begin polling with an initial delay of 5 seconds. - **Subsequent Delays**: Gradually increase the delay up to a maximum of 60 seconds between retries. - **Reset Backoff**: Reset the backoff once a response indicates a status transition.  ---  ### Expected Status Progression: - **AUDIENCE_STATUS_QUEUED**: Indicates the job is in the queue, awaiting execution. - **AUDIENCE_STATUS_RUNNING**: Confirms the job is actively being processed. - **AUDIENCE_STATUS_COMPLETED**: The audience generation job is finished, and results can be downloaded. - **AUDIENCE_STATUS_READY**: The audience is finalized and can be added to an order line. 
     * Generate Audience
     * @param audienceId The ID of the Audience.
     * @param orgId The ID of the Org associated to the Audience.
     * @param version (OPTIONAL) The version of the target file to use. If empty, the most recent version is used.
     * @param queryId (OPTIONAL) Additional field you might need in order to run a job. The only one that uses this currently is the enrichment job.
     * @param seenCount (OPTIONAL) Additional field you might need in order to run a job. The only one that uses this currently is the enrichment job.
     * @param locType (OPTIONAL) Additional field you might need in order to run a job. The only one that uses this currently is the enrichment job.
     * @param radius (OPTIONAL) Additional field you might need in order to run a job. The only one that could use this currently is the digital canvassing job.
     * @param queryType (OPTIONAL) Additional field you might need in order to run a job. The only one that could use this currently is the digital canvassing job.
     * @param queryArgs (OPTIONAL) Additional field you might need in order to run a job.
     */
    public advertisingPlatformServiceGenerateAudience(audienceId?: string, orgId?: string, version?: number, queryId?: string, seenCount?: number, locType?: string, radius?: number, queryType?: string, queryArgs?: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGenerateAudience(audienceId, orgId, version, queryId, seenCount, locType, radius, queryType, queryArgs, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGenerateAudience(rsp)));
            }));
    }

    /**
     * #### Description: Endpoint used to get the Audience Resource.  ---  ### Unexpected Scenarios: #### 500 (Internal Server Error): - **Action**: Perform a short wait and retry once. - **Escalation**: If unresolved, submit a ticket to ElToro with the request details.  #### 503 (Service Unavailable): - **Action**: Retry up to 4 times using exponential backoff. - **Escalation**: If unresolved, submit a ticket with the request details.  ---  ### Exponential Backoff Example: - **Initial Delay**: 5 seconds - **Subsequent Delays**: 10s, 20s, 40s (up to a maximum of 60s). - **Reset Backoff**: After a successful response or status update, return to the initial delay for future polling.  Using exponential backoff helps balance timely updates with system efficiency, reducing unnecessary load on both client and server resources. This strategy ensures a balance between not overloading the server with excessive polling and allowing enough time for the system to recover from temporary issues. 
     * Get Audience
     * @param audienceId The ID of the audience to retrieve.
     * @param orgId The Organization where this Audience belongs to.
     */
    public advertisingPlatformServiceGetAudience(audienceId: string, orgId: string, _options?: Configuration): Observable<Targetjobservicev1Audience> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetAudience(audienceId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetAudience(rsp)));
            }));
    }

    /**
     * Get Queue Health
     */
    public advertisingPlatformServiceGetQueueHealth(_options?: Configuration): Observable<V1QueueHealth> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetQueueHealth(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetQueueHealth(rsp)));
            }));
    }

    /**
     * List Audience Folders
     * @param pageSize The maximum number of resources to return. The service may return fewer than this value. If unspecified, at most 16 resources will be returned. The maximum value is 100; values above 100 will be coerced to 100.
     * @param pageToken A page token, received from a previous &#x60;ListCreatives&#x60; request. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListCreatives&#x60; must match the request that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListAudienceFolders(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Observable<V1ListAudienceFoldersResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListAudienceFolders(pageSize, pageToken, orderBy, filter, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListAudienceFolders(rsp)));
            }));
    }

    /**
     * List Audiences
     * @param pageSize The maximum number of audiences to return. The service may return fewer than this value.  If unspecified, at most &#x60;1000&#x60; audiences will be returned.  The maximum value is &#x60;1000&#x60;; values above &#x60;1000&#x60; will be coerced to &#x60;1000&#x60;.
     * @param pageToken A page token, received from a previous &#x60;ListAudiences&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListAudiences&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     * @param descendantOfOrgId If specified, only return audiences of the specified org_id and its descendants.
     */
    public advertisingPlatformServiceListAudiences(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, descendantOfOrgId?: string, _options?: Configuration): Observable<V1ListAudiencesResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListAudiences(pageSize, pageToken, orderBy, filter, descendantOfOrgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListAudiences(rsp)));
            }));
    }

    /**
     * List Audiences attached to order lines wih refresh enabled true
     * @param pageSize The maximum number of audiences to return. The service may return fewer than this value.  If unspecified, at most &#x60;1000&#x60; audiences will be returned.  The maximum value is &#x60;1000&#x60;; values above &#x60;1000&#x60; will be coerced to &#x60;1000&#x60;.
     * @param pageToken A page token, received from a previous &#x60;ListAudiences&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListAudiences&#x60; must match the call that provided the page token.
     */
    public advertisingPlatformServiceListOrderlineAttachedRefreshAudiences(pageSize?: number, pageToken?: string, _options?: Configuration): Observable<V1ListAudiencesResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListOrderlineAttachedRefreshAudiences(pageSize, pageToken, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListOrderlineAttachedRefreshAudiences(rsp)));
            }));
    }

    /**
     * Update Audience
     * @param audienceId The Audience ID.
     * @param orgId The Organization where this Audience belongs to.
     * @param audience The audience to update.
     * @param updateMask The list of fields to update.
     */
    public advertisingPlatformServiceUpdateAudience(audienceId: string, orgId: string, audience: TheAudienceToUpdate, updateMask?: string, _options?: Configuration): Observable<Targetjobservicev1Audience> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateAudience(audienceId, orgId, audience, updateMask, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateAudience(rsp)));
            }));
    }

    /**
     * Update Audience Note
     * @param audienceId The Audience this note belongs to.
     * @param noteId The Note ID.
     * @param orgId The Organization where this Audience belongs to.
     * @param note The note to update.
     * @param updateMask The list of fields to update.
     */
    public advertisingPlatformServiceUpdateAudienceNote(audienceId: string, noteId: string, orgId: string, note: TheNoteToUpdate, updateMask?: string, _options?: Configuration): Observable<Targetjobservicev1Note> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateAudienceNote(audienceId, noteId, orgId, note, updateMask, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateAudienceNote(rsp)));
            }));
    }

}

import { AuditApiRequestFactory, AuditApiResponseProcessor} from "../apis/AuditApi";
export class ObservableAuditApi {
    private requestFactory: AuditApiRequestFactory;
    private responseProcessor: AuditApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: AuditApiRequestFactory,
        responseProcessor?: AuditApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new AuditApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new AuditApiResponseProcessor();
    }

    /**
     * Audits objects deployed out to DSPs
     * Audit
     * @param body 
     */
    public advertisingPlatformServiceAudit(body: any, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceAudit(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceAudit(rsp)));
            }));
    }

}

import { AuthenticationApiRequestFactory, AuthenticationApiResponseProcessor} from "../apis/AuthenticationApi";
export class ObservableAuthenticationApi {
    private requestFactory: AuthenticationApiRequestFactory;
    private responseProcessor: AuthenticationApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: AuthenticationApiRequestFactory,
        responseProcessor?: AuthenticationApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new AuthenticationApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new AuthenticationApiResponseProcessor();
    }

    /**
     * OAuth 2.0
     * @param body 
     */
    public advertisingPlatformServiceOAuthToken(body: V1OAuthTokenRequest, _options?: Configuration): Observable<V1JWT> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceOAuthToken(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceOAuthToken(rsp)));
            }));
    }

}

import { BillingApiRequestFactory, BillingApiResponseProcessor} from "../apis/BillingApi";
export class ObservableBillingApi {
    private requestFactory: BillingApiRequestFactory;
    private responseProcessor: BillingApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: BillingApiRequestFactory,
        responseProcessor?: BillingApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new BillingApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new BillingApiResponseProcessor();
    }

    /**
     * Add  a note to orgs that have no valid associated credit cards
     */
    public advertisingPlatformServiceAddNoteToOrgsWithoutValidCCs(_options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceAddNoteToOrgsWithoutValidCCs(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceAddNoteToOrgsWithoutValidCCs(rsp)));
            }));
    }

    /**
     * Create a credit card
     * @param creditCardOrgId ID of the Org the credit card belongs to
     * @param body 
     */
    public advertisingPlatformServiceCreateCreditCard(creditCardOrgId: string, body: CreateCreditCardRequest, _options?: Configuration): Observable<V1CreditCard> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateCreditCard(creditCardOrgId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateCreditCard(rsp)));
            }));
    }

    /**
     * Create Invoice
     * @param orgId 
     * @param adminInvoice 
     */
    public advertisingPlatformServiceCreateInvoice(orgId: string, adminInvoice: V1AdminInvoice, _options?: Configuration): Observable<V1AdminInvoice> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateInvoice(orgId, adminInvoice, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateInvoice(rsp)));
            }));
    }

    /**
     * Delete a credit card
     * @param orgId ID of the Org the credit card belongs to
     * @param creditCardId ID of the credit to be deleted
     */
    public advertisingPlatformServiceDeleteCreditCard(orgId: string, creditCardId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteCreditCard(orgId, creditCardId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteCreditCard(rsp)));
            }));
    }

    /**
     * Delete an invoice by id
     * @param id 
     */
    public advertisingPlatformServiceDeleteInvoice(id: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteInvoice(id, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteInvoice(rsp)));
            }));
    }

    /**
     * Get accounting job
     * @param jobId ID of the Job
     */
    public advertisingPlatformServiceGetAccountingJob(jobId: string, _options?: Configuration): Observable<V1AccountingJob> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetAccountingJob(jobId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetAccountingJob(rsp)));
            }));
    }

    /**
     * Get the balance of an org
     * @param orgId ID of the Org to get the balance for
     */
    public advertisingPlatformServiceGetBalance(orgId: string, _options?: Configuration): Observable<V1Balance> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetBalance(orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetBalance(rsp)));
            }));
    }

    /**
     * Get billing information for an org
     * @param orgId 
     * @param includeInvoices include_invoices
     * @param includeBalance include_balance
     * @param invoiceStatus invoice_status  Filter based on the invoices statuses.
     */
    public advertisingPlatformServiceGetBillingOrg(orgId: string, includeInvoices?: boolean, includeBalance?: boolean, invoiceStatus?: 'INVOICE_STATUS_UNKNOWN' | 'INVOICE_STATUS_PAID' | 'INVOICE_STATUS_PROCESSING' | 'INVOICE_STATUS_DECLINED' | 'INVOICE_STATUS_PAYMENT_DUE' | 'INVOICE_STATUS_PARTIALLY_PAID' | 'INVOICE_STATUS_PAST_DUE', _options?: Configuration): Observable<Billingservicev1Org> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetBillingOrg(orgId, includeInvoices, includeBalance, invoiceStatus, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetBillingOrg(rsp)));
            }));
    }

    /**
     * Get information around a commission group
     * Get information around a commission group
     * @param recordNo Commission group
     */
    public advertisingPlatformServiceGetCommissionGroup(recordNo: string, _options?: Configuration): Observable<Billingservicev1CommissionGroup> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetCommissionGroup(recordNo, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetCommissionGroup(rsp)));
            }));
    }

    /**
     * Get credit card information
     * @param orgId ID of the Org that the credit card is associated with
     * @param creditCardId ID of the credit card
     */
    public advertisingPlatformServiceGetCreditCard(orgId: string, creditCardId: string, _options?: Configuration): Observable<V1CreditCard> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetCreditCard(orgId, creditCardId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetCreditCard(rsp)));
            }));
    }

    /**
     * Get invoice on an org
     * Get a specific invoice from an org
     * @param orgId Id of the org that owns the invoices
     * @param recordNo Number (id) of the invoice
     */
    public advertisingPlatformServiceGetInvoice(orgId: string, recordNo: string, _options?: Configuration): Observable<Billingservicev1Invoice> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetInvoice(orgId, recordNo, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetInvoice(rsp)));
            }));
    }

    /**
     * List accounting jobs
     * @param pageSize The maximum number of jobs to return. The service may return fewer than this value.  If unspecified, at most &#x60;1000&#x60; jobs will be returned.  The maximum value is &#x60;1000&#x60;; values above &#x60;1000&#x60; will be coerced to &#x60;1000&#x60;.
     * @param pageToken A page token, received from a previous &#x60;ListAccountingJobs&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListAccountingJobs&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListAccountingJobs(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Observable<V1ListAccountingJobsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListAccountingJobs(pageSize, pageToken, orderBy, filter, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListAccountingJobs(rsp)));
            }));
    }

    /**
     * List commission groups
     * List commission groups
     */
    public advertisingPlatformServiceListCommissionGroups(_options?: Configuration): Observable<V1ListCommissionGroupsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListCommissionGroups(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListCommissionGroups(rsp)));
            }));
    }

    /**
     * List credit cards
     * @param orgId The org associated with the listed credit cards
     * @param pageSize How many credit cards to return in the response
     * @param pageToken page_token  A token received by prior list calls, used to send on subsequent list requests to retrieve next page of credit cards
     * @param orderBy How to order the credit cards returning
     * @param filter Filter
     */
    public advertisingPlatformServiceListCreditCards(orgId: string, pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Observable<V1ListCreditCardsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListCreditCards(orgId, pageSize, pageToken, orderBy, filter, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListCreditCards(rsp)));
            }));
    }

    /**
     * List all invoices on an org
     * Get all invoices from an org
     * @param orgId Id of the org that owns the invoices
     * @param status status  Filter based on the invoices statuses.
     */
    public advertisingPlatformServiceListInvoices(orgId: string, status?: 'INVOICE_STATUS_UNKNOWN' | 'INVOICE_STATUS_PAID' | 'INVOICE_STATUS_PROCESSING' | 'INVOICE_STATUS_DECLINED' | 'INVOICE_STATUS_PAYMENT_DUE' | 'INVOICE_STATUS_PARTIALLY_PAID' | 'INVOICE_STATUS_PAST_DUE', _options?: Configuration): Observable<Billingservicev1ListInvoicesResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListInvoices(orgId, status, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListInvoices(rsp)));
            }));
    }

    /**
     * List all invoices on an org
     * @param orgId Id of the org that owns the invoices
     * @param pageSize How many invoices to return in the response
     * @param pageToken page_token  A token received by prior list calls, used to send on subsequent list requests to retrieve next page of credit cards
     * @param orderBy How to order the invoices returning
     * @param filter Filter
     */
    public advertisingPlatformServiceListInvoicesV2(orgId: string, pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Observable<Billingservicev2ListInvoicesResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListInvoicesV2(orgId, pageSize, pageToken, orderBy, filter, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListInvoicesV2(rsp)));
            }));
    }

    /**
     * Pay an invoice for an org
     * Pay a specific invoice for an org
     * @param orgId Id of the org that owns the invoices
     * @param id ID of the invoice
     * @param body 
     */
    public advertisingPlatformServicePayInvoice(orgId: string, id: string, body: PayInvoiceRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServicePayInvoice(orgId, id, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServicePayInvoice(rsp)));
            }));
    }

    /**
     * Pay the setup fee of an org
     * @param orgId ID of the Org to pay the set-up fee for
     * @param body 
     */
    public advertisingPlatformServicePaySetupFee(orgId: string, body: PaySetUpFeeRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServicePaySetupFee(orgId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServicePaySetupFee(rsp)));
            }));
    }

    /**
     * Prepay an org
     * @param orgId ID of the Org to prepay
     * @param body 
     */
    public advertisingPlatformServicePrepay(orgId: string, body: PrepayRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServicePrepay(orgId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServicePrepay(rsp)));
            }));
    }

    /**
     * Remove Orgs Billing Hold
     */
    public advertisingPlatformServiceRemoveOrgsBillingHold(_options?: Configuration): Observable<V1CronResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceRemoveOrgsBillingHold(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceRemoveOrgsBillingHold(rsp)));
            }));
    }

    /**
     * Run commissions
     * Run commissions for all orgs
     * @param body 
     */
    public advertisingPlatformServiceRunCommissions(body: V1RunCommissionsRequest, _options?: Configuration): Observable<V1RunCommissionsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceRunCommissions(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceRunCommissions(rsp)));
            }));
    }

    /**
     * Run invoicing
     * Run invoicing for all orgs
     * @param body 
     */
    public advertisingPlatformServiceRunInvoicing(body: V1RunInvoicingRequest, _options?: Configuration): Observable<V1RunInvoicingResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceRunInvoicing(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceRunInvoicing(rsp)));
            }));
    }

    /**
     * Send out expired credit card emails
     */
    public advertisingPlatformServiceSendExpiredCreditCardEmails(_options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceSendExpiredCreditCardEmails(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceSendExpiredCreditCardEmails(rsp)));
            }));
    }

    /**
     * Send emails to all clients with overdue invoices
     */
    public advertisingPlatformServiceSendOverdueInvoiceEmails(_options?: Configuration): Observable<V1CronResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceSendOverdueInvoiceEmails(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceSendOverdueInvoiceEmails(rsp)));
            }));
    }

    /**
     * Sync billing service credit cards with AuthNet
     */
    public advertisingPlatformServiceSyncOrgCCsWithAuthnet(_options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceSyncOrgCCsWithAuthnet(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceSyncOrgCCsWithAuthnet(rsp)));
            }));
    }

    /**
     * Syncs sage invoices to db
     */
    public advertisingPlatformServiceSyncSageInvoicesToDB(_options?: Configuration): Observable<V1CronResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceSyncSageInvoicesToDB(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceSyncSageInvoicesToDB(rsp)));
            }));
    }

    /**
     * Update a credit card's info
     * @param creditCardOrgId ID of the Org the credit card belongs to
     * @param creditCardId ID of the credit card
     * @param creditCard Credit Card  Information needed to process a credit card
     * @param updateMask 
     */
    public advertisingPlatformServiceUpdateCreditCard(creditCardOrgId: string, creditCardId: string, creditCard: CreditCard1, updateMask?: string, _options?: Configuration): Observable<V1CreditCard> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateCreditCard(creditCardOrgId, creditCardId, creditCard, updateMask, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateCreditCard(rsp)));
            }));
    }

    /**
     * Web To Home Billing
     */
    public advertisingPlatformServiceWebToHomeBilling(_options?: Configuration): Observable<V1CronResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceWebToHomeBilling(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceWebToHomeBilling(rsp)));
            }));
    }

}

import { CallbacksApiRequestFactory, CallbacksApiResponseProcessor} from "../apis/CallbacksApi";
export class ObservableCallbacksApi {
    private requestFactory: CallbacksApiRequestFactory;
    private responseProcessor: CallbacksApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: CallbacksApiRequestFactory,
        responseProcessor?: CallbacksApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new CallbacksApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new CallbacksApiResponseProcessor();
    }

    /**
     * Callback to a url
     * Callback to a service
     * @param jwt JWT  The JWT Token holding the info necessary to callback to service required
     * @param orgId 
     * @param requestId Request_ID  Id of the request
     */
    public advertisingPlatformServiceCallback(jwt?: string, orgId?: string, requestId?: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCallback(jwt, orgId, requestId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCallback(rsp)));
            }));
    }

}

import { CampaignsApiRequestFactory, CampaignsApiResponseProcessor} from "../apis/CampaignsApi";
export class ObservableCampaignsApi {
    private requestFactory: CampaignsApiRequestFactory;
    private responseProcessor: CampaignsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: CampaignsApiRequestFactory,
        responseProcessor?: CampaignsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new CampaignsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new CampaignsApiResponseProcessor();
    }

    /**
     * Add Audience
     * @param orderLineId The ID of the Order Line
     * @param body 
     */
    public advertisingPlatformServiceAddAudience(orderLineId: string, body: AddAudienceRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceAddAudience(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceAddAudience(rsp)));
            }));
    }

    /**
     * Add Creative
     * @param orderLineId The ID of the Order Line
     * @param body 
     */
    public advertisingPlatformServiceAddCreative(orderLineId: string, body: AddCreativeRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceAddCreative(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceAddCreative(rsp)));
            }));
    }

    /**
     * @param orderLineId 
     * @param body 
     */
    public advertisingPlatformServiceAppendOrderLineNote(orderLineId: string, body: AdvertisingPlatformServiceAppendOrderLineNoteRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceAppendOrderLineNote(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceAppendOrderLineNote(rsp)));
            }));
    }

    /**
     * Approves an order line
     * @param orderLineId ID of the Order Line.
     * @param body 
     */
    public advertisingPlatformServiceApproveOrderLine(orderLineId: string, body: ApproveOrderLineRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceApproveOrderLine(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceApproveOrderLine(rsp)));
            }));
    }

    /**
     * Archive Campaign
     * @param body 
     */
    public advertisingPlatformServiceArchiveCampaign(body: V1ArchiveCampaignRequest, _options?: Configuration): Observable<Campaignservicev1Campaign> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceArchiveCampaign(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceArchiveCampaign(rsp)));
            }));
    }

    /**
     * @param body 
     */
    public advertisingPlatformServiceArchiveOrderLine(body: V1ArchiveOrderLineRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceArchiveOrderLine(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceArchiveOrderLine(rsp)));
            }));
    }

    /**
     * Batch Add Audiences
     * @param orderLineId 
     * @param body 
     */
    public advertisingPlatformServiceBatchAddAudiences(orderLineId: string, body: AdvertisingPlatformServiceBatchAddAudiencesRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceBatchAddAudiences(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceBatchAddAudiences(rsp)));
            }));
    }

    /**
     * Batch Add Creatives
     * @param orderLineId 
     * @param body 
     */
    public advertisingPlatformServiceBatchAddCreatives(orderLineId: string, body: AdvertisingPlatformServiceBatchAddCreativesRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceBatchAddCreatives(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceBatchAddCreatives(rsp)));
            }));
    }

    /**
     * Batch Remove Audiences
     * @param orderLineId 
     * @param body 
     */
    public advertisingPlatformServiceBatchRemoveAudiences(orderLineId: string, body: AdvertisingPlatformServiceBatchRemoveAudiencesRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceBatchRemoveAudiences(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceBatchRemoveAudiences(rsp)));
            }));
    }

    /**
     * Batch Remove Creatives
     * @param orderLineId 
     * @param body 
     */
    public advertisingPlatformServiceBatchRemoveCreatives(orderLineId: string, body: AdvertisingPlatformServiceBatchRemoveCreativesRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceBatchRemoveCreatives(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceBatchRemoveCreatives(rsp)));
            }));
    }

    /**
     * Batch Update OrderLines
     * @param body 
     */
    public advertisingPlatformServiceBatchUpdateOrderLines(body: V1BatchUpdateOrderLinesRequest, _options?: Configuration): Observable<V1BatchUpdateOrderLinesResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceBatchUpdateOrderLines(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceBatchUpdateOrderLines(rsp)));
            }));
    }

    /**
     * Cancel OrderLine Deployment
     * @param orderLineId ID of the Order Line.
     * @param body 
     */
    public advertisingPlatformServiceCancelOrderLineDeployment(orderLineId: string, body: CancelOrderLineDeploymentRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCancelOrderLineDeployment(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCancelOrderLineDeployment(rsp)));
            }));
    }

    /**
     * Clone OrderLine
     * @param orderLineId ID of the Order Line to clone.
     * @param body 
     */
    public advertisingPlatformServiceCloneOrderLine(orderLineId: string, body: AdvertisingPlatformServiceCloneOrderLineRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCloneOrderLine(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCloneOrderLine(rsp)));
            }));
    }

    /**
     * Create a new Camapign
     * Create Campaign
     * @param orgId The Organization where this Campaign will be created.
     * @param campaign The campaign to create.
     */
    public advertisingPlatformServiceCreateCampaign(orgId: string, campaign: Campaignservicev1Campaign, _options?: Configuration): Observable<Campaignservicev1Campaign> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateCampaign(orgId, campaign, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateCampaign(rsp)));
            }));
    }

    /**
     * Create one or more destination deployment configurations (DDCs) for an order line. When distribution exists, this configures destinations only; allocation values are managed by SetDistribution.
     * Create Deployment Configuration
     * @param orderLineId The ID of the Order Line being configured.
     * @param body 
     */
    public advertisingPlatformServiceCreateDeployment(orderLineId: string, body: CreateDeploymentRequest, _options?: Configuration): Observable<V3DeploymentDestinationConfigurations> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateDeployment(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateDeployment(rsp)));
            }));
    }

    /**
     * Create a new OrderLine
     * Create OrderLine
     * @param orgId The organization where this order line will be created.
     * @param orderLine The order line to create.
     * @param campaignId The campaign that the OrderLine will be auto attached to.
     */
    public advertisingPlatformServiceCreateOrderLine(orgId: string, orderLine: Campaignservicev1OrderLine, campaignId?: string, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateOrderLine(orgId, orderLine, campaignId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateOrderLine(rsp)));
            }));
    }

    /**
     * @param orderLineId 
     * @param body 
     */
    public advertisingPlatformServiceDeactivateOrderLineNote(orderLineId: string, body: AdvertisingPlatformServiceDeactivateOrderLineNoteRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeactivateOrderLineNote(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeactivateOrderLineNote(rsp)));
            }));
    }

    /**
     * Deletes a Campaign
     * Delete Campaign
     * @param campaignId ID of the Campaign
     * @param orgId The Organization where this Campaign belongs to.
     */
    public advertisingPlatformServiceDeleteCampaign(campaignId: string, orgId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteCampaign(campaignId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteCampaign(rsp)));
            }));
    }

    /**
     * Delete OrderLine
     * @param orderLineId The ID of the order line to delete.
     * @param orgId The Organization where this creative belongs to.
     */
    public advertisingPlatformServiceDeleteOrderLine(orderLineId: string, orgId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteOrderLine(orderLineId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteOrderLine(rsp)));
            }));
    }

    /**
     * Deploy OrderLine to xandr invest
     * @param orderLineId ID of the Order Line.
     * @param body 
     */
    public advertisingPlatformServiceDeployOrderLine(orderLineId: string, body: DeployOrderLineRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeployOrderLine(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeployOrderLine(rsp)));
            }));
    }

    /**
     * Get a Campaign by ID
     * Get Campaign
     * @param campaignId The ID of the campaign to retrieve.
     * @param orgId The Organization where this Campaign belongs to.
     */
    public advertisingPlatformServiceGetCampaign(campaignId: string, orgId: string, _options?: Configuration): Observable<Campaignservicev1Campaign> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetCampaign(campaignId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetCampaign(rsp)));
            }));
    }

    /**
     * Get an OrderLine by ID
     * Get OrderLine
     * @param orderLineId The ID of the Order Line to retrieve.
     * @param orgId The ID of Organization that this Order Line belongs to.
     */
    public advertisingPlatformServiceGetOrderLine(orderLineId: string, orgId: string, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetOrderLine(orderLineId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetOrderLine(rsp)));
            }));
    }

    /**
     * Get OrderLine Job
     * @param jobId The ID of the batch upsert job.
     * @param orgId The ID of Organization that this Job belongs to.
     */
    public advertisingPlatformServiceGetOrderLineJob(jobId: string, orgId?: string, _options?: Configuration): Observable<V1OrderLineJob> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetOrderLineJob(jobId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetOrderLineJob(rsp)));
            }));
    }

    /**
     * Get OrderLine Job
     * @param jobId The ID of the batch upsert job.
     * @param orgId The ID of Organization that this Job belongs to.
     */
    public advertisingPlatformServiceGetOrderLineJob2(jobId: string, orgId?: string, _options?: Configuration): Observable<V1OrderLineJob> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetOrderLineJob2(jobId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetOrderLineJob2(rsp)));
            }));
    }

    /**
     * Get OrderLine Destination Configuration Default Template
     * @param orderLineId ID of the Order Line.
     * @param body 
     */
    public advertisingPlatformServiceGetTemplate(orderLineId: string, body: GetDefaultTemplateRequest, _options?: Configuration): Observable<V1GetTemplateResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetTemplate(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetTemplate(rsp)));
            }));
    }

    /**
     * Get a Campaign History by ID
     * List CampaignEvents
     * @param campaignId ID of Campaign.
     * @param orgId ID of Org
     * @param pageSize The maximum number of resources to return. The service may return fewer than this value. If unspecified, at most 16 resources will be returned. The maximum value is 100; values above 100 will be coerced to 100.
     * @param pageToken A page token, received from a previous &#x60;ListCampaignEvents&#x60; request. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListCampaignEvents&#x60; must match the request that provided the page token.
     */
    public advertisingPlatformServiceListCampaignEvents(campaignId: string, orgId: string, pageSize?: number, pageToken?: string, _options?: Configuration): Observable<V1ListCampaignEventsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListCampaignEvents(campaignId, orgId, pageSize, pageToken, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListCampaignEvents(rsp)));
            }));
    }

    /**
     * List Campaigns
     * List Campaigns
     * @param pageSize The maximum number of campaigns to return. The service may return fewer than this value.  If unspecified, at most &#x60;1000&#x60; campaigns will be returned.  The maximum value is &#x60;1000&#x60;; values above &#x60;1000&#x60; will be coerced to &#x60;1000&#x60;.
     * @param pageToken A page token, received from a previous &#x60;ListCampaigns&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListCampaigns&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     * @param descendantOfOrgId If specified, only return campaigns of the specified org_id and its descendants.
     */
    public advertisingPlatformServiceListCampaigns(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, descendantOfOrgId?: string, _options?: Configuration): Observable<Campaignservicev1ListCampaignsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListCampaigns(pageSize, pageToken, orderBy, filter, descendantOfOrgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListCampaigns(rsp)));
            }));
    }

    /**
     * Get a list of changes that have been made to an order line
     * List OrderLineEvents
     * @param orderLineId ID of OrderLine.
     * @param orgId ID of Org
     * @param pageSize The maximum number of resources to return. The service may return fewer than this value. If unspecified, at most 16 resources will be returned. The maximum value is 100; values above 100 will be coerced to 100.
     * @param pageToken A page token, received from a previous &#x60;ListOrderLineEvents&#x60; request. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListOrderLineEvents&#x60; must match the request that provided the page token.
     */
    public advertisingPlatformServiceListOrderLineEvents(orderLineId: string, orgId: string, pageSize?: number, pageToken?: string, _options?: Configuration): Observable<V1ListOrderLineEventsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListOrderLineEvents(orderLineId, orgId, pageSize, pageToken, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListOrderLineEvents(rsp)));
            }));
    }

    /**
     * List OrderLine Jobs
     * @param template  - JOB_TEMPLATE_UNSPECIFIED: [id, name, org_id, campaign_id, impressions, impressions_per_day, ref_id, click_through_url, start_time, end_time, creative_ids, audience_ids] creative_ids and audience_ids use pipe delimeter  - JOB_TEMPLATE_AA_STANDARD: [org_id, start_time, end_time, pacing_strategy, campaign_impressions, click_through_url, creative_ids, seen_count, loc_type, dealer_zipcode, radius, dms_audience_id, control_audience_id]  - JOB_TEMPLATE_ADMIN_PORTAL_CREATE: [org_id, campaign_id, campaign_name, order_line_name, order_line_start_time, order_line_end_time, creative_ids, audience_ids, click_through_url, impressions, minimum_impressions, cpm]  - JOB_TEMPLATE_ADMIN_PORTAL_UPDATE: [org_id, campaign_id, campaign_name, order_line_id, order_line_name, order_line_start_time, order_line_end_time, creative_ids, audience_ids, click_through_url, impressions, minimum_impressions, cpm]
     */
    public advertisingPlatformServiceListOrderLineJobs(template?: 'JOB_TEMPLATE_UNSPECIFIED' | 'JOB_TEMPLATE_AA_STANDARD' | 'JOB_TEMPLATE_ADMIN_PORTAL_CREATE' | 'JOB_TEMPLATE_ADMIN_PORTAL_UPDATE', _options?: Configuration): Observable<V1ListOrderLineJobsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListOrderLineJobs(template, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListOrderLineJobs(rsp)));
            }));
    }

    /**
     * Get a paginated list of all OrderLines
     * List OrderLines
     * @param pageSize The maximum number of order lines to return. The service may return fewer than this value.  If unspecified, at most &#x60;1000&#x60; order lines will be returned.  The maximum value is &#x60;1000&#x60;; values above &#x60;1000&#x60; will be coerced to &#x60;1000&#x60;.
     * @param pageToken A page token, received from a previous &#x60;ListOrderLines&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListOrderLines&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     * @param descendantOfOrgId If specified, only return order lines of the specified org_id and its descendants.
     */
    public advertisingPlatformServiceListOrderLines(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, descendantOfOrgId?: string, _options?: Configuration): Observable<V1ListOrderLinesResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListOrderLines(pageSize, pageToken, orderBy, filter, descendantOfOrgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListOrderLines(rsp)));
            }));
    }

    /**
     * Lock an order line
     * @param orderLineId The ID of the Order Line to lock
     * @param body 
     */
    public advertisingPlatformServiceLockOrderLine(orderLineId: string, body: LockOrderLineRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceLockOrderLine(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceLockOrderLine(rsp)));
            }));
    }

    /**
     * Pause an OrderLine
     * @param orderLineId The ID of the Order Line.
     * @param body 
     */
    public advertisingPlatformServicePauseOrderLine(orderLineId: string, body: PauseOrderLineRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServicePauseOrderLine(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServicePauseOrderLine(rsp)));
            }));
    }

    /**
     * Pay Order Lines
     * Pay Order Lines
     * @param body 
     */
    public advertisingPlatformServicePayOrderLines(body: V1PayOrderLinesRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServicePayOrderLines(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServicePayOrderLines(rsp)));
            }));
    }

    /**
     * Play an OrderLine
     * @param orderLineId id of the order line
     * @param body 
     */
    public advertisingPlatformServicePlayOrderLine(orderLineId: string, body: PlayOrderLineRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServicePlayOrderLine(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServicePlayOrderLine(rsp)));
            }));
    }

    /**
     * Rejects an order line
     * @param orderLineId ID of the Order Line.
     * @param body 
     */
    public advertisingPlatformServiceRejectOrderLine(orderLineId: string, body: RejectOrderLineRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceRejectOrderLine(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceRejectOrderLine(rsp)));
            }));
    }

    /**
     * Remove Audience
     * @param orderLineId The ID of the Order Line
     * @param body 
     */
    public advertisingPlatformServiceRemoveAudience(orderLineId: string, body: RemoveAudienceRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceRemoveAudience(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceRemoveAudience(rsp)));
            }));
    }

    /**
     * Remove Creative
     * @param orderLineId The ID of the Order Line
     * @param body 
     */
    public advertisingPlatformServiceRemoveCreative(orderLineId: string, body: RemoveCreativeRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceRemoveCreative(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceRemoveCreative(rsp)));
            }));
    }

    /**
     * Request Review
     * @param orderLineId The OrderLine resource to submit for review.
     * @param body 
     */
    public advertisingPlatformServiceRequestReview(orderLineId: string, body: RequestReviewRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceRequestReview(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceRequestReview(rsp)));
            }));
    }

    /**
     * @param body  (streaming inputs)
     */
    public advertisingPlatformServiceSetCampaignPoliticalForm(body: V1SetCampaignPoliticalFormRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceSetCampaignPoliticalForm(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceSetCampaignPoliticalForm(rsp)));
            }));
    }

    /**
     * Create or update the order line impression allocation across destinations. If the order line is currently DEPLOYED, PAUSED, or SERVING, this operation auto-triggers a redeploy so allocation-driven budget changes are applied.
     * Set Distribution
     * @param orderLineId ID of the Order Line.
     * @param body 
     */
    public advertisingPlatformServiceSetDistribution(orderLineId: string, body: SetDistributionRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceSetDistribution(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceSetDistribution(rsp)));
            }));
    }

    /**
     */
    public advertisingPlatformServiceStartArchivingOrderLines(_options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceStartArchivingOrderLines(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceStartArchivingOrderLines(rsp)));
            }));
    }

    /**
     */
    public advertisingPlatformServiceStartOrderLineStatusChecker(_options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceStartOrderLineStatusChecker(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceStartOrderLineStatusChecker(rsp)));
            }));
    }

    /**
     * Starts review on an order line
     * @param orderLineId ID of the Order Line.
     * @param body 
     */
    public advertisingPlatformServiceStartReview(orderLineId: string, body: StartReviewRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceStartReview(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceStartReview(rsp)));
            }));
    }

    /**
     * @param body 
     */
    public advertisingPlatformServiceUnarchiveOrderLine(body: V1UnarchiveOrderLineRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUnarchiveOrderLine(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUnarchiveOrderLine(rsp)));
            }));
    }

    /**
     * Unlock an order line
     * @param orderLineId The ID of the Order Line to unlock
     * @param body 
     */
    public advertisingPlatformServiceUnlockOrderLine(orderLineId: string, body: UnlockOrderLineRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUnlockOrderLine(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUnlockOrderLine(rsp)));
            }));
    }

    /**
     * Update Campaign
     * Update Campaign
     * @param campaignId ID of Campaign.
     * @param orgId The Organization where this Campaign belongs to.
     * @param campaign The campaign to update.
     * @param updateMask List of fields to be updated
     */
    public advertisingPlatformServiceUpdateCampaign(campaignId: string, orgId: string, campaign: TheCampaignToUpdate, updateMask?: string, _options?: Configuration): Observable<Campaignservicev1Campaign> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateCampaign(campaignId, orgId, campaign, updateMask, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateCampaign(rsp)));
            }));
    }

    /**
     * Update destination deployment configurations (DDCs). If distribution is active, budget/impression updates for allocated destinations are blocked and destination removal for allocated destinations is blocked.
     * Update Deployment Configuration
     * @param orderLineId The ID of the Order Line being set.
     * @param body 
     */
    public advertisingPlatformServiceUpdateDeployment(orderLineId: string, body: UpdateDeploymentRequest, _options?: Configuration): Observable<V3DeploymentDestinationConfigurations> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateDeployment(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateDeployment(rsp)));
            }));
    }

    /**
     * Update OrderLine
     * @param orderLineId ID of the Order Line.
     * @param orgId The Organization where this Order Line belongs to.
     * @param orderLine The order line to update.
     * @param updateMask Field Mask  The list of fields to update.
     */
    public advertisingPlatformServiceUpdateOrderLine(orderLineId: string, orgId: string, orderLine: TheOrderLineToUpdate, updateMask?: string, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateOrderLine(orderLineId, orgId, orderLine, updateMask, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateOrderLine(rsp)));
            }));
    }

    /**
     * Update the CPMs of an Order Line
     * Update  Order Line CPMs
     * @param orderLineId ID of the order line
     * @param body 
     */
    public advertisingPlatformServiceUpdateOrderLineCPMs(orderLineId: string, body: UpdateCPMsRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateOrderLineCPMs(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateOrderLineCPMs(rsp)));
            }));
    }

    /**
     * @param orderLineId 
     * @param body 
     */
    public advertisingPlatformServiceUpdateOrderLineNote(orderLineId: string, body: AdvertisingPlatformServiceUpdateOrderLineNoteRequest, _options?: Configuration): Observable<Campaignservicev1OrderLine> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateOrderLineNote(orderLineId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateOrderLineNote(rsp)));
            }));
    }

    /**
     * Upload OrderLine Job
     * @param body  (streaming inputs)
     */
    public advertisingPlatformServiceUploadOrderLineJob(body: V1UploadOrderLineJobRequest, _options?: Configuration): Observable<V1OrderLineJob> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUploadOrderLineJob(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUploadOrderLineJob(rsp)));
            }));
    }

    /**
     * Upload OrderLine Job
     * @param body  (streaming inputs)
     */
    public advertisingPlatformServiceUploadOrderLineJob2(body: V1UploadOrderLineJobRequest, _options?: Configuration): Observable<V1OrderLineJob> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUploadOrderLineJob2(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUploadOrderLineJob2(rsp)));
            }));
    }

}

import { CreativesApiRequestFactory, CreativesApiResponseProcessor} from "../apis/CreativesApi";
export class ObservableCreativesApi {
    private requestFactory: CreativesApiRequestFactory;
    private responseProcessor: CreativesApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: CreativesApiRequestFactory,
        responseProcessor?: CreativesApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new CreativesApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new CreativesApiResponseProcessor();
    }

    /**
     * ArchiveCreative
     * @param body 
     */
    public advertisingPlatformServiceArchiveCreative(body: V1ArchiveCreativeRequest, _options?: Configuration): Observable<Creativeservicev1Creative> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceArchiveCreative(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceArchiveCreative(rsp)));
            }));
    }

    /**
     * Create Creative
     * @param orgId The Organization where this Creative will be created.
     * @param creative The creative to create.
     */
    public advertisingPlatformServiceCreateCreative(orgId: string, creative: Creativeservicev1Creative, _options?: Configuration): Observable<Creativeservicev1Creative> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateCreative(orgId, creative, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateCreative(rsp)));
            }));
    }

    /**
     * Delete Creative
     * @param creativeId The ID of the creative to delete.
     * @param orgId The Organization where this Creative belongs to.
     */
    public advertisingPlatformServiceDeleteCreative(creativeId: string, orgId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteCreative(creativeId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteCreative(rsp)));
            }));
    }

    /**
     * DownloadCreativeFile
     * @param orgId ID of the org that the creative belongs to
     * @param creativeId The ID of the Creative.
     * @param fileId The ID of the Creative File.
     */
    public advertisingPlatformServiceDownloadCreativeFile(orgId: string, creativeId?: string, fileId?: string, _options?: Configuration): Observable<StreamResultOfV1DownloadCreativeFileResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDownloadCreativeFile(orgId, creativeId, fileId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDownloadCreativeFile(rsp)));
            }));
    }

    /**
     * Get Creative
     * @param creativeId The ID of the creative to retrieve.
     * @param orgId The Organization where this Creative belongs to.
     */
    public advertisingPlatformServiceGetCreative(creativeId: string, orgId: string, _options?: Configuration): Observable<Creativeservicev1Creative> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetCreative(creativeId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetCreative(rsp)));
            }));
    }

    /**
     * List Creative Folders
     * @param pageSize The maximum number of resources to return. The service may return fewer than this value. If unspecified, at most 16 resources will be returned. The maximum value is 100; values above 100 will be coerced to 100.
     * @param pageToken A page token, received from a previous &#x60;ListCreativeFolders&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListCreativeFolders&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListCreativeFolders(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Observable<V1ListCreativeFoldersResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListCreativeFolders(pageSize, pageToken, orderBy, filter, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListCreativeFolders(rsp)));
            }));
    }

    /**
     * List Creatives
     * @param pageSize The maximum number of creatives to return. The service may return fewer than this value.  If unspecified, at most &#x60;1000&#x60; creatives will be returned.  The maximum value is &#x60;1000&#x60;; values above &#x60;1000&#x60; will be coerced to &#x60;1000&#x60;.
     * @param pageToken A page token, received from a previous &#x60;ListCreatives&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListCreatives&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     * @param descendantOfOrgId If specified, only return creatives of the specified org_id and its descendants.
     */
    public advertisingPlatformServiceListCreatives(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, descendantOfOrgId?: string, _options?: Configuration): Observable<Creativeservicev1ListCreativesResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListCreatives(pageSize, pageToken, orderBy, filter, descendantOfOrgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListCreatives(rsp)));
            }));
    }

    /**
     * Start Archiving Creative
     */
    public advertisingPlatformServiceStartArchivingCreative(_options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceStartArchivingCreative(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceStartArchivingCreative(rsp)));
            }));
    }

    /**
     * Unarchive Creative
     * @param body 
     */
    public advertisingPlatformServiceUnarchiveCreative(body: V1UnarchiveCreativeRequest, _options?: Configuration): Observable<Creativeservicev1Creative> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUnarchiveCreative(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUnarchiveCreative(rsp)));
            }));
    }

    /**
     * Update Creative
     * @param creativeId ID of the Creative
     * @param orgId The Organization where this Creative belongs to.
     * @param creative The creative to update.
     * @param updateMask The list of fields to update.
     */
    public advertisingPlatformServiceUpdateCreative(creativeId: string, orgId: string, creative: TheCreativeToUpdate, updateMask?: string, _options?: Configuration): Observable<Creativeservicev1Creative> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateCreative(creativeId, orgId, creative, updateMask, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateCreative(rsp)));
            }));
    }

    /**
     * Upload Creative File
     * @param body  (streaming inputs)
     */
    public advertisingPlatformServiceUploadCreativeFile(body: V1UploadCreativeFileRequest, _options?: Configuration): Observable<V1CreativeFile> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUploadCreativeFile(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUploadCreativeFile(rsp)));
            }));
    }

}

import { DeployApiRequestFactory, DeployApiResponseProcessor} from "../apis/DeployApi";
export class ObservableDeployApi {
    private requestFactory: DeployApiRequestFactory;
    private responseProcessor: DeployApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: DeployApiRequestFactory,
        responseProcessor?: DeployApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new DeployApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new DeployApiResponseProcessor();
    }

    /**
     * Create a advertiser in deploy
     * Create an Advertiser
     * @param advertiser the advertiser to create.
     */
    public advertisingPlatformServiceCreateDeployServiceAdvertiser(advertiser: V3Advertiser, _options?: Configuration): Observable<V3Advertiser> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateDeployServiceAdvertiser(advertiser, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateDeployServiceAdvertiser(rsp)));
            }));
    }

    /**
     * Create a campaign in deploy
     * Create an Campaign
     * @param campaign the campaign to create.
     */
    public advertisingPlatformServiceCreateDeployServiceCampaign(campaign: Deployservicev3Campaign, _options?: Configuration): Observable<Deployservicev3Campaign> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateDeployServiceCampaign(campaign, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateDeployServiceCampaign(rsp)));
            }));
    }

    /**
     * Create a creative in deploy
     * Create a Creative in deploy
     * @param creative the creative to create.
     */
    public advertisingPlatformServiceCreateDeployServiceCreative(creative: Deployservicev3Creative, _options?: Configuration): Observable<Deployservicev3Creative> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateDeployServiceCreative(creative, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateDeployServiceCreative(rsp)));
            }));
    }

    /**
     * Create a deployment in deploy
     * Create an Deployment
     * @param deployment the segment to create.
     */
    public advertisingPlatformServiceCreateDeployServiceDeployment(deployment: Deployservicev3Deployment, _options?: Configuration): Observable<Deployservicev3Deployment> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateDeployServiceDeployment(deployment, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateDeployServiceDeployment(rsp)));
            }));
    }

    /**
     * Create a segment in deploy
     * Create an Segment
     * @param segment the segment to create.
     */
    public advertisingPlatformServiceCreateDeployServiceSegment(segment: V3Segment, _options?: Configuration): Observable<V3Segment> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateDeployServiceSegment(segment, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateDeployServiceSegment(rsp)));
            }));
    }

    /**
     * Delete a advertiser in deploy
     * Delete a Advertiser
     * @param advertiserId The ID of the Advertiser
     */
    public advertisingPlatformServiceDeleteDeployServiceAdvertiser(advertiserId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteDeployServiceAdvertiser(advertiserId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteDeployServiceAdvertiser(rsp)));
            }));
    }

    /**
     * Delete a campaign in deploy
     * Delete a Campaign
     * @param campaignId The ID of the Campaign
     */
    public advertisingPlatformServiceDeleteDeployServiceCampaign(campaignId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteDeployServiceCampaign(campaignId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteDeployServiceCampaign(rsp)));
            }));
    }

    /**
     * Delete a creative in deploy
     * Delete a Creative
     * @param creativeId The ID of the Creative
     */
    public advertisingPlatformServiceDeleteDeployServiceCreative(creativeId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteDeployServiceCreative(creativeId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteDeployServiceCreative(rsp)));
            }));
    }

    /**
     * Delete a deployment in deploy
     * Delete a Deployment
     * @param deploymentId The ID of the Deployment
     */
    public advertisingPlatformServiceDeleteDeployServiceDeployment(deploymentId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteDeployServiceDeployment(deploymentId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteDeployServiceDeployment(rsp)));
            }));
    }

    /**
     * Delete a segment in deploy
     * Delete a Segment
     * @param segmentId The ID of the Segment
     */
    public advertisingPlatformServiceDeleteDeployServiceSegment(segmentId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteDeployServiceSegment(segmentId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteDeployServiceSegment(rsp)));
            }));
    }

    /**
     * Hits the generic deploy
     * @param body 
     */
    public advertisingPlatformServiceDeploy(body: V3GenericDeployRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeploy(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeploy(rsp)));
            }));
    }

    /**
     * Deploy segment(s) to xandr curate
     * Create deployment configs for and deploy segment(s) to xandr curate
     * @param body 
     */
    public advertisingPlatformServiceDeploySegmentsToCurate(body: V3DeploySegmentsToCurateRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeploySegmentsToCurate(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeploySegmentsToCurate(rsp)));
            }));
    }

    /**
     * Get advertisers
     * Get a Advertiser
     * @param advertiserId The ID of the Advertiser
     */
    public advertisingPlatformServiceGetDeployServiceAdvertiser(advertiserId: string, _options?: Configuration): Observable<V3Advertiser> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetDeployServiceAdvertiser(advertiserId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetDeployServiceAdvertiser(rsp)));
            }));
    }

    /**
     * Get campaigns
     * Get a Campaign
     * @param campaignId The ID of the Campaign
     */
    public advertisingPlatformServiceGetDeployServiceCampaign(campaignId: string, _options?: Configuration): Observable<Deployservicev3Campaign> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetDeployServiceCampaign(campaignId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetDeployServiceCampaign(rsp)));
            }));
    }

    /**
     * Get creatives
     * Get a Creative
     * @param creativeId The ID of the Creative
     */
    public advertisingPlatformServiceGetDeployServiceCreative(creativeId: string, _options?: Configuration): Observable<Deployservicev3Creative> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetDeployServiceCreative(creativeId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetDeployServiceCreative(rsp)));
            }));
    }

    /**
     * Get deployments
     * Get a Deployment
     * @param deploymentId The ID of the Deployment
     */
    public advertisingPlatformServiceGetDeployServiceDeployment(deploymentId: string, _options?: Configuration): Observable<Deployservicev3Deployment> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetDeployServiceDeployment(deploymentId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetDeployServiceDeployment(rsp)));
            }));
    }

    /**
     * Get segments
     * Get a Segment
     * @param segmentId The ID of the Segment
     */
    public advertisingPlatformServiceGetDeployServiceSegment(segmentId: string, _options?: Configuration): Observable<V3Segment> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetDeployServiceSegment(segmentId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetDeployServiceSegment(rsp)));
            }));
    }

    /**
     * List all advertisers
     * List Advertisers
     * @param pageSize The maximum number of resources to return. The service may return fewer than this value. If unspecified, at most 50 resources will be returned. The maximum value is 1000; values above 1000 will be coerced to 1000.
     * @param pageToken A page token, received from a previous &#x60;ListAdvertisersRequest&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListAdvertisersRequest&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering. Only one column sorting is supported as of now.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListDeployServiceAdvertisers(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Observable<V3ListAdvertisersResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListDeployServiceAdvertisers(pageSize, pageToken, orderBy, filter, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListDeployServiceAdvertisers(rsp)));
            }));
    }

    /**
     * List all campaigns
     * List Campaigns
     * @param pageSize The maximum number of resources to return. The service may return fewer than this value. If unspecified, at most 50 resources will be returned. The maximum value is 1000; values above 1000 will be coerced to 1000.
     * @param pageToken A page token, received from a previous &#x60;ListCampaignsRequest&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListCampaignsRequest&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering. Only one column sorting is supported as of now.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListDeployServiceCampaigns(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Observable<Deployservicev3ListCampaignsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListDeployServiceCampaigns(pageSize, pageToken, orderBy, filter, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListDeployServiceCampaigns(rsp)));
            }));
    }

    /**
     * List all creatives
     * List Creatives
     * @param pageSize The maximum number of resources to return. The service may return fewer than this value. If unspecified, at most 50 resources will be returned. The maximum value is 1000; values above 1000 will be coerced to 1000.
     * @param pageToken A page token, received from a previous &#x60;ListCreativesRequest&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListCreativesRequest&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering. Only one column sorting is supported as of now.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListDeployServiceCreatives(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Observable<Deployservicev3ListCreativesResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListDeployServiceCreatives(pageSize, pageToken, orderBy, filter, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListDeployServiceCreatives(rsp)));
            }));
    }

    /**
     * List all deployments
     * List Deployments
     * @param pageSize The maximum number of resources to return. The service may return fewer than this value. If unspecified, at most 50 resources will be returned. The maximum value is 1000; values above 1000 will be coerced to 1000.
     * @param pageToken A page token, received from a previous &#x60;ListDeploymentsRequest&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListDeploymentsRequest&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering. Only one column sorting is supported as of now.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListDeployServiceDeployments(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Observable<V3ListDeploymentsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListDeployServiceDeployments(pageSize, pageToken, orderBy, filter, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListDeployServiceDeployments(rsp)));
            }));
    }

    /**
     * List all segments
     * List Segments
     * @param pageSize The maximum number of resources to return. The service may return fewer than this value. If unspecified, at most 50 resources will be returned. The maximum value is 1000; values above 1000 will be coerced to 1000.
     * @param pageToken A page token, received from a previous &#x60;ListSegmentsRequest&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListSegmentsRequest&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering. Only one column sorting is supported as of now.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListDeployServiceSegments(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Observable<V3ListSegmentsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListDeployServiceSegments(pageSize, pageToken, orderBy, filter, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListDeployServiceSegments(rsp)));
            }));
    }

    /**
     * Deploy objects to their destinations
     * Queue a request to deploy deploy objects to destinations
     * @param body 
     */
    public advertisingPlatformServiceQueueDeployServiceRequest(body: V3QueueRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceQueueDeployServiceRequest(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceQueueDeployServiceRequest(rsp)));
            }));
    }

    /**
     * Update an advertiser in deploy
     * Update a Advertiser
     * @param advertiserId The ID of the advertiser.
     * @param advertiser the advertiser to create.
     * @param updateMask update_mask  The list of fields to update
     */
    public advertisingPlatformServiceUpdateDeployServiceAdvertiser(advertiserId: string, advertiser: TheAdvertiserToCreate, updateMask?: string, _options?: Configuration): Observable<V3Advertiser> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateDeployServiceAdvertiser(advertiserId, advertiser, updateMask, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateDeployServiceAdvertiser(rsp)));
            }));
    }

    /**
     * Update a Campaign in deploy
     * Update a Campaign
     * @param campaignId The ID of the campaign.
     * @param campaign the campaign to create.
     * @param updateMask update_mask  The list of fields to update
     */
    public advertisingPlatformServiceUpdateDeployServiceCampaign(campaignId: string, campaign: TheCampaignToCreate, updateMask?: string, _options?: Configuration): Observable<Deployservicev3Campaign> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateDeployServiceCampaign(campaignId, campaign, updateMask, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateDeployServiceCampaign(rsp)));
            }));
    }

    /**
     * Update a creative in deploy
     * Update a Creative
     * @param creativeId The ID of the creative object in the deploy service.
     * @param creative the creative to create.
     * @param updateMask update_mask  The list of fields to update
     */
    public advertisingPlatformServiceUpdateDeployServiceCreative(creativeId: string, creative: TheCreativeToCreate, updateMask?: string, _options?: Configuration): Observable<Deployservicev3Creative> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateDeployServiceCreative(creativeId, creative, updateMask, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateDeployServiceCreative(rsp)));
            }));
    }

    /**
     * Update a deployment in deploy
     * Update a Deployment
     * @param deploymentId The ID for the deployment
     * @param deployment the deployment to create.
     * @param updateMask update_mask  The list of fields to update
     */
    public advertisingPlatformServiceUpdateDeployServiceDeployment(deploymentId: string, deployment: TheDeploymentToCreate, updateMask?: string, _options?: Configuration): Observable<Deployservicev3Deployment> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateDeployServiceDeployment(deploymentId, deployment, updateMask, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateDeployServiceDeployment(rsp)));
            }));
    }

    /**
     * Update a segment in deploy
     * Update a Segment
     * @param segmentId The ID of the segment.
     * @param segment the segment to create.
     * @param updateMask update_mask  The list of fields to update
     */
    public advertisingPlatformServiceUpdateDeployServiceSegment(segmentId: string, segment: TheSegmentToCreate, updateMask?: string, _options?: Configuration): Observable<V3Segment> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateDeployServiceSegment(segmentId, segment, updateMask, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateDeployServiceSegment(rsp)));
            }));
    }

}

import { ExportDataFromThePlatformToColdStorageApiRequestFactory, ExportDataFromThePlatformToColdStorageApiResponseProcessor} from "../apis/ExportDataFromThePlatformToColdStorageApi";
export class ObservableExportDataFromThePlatformToColdStorageApi {
    private requestFactory: ExportDataFromThePlatformToColdStorageApiRequestFactory;
    private responseProcessor: ExportDataFromThePlatformToColdStorageApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ExportDataFromThePlatformToColdStorageApiRequestFactory,
        responseProcessor?: ExportDataFromThePlatformToColdStorageApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ExportDataFromThePlatformToColdStorageApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ExportDataFromThePlatformToColdStorageApiResponseProcessor();
    }

    /**
     * @param body 
     */
    public advertisingPlatformServiceExportData(body: any, _options?: Configuration): Observable<V1ExportDataResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceExportData(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceExportData(rsp)));
            }));
    }

}

import { GlobalSearchApiRequestFactory, GlobalSearchApiResponseProcessor} from "../apis/GlobalSearchApi";
export class ObservableGlobalSearchApi {
    private requestFactory: GlobalSearchApiRequestFactory;
    private responseProcessor: GlobalSearchApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: GlobalSearchApiRequestFactory,
        responseProcessor?: GlobalSearchApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new GlobalSearchApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new GlobalSearchApiResponseProcessor();
    }

    /**
     * Case insensitive and diacritic text searches. Matches on the complete stemmed word. So if a document field contains the word blueberry, a search on the term blue will not match. However, blueberry or blueberries will match.
     * GlobalSearch
     * @param orgIds List of Org IDs to Search
     * @param keywords List of keywords to search for. Only supports one at the moment.
     */
    public advertisingPlatformServiceGlobalSearch(orgIds?: Array<string>, keywords?: Array<string>, _options?: Configuration): Observable<V1GlobalSearchResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGlobalSearch(orgIds, keywords, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGlobalSearch(rsp)));
            }));
    }

}

import { HealthCheckApiRequestFactory, HealthCheckApiResponseProcessor} from "../apis/HealthCheckApi";
export class ObservableHealthCheckApi {
    private requestFactory: HealthCheckApiRequestFactory;
    private responseProcessor: HealthCheckApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: HealthCheckApiRequestFactory,
        responseProcessor?: HealthCheckApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new HealthCheckApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new HealthCheckApiResponseProcessor();
    }

    /**
     */
    public advertisingPlatformServiceGetAPQSHealthCheck(_options?: Configuration): Observable<Apqsv1HealthCheck> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetAPQSHealthCheck(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetAPQSHealthCheck(rsp)));
            }));
    }

    /**
     */
    public advertisingPlatformServiceGetAudienceHealthCheck(_options?: Configuration): Observable<Targetjobservicev1HealthCheck> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetAudienceHealthCheck(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetAudienceHealthCheck(rsp)));
            }));
    }

    /**
     */
    public advertisingPlatformServiceGetBillingHealthCheck(_options?: Configuration): Observable<Billingservicev1HealthCheck> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetBillingHealthCheck(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetBillingHealthCheck(rsp)));
            }));
    }

    /**
     */
    public advertisingPlatformServiceGetCampaignHealthCheck(_options?: Configuration): Observable<Campaignservicev1HealthCheck> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetCampaignHealthCheck(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetCampaignHealthCheck(rsp)));
            }));
    }

    /**
     */
    public advertisingPlatformServiceGetCreativeHealthCheck(_options?: Configuration): Observable<Creativeservicev1HealthCheck> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetCreativeHealthCheck(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetCreativeHealthCheck(rsp)));
            }));
    }

    /**
     */
    public advertisingPlatformServiceGetDeployHealthCheck(_options?: Configuration): Observable<Deployservicev3HealthCheck> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetDeployHealthCheck(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetDeployHealthCheck(rsp)));
            }));
    }

    /**
     */
    public advertisingPlatformServiceGetHealthCheck(_options?: Configuration): Observable<Hagridv1HealthCheck> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetHealthCheck(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetHealthCheck(rsp)));
            }));
    }

    /**
     */
    public advertisingPlatformServiceGetNotificationHealthCheck(_options?: Configuration): Observable<Notificationservicev1HealthCheck> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetNotificationHealthCheck(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetNotificationHealthCheck(rsp)));
            }));
    }

    /**
     */
    public advertisingPlatformServiceGetOrgHealthCheck(_options?: Configuration): Observable<Orgmanagerv1HealthCheck> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetOrgHealthCheck(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetOrgHealthCheck(rsp)));
            }));
    }

    /**
     */
    public advertisingPlatformServiceGetTargetHealthCheck(_options?: Configuration): Observable<Targetorchestratorv2HealthCheck> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetTargetHealthCheck(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetTargetHealthCheck(rsp)));
            }));
    }

}

import { JobsApiRequestFactory, JobsApiResponseProcessor} from "../apis/JobsApi";
export class ObservableJobsApi {
    private requestFactory: JobsApiRequestFactory;
    private responseProcessor: JobsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: JobsApiRequestFactory,
        responseProcessor?: JobsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new JobsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new JobsApiResponseProcessor();
    }

    /**
     * Create Job
     * @param orgId The Organization where this job will be created.
     * @param job The job to create.
     */
    public advertisingPlatformServiceCreateJob(orgId: string, job: V1Job, _options?: Configuration): Observable<V1Job> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateJob(orgId, job, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateJob(rsp)));
            }));
    }

    /**
     * Delete Job
     * @param jobId The ID of the job to delete.
     * @param orgId The Organization where this Job belongs to.
     */
    public advertisingPlatformServiceDeleteJob(jobId: string, orgId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteJob(jobId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteJob(rsp)));
            }));
    }

    /**
     * Download Job File
     * @param jobId The ID of the job.
     * @param jobFileType File type to download.   - JOB_FILE_TYPE_UNKNOWN: Unknown File Type.  - JOB_FILE_TYPE_ANNOTATED: File of the original source file data with a boolean that specifies whether the row was matched or not.  - JOB_FILE_TYPE_SELECTED: File of the ip addresses and ethashs.  - JOB_FILE_TYPE_VALIDATED: File of the validated addresses.  - JOB_FILE_TYPE_RESULTS: File of the results of digital canvas.  - JOB_FILE_TYPE_DIRECT_MAIL: File of direct mail addresses.  - JOB_FILE_TYPE_HOMES: File of the addresses of devices found in venue replay.  - JOB_FILE_TYPE_DEVICES_IN_HOMES_NOT_SEEN: File of the devices found in homes but not found with venue replay.  - JOB_FILE_TYPE_DEVICES_WITH_HOMES: File of the devices with homes found in venue replay.  - JOB_FILE_TYPE_DEVICES_WITHOUT_HOMES: File of the devices without homes found in venue replay.  - JOB_FILE_TYPE_MAIDS: File of MAIDS addresses.  - JOB_FILE_TYPE_ENRICHED: File of Enriched addresses.  - JOB_FILE_TYPE_SALES_MATCHBACK: CSV that joins the ethashed sales file to the compiled audience file on the ethash column.  - JOB_FILE_TYPE_ORDER_LINE_MATCHBACK: JSON file that encompasses the orderline and audience relations for the matchbacking job.  - JOB_FILE_TYPE_ETHASHED_SALES: CSV file that contains the original sales file with the ethash and the match code for each row.  - JOB_FILE_TYPE_COMPILED_AUDIENCE: CSV file that contains the following columns generated by an ethash job: AudienceID, OLID, CurrentlyAttached, Deployed, Served, Excluded, ETHash, Matched, Address, Zip, ServeTimeFrames
     * @param orgId The ID of the target&#39;s org
     */
    public advertisingPlatformServiceDownloadJobFile(jobId?: string, jobFileType?: 'JOB_FILE_TYPE_UNKNOWN' | 'JOB_FILE_TYPE_ANNOTATED' | 'JOB_FILE_TYPE_SELECTED' | 'JOB_FILE_TYPE_VALIDATED' | 'JOB_FILE_TYPE_RESULTS' | 'JOB_FILE_TYPE_DIRECT_MAIL' | 'JOB_FILE_TYPE_HOMES' | 'JOB_FILE_TYPE_DEVICES_IN_HOMES_NOT_SEEN' | 'JOB_FILE_TYPE_DEVICES_WITH_HOMES' | 'JOB_FILE_TYPE_DEVICES_WITHOUT_HOMES' | 'JOB_FILE_TYPE_MAIDS' | 'JOB_FILE_TYPE_ENRICHED' | 'JOB_FILE_TYPE_SALES_MATCHBACK' | 'JOB_FILE_TYPE_ORDER_LINE_MATCHBACK' | 'JOB_FILE_TYPE_ETHASHED_SALES' | 'JOB_FILE_TYPE_COMPILED_AUDIENCE', orgId?: string, _options?: Configuration): Observable<StreamResultOfV1DownloadJobFileResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDownloadJobFile(jobId, jobFileType, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDownloadJobFile(rsp)));
            }));
    }

    /**
     * Get Job
     * @param jobId The ID of the job to retrieve.
     * @param orgId The Organization where this Job belongs to.
     */
    public advertisingPlatformServiceGetJob(jobId: string, orgId: string, _options?: Configuration): Observable<V1Job> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetJob(jobId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetJob(rsp)));
            }));
    }

    /**
     * Run Job
     * @param jobId The ID of the Job.
     * @param orgId The ID of the Org associated to the Job.
     * @param version (OPTIONAL) The version of the target file to use. If empty, the most recent version is used.
     * @param queryId (OPTIONAL) Additional field you might need in order to run a job. The only one that uses this currently is the enrichment job.
     * @param seenCount (OPTIONAL) Additional field you might need in order to run a job. The only one that uses this currently is the enrichment job.
     * @param locType (OPTIONAL) Additional field you might need in order to run a job. The only one that uses this currently is the enrichment job.
     * @param radius (OPTIONAL) Additional field you might need in order to run a job. The only one that could use this currently is the digital canvassing job.
     * @param queryType (OPTIONAL) Additional field you might need in order to run a job. The only one that could use this currently is the digital canvassing job.
     * @param queryArgs (OPTIONAL) Additional field you might need in order to run a job.
     */
    public advertisingPlatformServiceRunJob(jobId?: string, orgId?: string, version?: number, queryId?: string, seenCount?: number, locType?: string, radius?: number, queryType?: string, queryArgs?: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceRunJob(jobId, orgId, version, queryId, seenCount, locType, radius, queryType, queryArgs, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceRunJob(rsp)));
            }));
    }

    /**
     * Update Job
     * @param jobId The Job ID.
     * @param job Job  Job holds info about a specific Job.
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdateJob(jobId: string, job: Job, updateMask?: string, orgId?: string, _options?: Configuration): Observable<V1Job> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateJob(jobId, job, updateMask, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateJob(rsp)));
            }));
    }

}

import { NewMoverApiRequestFactory, NewMoverApiResponseProcessor} from "../apis/NewMoverApi";
export class ObservableNewMoverApi {
    private requestFactory: NewMoverApiRequestFactory;
    private responseProcessor: NewMoverApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: NewMoverApiRequestFactory,
        responseProcessor?: NewMoverApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new NewMoverApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new NewMoverApiResponseProcessor();
    }

    /**
     * Get the number of matched new mover homes for specified mover type(s) for a specified state or zipcode(s)
     * Get New Mover Match Count
     * @param moverType Mover Type  The type of mover for which you want to get the count.
     * @param stateAbbreviation State Abbreviation  The abbreviation of the state from which you want to get the mover count. You can query by state abbreviation or zipcode(s) but not both.
     * @param zipcode Zipcodes  The zipcodes from which you want to get the mover count. You can query by state abbreviation or zipcode(s) but not both.
     * @param orgId Org id  The org_id associated with the user making the request
     * @param requestId Request_ID  Id of the request
     */
    public advertisingPlatformServiceGetNewMoverMatchCount(moverType?: Array<string>, stateAbbreviation?: string, zipcode?: Array<string>, orgId?: string, requestId?: string, _options?: Configuration): Observable<V1GetNewMoverMatchCountResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetNewMoverMatchCount(moverType, stateAbbreviation, zipcode, orgId, requestId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetNewMoverMatchCount(rsp)));
            }));
    }

}

import { NotificationsApiRequestFactory, NotificationsApiResponseProcessor} from "../apis/NotificationsApi";
export class ObservableNotificationsApi {
    private requestFactory: NotificationsApiRequestFactory;
    private responseProcessor: NotificationsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: NotificationsApiRequestFactory,
        responseProcessor?: NotificationsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new NotificationsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new NotificationsApiResponseProcessor();
    }

    /**
     * Gets all notifications irrespective of activity or global/user-specific
     * @param pageSize The maximum number of notifications to return. The service may return fewer than this value.  If unspecified, at most &#x60;1000&#x60; organizations will be returned.  The maximum value is &#x60;1000&#x60;; values above &#x60;1000&#x60; will be coerced to &#x60;1000&#x60;.
     * @param pageToken A page token, received from a previous &#x60;AdminListNotifications&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;AdminListNotifications&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceAdminListNotifications(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Observable<V1AdminListNotificationsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceAdminListNotifications(pageSize, pageToken, orderBy, filter, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceAdminListNotifications(rsp)));
            }));
    }

    /**
     * Create an Email Mapping
     * @param body 
     */
    public advertisingPlatformServiceCreateEmailMapping(body: V1CreateEmailMappingRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateEmailMapping(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateEmailMapping(rsp)));
            }));
    }

    /**
     * creates a notification to be sent when specific events occur.
     * creates a notification to be sent when specific events occur
     * @param notification 
     */
    public advertisingPlatformServiceCreateNotification(notification: V1Notification, _options?: Configuration): Observable<V1Notification> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateNotification(notification, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateNotification(rsp)));
            }));
    }

    /**
     * Create an Email Route
     * Notification Service Routes -> *All Internally Managed*
     * @param body 
     */
    public advertisingPlatformServiceCreateRoute(body: V1CreateRouteRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateRoute(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateRoute(rsp)));
            }));
    }

    /**
     * Delete an Email Mapping
     * @param name 
     */
    public advertisingPlatformServiceDeleteEmailMapping(name: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteEmailMapping(name, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteEmailMapping(rsp)));
            }));
    }

    /**
     * delete a notification
     * delete a notification
     * @param notificationId 
     */
    public advertisingPlatformServiceDeleteNotification(notificationId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteNotification(notificationId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteNotification(rsp)));
            }));
    }

    /**
     * Delete an Email Route
     * @param routeIdentifier 
     */
    public advertisingPlatformServiceDeleteRoute(routeIdentifier: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteRoute(routeIdentifier, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteRoute(rsp)));
            }));
    }

    /**
     * Create an Email Mapping
     * @param name 
     */
    public advertisingPlatformServiceGetEmailMapping(name: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetEmailMapping(name, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetEmailMapping(rsp)));
            }));
    }

    /**
     * Get notification by its id.
     * Get notification by ID
     * @param notificationId 
     */
    public advertisingPlatformServiceGetNotification(notificationId: string, _options?: Configuration): Observable<V1Notification> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetNotification(notificationId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetNotification(rsp)));
            }));
    }

    /**
     * Get global notifications and a user's notifications provided a user_id is supplied.
     * Get global + user notifications
     * @param userId 
     */
    public advertisingPlatformServiceGetNotifications(userId?: string, _options?: Configuration): Observable<V1GetNotificationsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetNotifications(userId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetNotifications(rsp)));
            }));
    }

    /**
     * Create an Email Route
     * @param routeIdentifier 
     */
    public advertisingPlatformServiceGetRoute(routeIdentifier: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetRoute(routeIdentifier, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetRoute(rsp)));
            }));
    }

    /**
     * Get the job report for a specific route
     * @param jobId The ID of the River Job you want to fetch
     */
    public advertisingPlatformServiceGetRouteJobReport(jobId: number, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetRouteJobReport(jobId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetRouteJobReport(rsp)));
            }));
    }

    /**
     * Get all Email Mappings
     */
    public advertisingPlatformServiceListEmailMappings(_options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListEmailMappings(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListEmailMappings(rsp)));
            }));
    }

    /**
     * Get all Email Routes
     */
    public advertisingPlatformServiceListRoutes(_options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListRoutes(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListRoutes(rsp)));
            }));
    }

    /**
     * Request an org name change
     * @param body 
     */
    public advertisingPlatformServiceRequestOrgNameChange(body: V1RequestOrgNameChangeRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceRequestOrgNameChange(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceRequestOrgNameChange(rsp)));
            }));
    }

    /**
     * Request support from AdOps
     * @param body  (streaming inputs)
     */
    public advertisingPlatformServiceRequestSupport(body: V1RequestSupportRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceRequestSupport(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceRequestSupport(rsp)));
            }));
    }

    /**
     * send a message
     * @param body 
     */
    public advertisingPlatformServiceSendMessage(body: V1SendMessageRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceSendMessage(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceSendMessage(rsp)));
            }));
    }

    /**
     * Send OrderLine Ending Message for all order lines ending in 7 days
     */
    public advertisingPlatformServiceSendOrderLineEndingNotifications(_options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceSendOrderLineEndingNotifications(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceSendOrderLineEndingNotifications(rsp)));
            }));
    }

    /**
     * Send a message to orgs that have order lines that are ready but not submitted
     */
    public advertisingPlatformServiceSendOrderLineReadyButNotSubmittedNotifications(_options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceSendOrderLineReadyButNotSubmittedNotifications(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceSendOrderLineReadyButNotSubmittedNotifications(rsp)));
            }));
    }

    /**
     * Trigger an email route to send emails based on its template configs
     * @param routeIdentifier The identifier/name of the email route to trigger
     * @param body 
     */
    public advertisingPlatformServiceTriggerRoute(routeIdentifier: string, body: AdvertisingPlatformServiceTriggerRouteRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceTriggerRoute(routeIdentifier, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceTriggerRoute(rsp)));
            }));
    }

    /**
     * Update an Email Mapping
     * @param name 
     * @param body 
     */
    public advertisingPlatformServiceUpdateEmailMapping(name: string, body: AdvertisingPlatformServiceUpdateEmailMappingRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateEmailMapping(name, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateEmailMapping(rsp)));
            }));
    }

    /**
     * update any notification fields except send_to and groups.
     * update any notification fields except send_to and groups
     * @param notificationId 
     * @param notification Notification  Contains data after creating a notification
     * @param updateMask 
     */
    public advertisingPlatformServiceUpdateNotification(notificationId: string, notification: Notification, updateMask?: string, _options?: Configuration): Observable<V1Notification> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateNotification(notificationId, notification, updateMask, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateNotification(rsp)));
            }));
    }

    /**
     * Update an Email Route
     * @param routeIdentifier 
     * @param body 
     */
    public advertisingPlatformServiceUpdateRoute(routeIdentifier: string, body: AdvertisingPlatformServiceUpdateRouteRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateRoute(routeIdentifier, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateRoute(rsp)));
            }));
    }

}

import { OrganizationsApiRequestFactory, OrganizationsApiResponseProcessor} from "../apis/OrganizationsApi";
export class ObservableOrganizationsApi {
    private requestFactory: OrganizationsApiRequestFactory;
    private responseProcessor: OrganizationsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: OrganizationsApiRequestFactory,
        responseProcessor?: OrganizationsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new OrganizationsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new OrganizationsApiResponseProcessor();
    }

    /**
     * @param orgId 
     * @param noteId 
     */
    public advertisingPlatformServiceActivateOrgNote(orgId: string, noteId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceActivateOrgNote(orgId, noteId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceActivateOrgNote(rsp)));
            }));
    }

    /**
     * Add AccountRep
     * @param orgId 
     * @param body 
     */
    public advertisingPlatformServiceAddAccountRep(orgId: string, body: AdvertisingPlatformServiceAddAccountRepRequest, _options?: Configuration): Observable<Orgmanagerv1Org> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceAddAccountRep(orgId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceAddAccountRep(rsp)));
            }));
    }

    /**
     * Add CommissionGroup
     * @param orgId 
     * @param body 
     */
    public advertisingPlatformServiceAddCommissionGroup(orgId: string, body: AdvertisingPlatformServiceAddCommissionGroupRequest, _options?: Configuration): Observable<Orgmanagerv1Org> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceAddCommissionGroup(orgId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceAddCommissionGroup(rsp)));
            }));
    }

    /**
     * Add SalesRep
     * @param orgId 
     * @param body 
     */
    public advertisingPlatformServiceAddSalesRep(orgId: string, body: AdvertisingPlatformServiceAddSalesRepRequest, _options?: Configuration): Observable<Orgmanagerv1Org> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceAddSalesRep(orgId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceAddSalesRep(rsp)));
            }));
    }

    /**
     * Add User
     * @param orgId 
     * @param body 
     */
    public advertisingPlatformServiceAddUser(orgId: string, body: AdvertisingPlatformServiceAddUserRequest, _options?: Configuration): Observable<Orgmanagerv1Org> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceAddUser(orgId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceAddUser(rsp)));
            }));
    }

    /**
     * Create CPM
     * @param orgId 
     * @param cpm 
     */
    public advertisingPlatformServiceCreateCPM(orgId: string, cpm: V1CPM, _options?: Configuration): Observable<V1CPM> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateCPM(orgId, cpm, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateCPM(rsp)));
            }));
    }

    /**
     * Create Contact
     * @param orgId 
     * @param contact 
     */
    public advertisingPlatformServiceCreateContact(orgId: string, contact: Orgmanagerv1Contact, _options?: Configuration): Observable<Orgmanagerv1Contact> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateContact(orgId, contact, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateContact(rsp)));
            }));
    }

    /**
     * Create Organization
     * @param org The Organization to create.
     */
    public advertisingPlatformServiceCreateOrg(org: Orgmanagerv1Org, _options?: Configuration): Observable<Orgmanagerv1Org> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateOrg(org, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateOrg(rsp)));
            }));
    }

    /**
     * @param orgId 
     * @param body 
     */
    public advertisingPlatformServiceCreateOrgNote(orgId: string, body: AdvertisingPlatformServiceCreateOrgNoteRequest, _options?: Configuration): Observable<Orgmanagerv1Note> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateOrgNote(orgId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateOrgNote(rsp)));
            }));
    }

    /**
     * @param orgId 
     * @param noteId 
     */
    public advertisingPlatformServiceDeactivateOrgNote(orgId: string, noteId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeactivateOrgNote(orgId, noteId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeactivateOrgNote(rsp)));
            }));
    }

    /**
     * Ensures User's data synchronization between Keycloak, Debezium and OrgManager.
     * Debezium Sync Check
     * @param userId The ID of the User to retrieve.
     * @param body 
     */
    public advertisingPlatformServiceDebeziumSyncCheck(userId: string, body: any, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDebeziumSyncCheck(userId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDebeziumSyncCheck(rsp)));
            }));
    }

    /**
     * Delete CPM
     * @param orgId 
     * @param cpmId 
     */
    public advertisingPlatformServiceDeleteCPM(orgId: string, cpmId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteCPM(orgId, cpmId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteCPM(rsp)));
            }));
    }

    /**
     * Delete Contact
     * @param orgId 
     * @param contactId 
     */
    public advertisingPlatformServiceDeleteContact(orgId: string, contactId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteContact(orgId, contactId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteContact(rsp)));
            }));
    }

    /**
     * Delete Organization
     * @param orgId The ID of the Organization to delete.
     */
    public advertisingPlatformServiceDeleteOrg(orgId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteOrg(orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteOrg(rsp)));
            }));
    }

    /**
     * Delete Org Logo
     * @param orgId ID of the org whose logo will be deleted
     */
    public advertisingPlatformServiceDeleteOrgLogo(orgId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteOrgLogo(orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteOrgLogo(rsp)));
            }));
    }

    /**
     * Get and Org from an Org ID
     * Get Organization
     * @param orgId The ID of the Organization to retrieve.
     * @param skipPreload 
     */
    public advertisingPlatformServiceGetOrg(orgId: string, skipPreload?: boolean, _options?: Configuration): Observable<Orgmanagerv1Org> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetOrg(orgId, skipPreload, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetOrg(rsp)));
            }));
    }

    /**
     * List org users
     * @param orgId 
     * @param pageSize 
     * @param pageToken 
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListOrgUsers(orgId: string, pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Observable<V1ListOrgUsersResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListOrgUsers(orgId, pageSize, pageToken, orderBy, filter, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListOrgUsers(rsp)));
            }));
    }

    /**
     * List Organizations
     * @param pageSize The maximum number of organizations to return. The service may return fewer than this value.  If unspecified, at most &#x60;100&#x60; organizations will be returned.  The maximum value is &#x60;100&#x60;; values above &#x60;100&#x60; will be coerced to &#x60;100&#x60;.
     * @param pageToken A page token, received from a previous &#x60;ListOrgs&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListOrgs&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     * @param skipPreload If true, then nested fields won&#39;t be populated. Use this for a faster response time.
     * @param userId Filter the Orgs returned by User ID.
     */
    public advertisingPlatformServiceListOrgs(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, skipPreload?: boolean, userId?: string, _options?: Configuration): Observable<V1ListOrgsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListOrgs(pageSize, pageToken, orderBy, filter, skipPreload, userId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListOrgs(rsp)));
            }));
    }

    /**
     * Update an org's parent org id
     * Move Organization
     * @param id The id of the org to move
     * @param body 
     */
    public advertisingPlatformServiceMoveOrg(id: string, body: MoveOrgsRequest, _options?: Configuration): Observable<Orgmanagerv1Org> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceMoveOrg(id, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceMoveOrg(rsp)));
            }));
    }

    /**
     * Remove AccountRep
     * @param orgId 
     * @param body 
     */
    public advertisingPlatformServiceRemoveAccountRep(orgId: string, body: AdvertisingPlatformServiceAddAccountRepRequest, _options?: Configuration): Observable<Orgmanagerv1Org> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceRemoveAccountRep(orgId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceRemoveAccountRep(rsp)));
            }));
    }

    /**
     * Remove CommissionGroup
     * @param orgId 
     * @param body 
     */
    public advertisingPlatformServiceRemoveCommissionGroup(orgId: string, body: AdvertisingPlatformServiceRemoveCommissionGroupRequest, _options?: Configuration): Observable<Orgmanagerv1Org> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceRemoveCommissionGroup(orgId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceRemoveCommissionGroup(rsp)));
            }));
    }

    /**
     * Remove SalesRep
     * @param orgId 
     * @param body 
     */
    public advertisingPlatformServiceRemoveSalesRep(orgId: string, body: AdvertisingPlatformServiceAddSalesRepRequest, _options?: Configuration): Observable<Orgmanagerv1Org> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceRemoveSalesRep(orgId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceRemoveSalesRep(rsp)));
            }));
    }

    /**
     * Remove User
     * @param orgId 
     * @param body 
     */
    public advertisingPlatformServiceRemoveUser(orgId: string, body: AdvertisingPlatformServiceRemoveUserRequest, _options?: Configuration): Observable<Orgmanagerv1Org> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceRemoveUser(orgId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceRemoveUser(rsp)));
            }));
    }

    /**
     * Update CPM
     * @param orgId 
     * @param cpmId ID of the CPM
     * @param cpm CPM contains information relating to a client cpmanization
     * @param updateMask 
     */
    public advertisingPlatformServiceUpdateCPM(orgId: string, cpmId: string, cpm: CPMContainsInformationRelatingToAClientCpmanization, updateMask?: string, _options?: Configuration): Observable<V1CPM> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateCPM(orgId, cpmId, cpm, updateMask, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateCPM(rsp)));
            }));
    }

    /**
     * Update Contact
     * @param orgId 
     * @param contactId ID of the Contact
     * @param contact Contact  Contacts store information of people interested in an org
     * @param updateMask 
     */
    public advertisingPlatformServiceUpdateContact(orgId: string, contactId: string, contact: Contact, updateMask?: string, _options?: Configuration): Observable<Orgmanagerv1Contact> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateContact(orgId, contactId, contact, updateMask, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateContact(rsp)));
            }));
    }

    /**
     * Update Organization
     * @param orgId ID of the Organization
     * @param org The Organization to update.
     * @param updateMask The list of fields to update.
     */
    public advertisingPlatformServiceUpdateOrg(orgId: string, org: TheOrganizationToUpdate, updateMask?: string, _options?: Configuration): Observable<Orgmanagerv1Org> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateOrg(orgId, org, updateMask, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateOrg(rsp)));
            }));
    }

}

import { OrgsApiRequestFactory, OrgsApiResponseProcessor} from "../apis/OrgsApi";
export class ObservableOrgsApi {
    private requestFactory: OrgsApiRequestFactory;
    private responseProcessor: OrgsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: OrgsApiRequestFactory,
        responseProcessor?: OrgsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new OrgsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new OrgsApiResponseProcessor();
    }

    /**
     * Batch Update Orgs
     * @param body 
     */
    public advertisingPlatformServiceBatchUpdateOrgs(body: V1BatchUpdateOrgsRequest, _options?: Configuration): Observable<V1BatchUpdateOrgsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceBatchUpdateOrgs(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceBatchUpdateOrgs(rsp)));
            }));
    }

}

import { PolicyApiRequestFactory, PolicyApiResponseProcessor} from "../apis/PolicyApi";
export class ObservablePolicyApi {
    private requestFactory: PolicyApiRequestFactory;
    private responseProcessor: PolicyApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: PolicyApiRequestFactory,
        responseProcessor?: PolicyApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new PolicyApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new PolicyApiResponseProcessor();
    }

    /**
     * Bundle a Policy
     * @param body 
     */
    public advertisingPlatformServiceBundle(body: V1BundleRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceBundle(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceBundle(rsp)));
            }));
    }

    /**
     * Download a Policy
     * @param policyPath Policy Path  The path to the policy you would like to download.
     */
    public advertisingPlatformServiceDownloadBundle(policyPath?: string, _options?: Configuration): Observable<StreamResultOfV1DownloadBundleResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDownloadBundle(policyPath, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDownloadBundle(rsp)));
            }));
    }

}

import { ReportRunsApiRequestFactory, ReportRunsApiResponseProcessor} from "../apis/ReportRunsApi";
export class ObservableReportRunsApi {
    private requestFactory: ReportRunsApiRequestFactory;
    private responseProcessor: ReportRunsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ReportRunsApiRequestFactory,
        responseProcessor?: ReportRunsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ReportRunsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ReportRunsApiResponseProcessor();
    }

    /**
     * Deletes a run.
     * Delete Report Run
     * @param reportId Parent report.
     * @param runId Run to delete.
     * @param orgId Org ID  Owning organization.
     */
    public advertisingPlatformServiceDeleteReportRun(reportId: string, runId: string, orgId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteReportRun(reportId, runId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteReportRun(rsp)));
            }));
    }

    /**
     * Retrieves a single run by ID.
     * Get Report Run
     * @param reportId Parent report.
     * @param runId Run to retrieve.
     * @param orgId Org ID  Owning organization.
     */
    public advertisingPlatformServiceGetReportRun(reportId: string, runId: string, orgId: string, _options?: Configuration): Observable<V1ReportRun> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetReportRun(reportId, runId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetReportRun(rsp)));
            }));
    }

    /**
     * Lists runs for a report.
     * List Report Runs
     * @param reportId Parent report.
     * @param pageSize Page Size  Maximum number of runs to return.
     * @param pageToken Page Token  Token from a previous ListReportRuns response. When paginating, all other parameters must match the call that produced the token.
     * @param orderBy Order By  Sort order.
     * @param filter Filter  Filter expression.
     */
    public advertisingPlatformServiceListReportRuns(reportId: string, pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Observable<V1ListReportRunsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListReportRuns(reportId, pageSize, pageToken, orderBy, filter, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListReportRuns(rsp)));
            }));
    }

    /**
     * Retries the same report run that failed and moves it from the FAILED to the SCHEDULED status.
     * Retry Report Run
     * @param reportId Parent report.
     * @param runId Run to retry. Must be in FAILED status.
     * @param body 
     */
    public advertisingPlatformServiceRetryReportRun(reportId: string, runId: string, body: AdvertisingPlatformServiceRetryReportRunRequest, _options?: Configuration): Observable<V1ReportRun> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceRetryReportRun(reportId, runId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceRetryReportRun(rsp)));
            }));
    }

    /**
     * Triggers a new manual run of an existing report. The new run starts in SCHEDULED status and executes asynchronously.
     * Run Report
     * @param reportId Report to run.
     * @param body 
     */
    public advertisingPlatformServiceRunReport(reportId: string, body: AdvertisingPlatformServiceRunReportRequest, _options?: Configuration): Observable<V1ReportRun> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceRunReport(reportId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceRunReport(rsp)));
            }));
    }

}

import { ReportsApiRequestFactory, ReportsApiResponseProcessor} from "../apis/ReportsApi";
export class ObservableReportsApi {
    private requestFactory: ReportsApiRequestFactory;
    private responseProcessor: ReportsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ReportsApiRequestFactory,
        responseProcessor?: ReportsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ReportsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ReportsApiResponseProcessor();
    }

    /**
     * Creates a report and returns the new ids. When should_run_now is true, the first run is also scheduled to start immediately. Any schedules supplied in the request are created together with the report.
     * Create Report
     * @param orgId Org ID  Owning organization.
     * @param report The report to create.
     * @param shouldRunNow Should Run Now  When true, the first run is also scheduled to start immediately. The response includes run_id.
     */
    public advertisingPlatformServiceCreateReport(orgId: string, report: V1Report, shouldRunNow?: boolean, _options?: Configuration): Observable<V1CreateReportResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateReport(orgId, report, shouldRunNow, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateReport(rsp)));
            }));
    }

    /**
     * Deletes a report and its associated schedules and runs.
     * Delete Report
     * @param reportId Report to delete.
     * @param orgId Org ID  Owning organization.
     */
    public advertisingPlatformServiceDeleteReport(reportId: string, orgId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteReport(reportId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteReport(rsp)));
            }));
    }

    /**
     * Retrieves a single report by ID. Returns NotFound if the report has been deleted.
     * Get Report
     * @param reportId Report to retrieve.
     * @param orgId Org ID  Owning organization.
     */
    public advertisingPlatformServiceGetReport(reportId: string, orgId: string, _options?: Configuration): Observable<V1Report> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetReport(reportId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetReport(rsp)));
            }));
    }

    /**
     * Lists reports the caller has access to. Deleted reports are excluded. Use the filter parameter to narrow to a specific org.
     * List Reports
     * @param pageSize Page Size  Maximum number of reports to return.
     * @param pageToken Page Token  Token from a previous ListReports response. When paginating, all other parameters must match the call that produced the token.
     * @param orderBy Order By  Sort order.
     * @param filter Filter  Filter expression.
     */
    public advertisingPlatformServiceListReports(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Observable<V1ListReportsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListReports(pageSize, pageToken, orderBy, filter, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListReports(rsp)));
            }));
    }

    /**
     * Partially updates a report. Only fields listed in update_mask are modified. Schedules are not modifiable here; use Schedule sub-resource RPCs.
     * Update Report
     * @param reportId Server-assigned report identifier.
     * @param orgId Org ID  Owning organization.
     * @param report The report to update. Must include id (identifies which report) and the new values for every field listed in update_mask.
     * @param updateMask Update Mask  Field paths to update on the report. Paths referencing schedules, id, org_id, create_time, update_time, or delete_time are rejected.
     */
    public advertisingPlatformServiceUpdateReport(reportId: string, orgId: string, report: TheReportToUpdateMustIncludeIdIdentifiesWhichReportAndTheNewValuesForEveryFieldListedInUpdateMask, updateMask?: string, _options?: Configuration): Observable<V1Report> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateReport(reportId, orgId, report, updateMask, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateReport(rsp)));
            }));
    }

}

import { SchedulesApiRequestFactory, SchedulesApiResponseProcessor} from "../apis/SchedulesApi";
export class ObservableSchedulesApi {
    private requestFactory: SchedulesApiRequestFactory;
    private responseProcessor: SchedulesApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: SchedulesApiRequestFactory,
        responseProcessor?: SchedulesApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new SchedulesApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new SchedulesApiResponseProcessor();
    }

    /**
     * Creates a new schedule attached to an existing report.
     * Create Schedule
     * @param reportId Parent report.
     * @param orgId Org ID  Owning organization.
     * @param schedule The schedule to create.
     */
    public advertisingPlatformServiceCreateSchedule(reportId: string, orgId: string, schedule: V1Schedule, _options?: Configuration): Observable<V1Schedule> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateSchedule(reportId, orgId, schedule, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateSchedule(rsp)));
            }));
    }

    /**
     * Deletes a schedule and cancels any future executions and it deletes all report runs associated with the schedule.
     * Delete Schedule
     * @param reportId Parent report.
     * @param scheduleId Schedule to delete.
     * @param orgId Org ID  Owning organization.
     */
    public advertisingPlatformServiceDeleteSchedule(reportId: string, scheduleId: string, orgId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteSchedule(reportId, scheduleId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteSchedule(rsp)));
            }));
    }

    /**
     * Retrieves a single schedule by ID.
     * Get Schedule
     * @param reportId Parent report.
     * @param scheduleId Schedule to retrieve.
     * @param orgId Org ID  Owning organization.
     */
    public advertisingPlatformServiceGetSchedule(reportId: string, scheduleId: string, orgId: string, _options?: Configuration): Observable<V1Schedule> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetSchedule(reportId, scheduleId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetSchedule(rsp)));
            }));
    }

    /**
     * Lists schedules attached to a report.
     * List Schedules
     * @param reportId Parent report.
     * @param pageSize Page Size  Maximum number of schedules to return.
     * @param pageToken Page Token  Token from a previous ListSchedules response. When paginating, all other parameters must match the call that produced the token.
     * @param orderBy Order By  Sort order.
     * @param filter Filter  Filter expression.
     */
    public advertisingPlatformServiceListSchedules(reportId: string, pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Observable<V1ListSchedulesResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListSchedules(reportId, pageSize, pageToken, orderBy, filter, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListSchedules(rsp)));
            }));
    }

    /**
     * Transitions schedules on a report from ACTIVE to INACTIVE. Omit schedule_ids to pause every ACTIVE schedule on the report. When schedule_ids is provided, the call is all-or-nothing: if any listed id is not ACTIVE, no schedules are paused and FailedPrecondition is returned.
     * Pause Schedules
     * @param reportId Parent report.
     * @param body 
     */
    public advertisingPlatformServicePauseSchedules(reportId: string, body: AdvertisingPlatformServicePauseSchedulesRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServicePauseSchedules(reportId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServicePauseSchedules(rsp)));
            }));
    }

    /**
     * Transitions schedules on a report from INACTIVE to ACTIVE. Omit schedule_ids to resume every INACTIVE schedule on the report. When schedule_ids is provided, the call is all-or-nothing: if any listed id is not INACTIVE, no schedules are resumed and FailedPrecondition is returned.
     * Play Schedules
     * @param reportId Parent report.
     * @param body 
     */
    public advertisingPlatformServicePlaySchedules(reportId: string, body: AdvertisingPlatformServicePlaySchedulesRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServicePlaySchedules(reportId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServicePlaySchedules(rsp)));
            }));
    }

    /**
     * Partially updates a schedule. Status, ownership, and timestamps are not modifiable. New start/end values must be today or future.
     * Update Schedule
     * @param reportId Parent report.
     * @param scheduleId Server-assigned schedule identifier.
     * @param orgId Org ID  Owning organization.
     * @param schedule The schedule to update. Must include id (identifies which schedule) and the new values for every field listed in update_mask.
     * @param updateMask Update Mask  Field paths to update on the schedule. Paths referencing status, id, org_id, report_id, create_time, update_time, or delete_time are rejected.
     */
    public advertisingPlatformServiceUpdateSchedule(reportId: string, scheduleId: string, orgId: string, schedule: TheScheduleToUpdateMustIncludeIdIdentifiesWhichScheduleAndTheNewValuesForEveryFieldListedInUpdateMask, updateMask?: string, _options?: Configuration): Observable<V1Schedule> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateSchedule(reportId, scheduleId, orgId, schedule, updateMask, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateSchedule(rsp)));
            }));
    }

}

import { StatsApiRequestFactory, StatsApiResponseProcessor} from "../apis/StatsApi";
export class ObservableStatsApi {
    private requestFactory: StatsApiRequestFactory;
    private responseProcessor: StatsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: StatsApiRequestFactory,
        responseProcessor?: StatsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new StatsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new StatsApiResponseProcessor();
    }

    /**
     * Get device type serve statistics on campaigns
     * Get Device Type Stat Results
     * @param orgId Filter results to specific organizations by providing one organization ID
     * @param body 
     */
    public advertisingPlatformServiceGetDeviceStats(orgId: string, body: DeviceStatsRequestWillHoldThePOSTRequestVarsForCustomizingDeviceStatisticsQueries, _options?: Configuration): Observable<V1DeviceStatsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetDeviceStats(orgId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetDeviceStats(rsp)));
            }));
    }

    /**
     * Get granular serve statistics on campaigns
     * Get Stat Results
     * @param orgId Filter results to specific organizations by providing one organization ID
     * @param body 
     */
    public advertisingPlatformServiceGetStats(orgId: string, body: StatsRequestWillHoldThePOSTRequestVarsForCustomizingStatisticsQueries, _options?: Configuration): Observable<V1StatsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetStats(orgId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetStats(rsp)));
            }));
    }

}

import { TargetsApiRequestFactory, TargetsApiResponseProcessor} from "../apis/TargetsApi";
export class ObservableTargetsApi {
    private requestFactory: TargetsApiRequestFactory;
    private responseProcessor: TargetsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: TargetsApiRequestFactory,
        responseProcessor?: TargetsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new TargetsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new TargetsApiResponseProcessor();
    }

    /**
     * Archive Target
     * @param body 
     */
    public advertisingPlatformServiceArchiveTarget(body: V2ArchiveTargetRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceArchiveTarget(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceArchiveTarget(rsp)));
            }));
    }

    /**
     * Create Json Target
     * @param body 
     */
    public advertisingPlatformServiceCreateJsonTarget(body: V2CreateJsonTargetRequest, _options?: Configuration): Observable<V2Target> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateJsonTarget(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateJsonTarget(rsp)));
            }));
    }

    /**
     * Delete Target
     * @param targetId The ID of the Target.
     * @param orgId Org_id  The ID of the Org associated to the Job.
     */
    public advertisingPlatformServiceDeleteTarget(targetId: string, orgId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteTarget(targetId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteTarget(rsp)));
            }));
    }

    /**
     * Download Target File
     * @param targetId The ID of the Target.
     * @param targetFileType File type to download.   - FILE_TYPE_UNKNOWN: Unknown File Type.  - FILE_TYPE_ADDRESS: File of addresses.  - FILE_TYPE_IP: File of IPs.  - FILE_TYPE_ZIP: File of zip codes.  - FILE_TYPE_DEVICE: File of device IDs.  - FILE_TYPE_GEOJSON: File of GeoJSON polygons  - FILE_TYPE_WKB: File of WKBs  - FILE_TYPE_FILELESS: Target doesnt require a file  - FILE_TYPE_SOURCE: File of the original source file. Period.  - FILE_TYPE_CLEANED: File of the original source file that has been processed by the filecleaner lambda.  - FILE_TYPE_ETHASH: File of ethashes  - FILE_TYPE_CONTACT: File of emails and or phone numbers and a contact id for each row  - FILE_TYPE_NPI: File of npis, national health care provider ids
     * @param orgId The ID of the target&#39;s org
     * @param version (OPTIONAL) The version of the target file to download. If empty, the most recent version is returned.
     */
    public advertisingPlatformServiceDownloadTargetFile(targetId?: string, targetFileType?: 'FILE_TYPE_UNKNOWN' | 'FILE_TYPE_ADDRESS' | 'FILE_TYPE_IP' | 'FILE_TYPE_ZIP' | 'FILE_TYPE_DEVICE' | 'FILE_TYPE_GEOJSON' | 'FILE_TYPE_WKB' | 'FILE_TYPE_FILELESS' | 'FILE_TYPE_SOURCE' | 'FILE_TYPE_CLEANED' | 'FILE_TYPE_ETHASH' | 'FILE_TYPE_CONTACT' | 'FILE_TYPE_NPI', orgId?: string, version?: number, _options?: Configuration): Observable<StreamResultOfV2DownloadTargetFileResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDownloadTargetFile(targetId, targetFileType, orgId, version, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDownloadTargetFile(rsp)));
            }));
    }

    /**
     * #### Description: This endpoint returns the target resource.  ### Unexpected Scenarios: #### 500 (Internal Server Error): - **Action**: Perform a short wait and retry once. - **Exponential Backoff**: If the issue persists, retry using exponential backoff (e.g., 1s, 2s, 4s, 8s). - **Escalation**: If unresolved, submit a support ticket to ElToro with the request CURL.  #### 503 (Service Unavailable): - **Action**: Retry up to 4 times using exponential backoff with increasing delays (e.g., 1s, 2s, 4s, 8s). - **Escalation**: If unresolved, submit a support ticket to ElToro with the request CURL.  #### TARGET_STATUS_ERRORED: - **Action**: Troubleshoot the request or file for issues (e.g., format, invalid data, etc.). - **Escalation**: If unresolved, submit a support ticket with the target ID and org ID.  ### Exponential Backoff Example: - **Initial Retry**: 1 second - **Subsequent Delays**: 2s, 4s, 8s, 16s, etc., doubling each time. - **Maximum Retry Delay**: Typically capped at 60 seconds for subsequent retries. - **Reset**: After a successful update, the delay resets to the initial 5-second interval for further polling.  By applying this exponential backoff strategy, you ensure more efficient retries, helping to avoid overwhelming the service while allowing time for recovery between requests.  
     * Get Target
     * @param targetId ID of the Target
     * @param orgId The Organization where this Target belongs to.
     */
    public advertisingPlatformServiceGetTarget(targetId: string, orgId: string, _options?: Configuration): Observable<V2Target> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetTarget(targetId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetTarget(rsp)));
            }));
    }

    /**
     * List Target Folders
     * @param pageSize The maximum number of resources to return. The service may return fewer than this value. If unspecified, at most 16 resources will be returned. The maximum value is 100; values above 100 will be coerced to 100.
     * @param pageToken A page token, received from a previous &#x60;ListCreatives&#x60; request. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListCreatives&#x60; must match the request that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListTargetFolders(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Observable<V2ListTargetFoldersResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListTargetFolders(pageSize, pageToken, orderBy, filter, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListTargetFolders(rsp)));
            }));
    }

    /**
     * List Targets
     * @param pageSize The maximum number of targets to return. The service may return fewer than this value.  If unspecified, at most &#x60;1000&#x60; targets will be returned.  The maximum value is &#x60;1000&#x60;; values above &#x60;1000&#x60; will be coerced to &#x60;1000&#x60;.
     * @param pageToken A page token, received from a previous &#x60;ListTargets&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListTargets&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListTargets(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Observable<V2ListTargetsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListTargets(pageSize, pageToken, orderBy, filter, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListTargets(rsp)));
            }));
    }

    /**
     * Replace Target File
     * @param body  (streaming inputs)
     */
    public advertisingPlatformServiceReplaceTargetFile(body: V2ReplaceTargetFileRequest, _options?: Configuration): Observable<V2Target> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceReplaceTargetFile(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceReplaceTargetFile(rsp)));
            }));
    }

    /**
     * Start Archiving Targets
     */
    public advertisingPlatformServiceStartArchivingTargets(_options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceStartArchivingTargets(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceStartArchivingTargets(rsp)));
            }));
    }

    /**
     * Unarchive Target
     * @param body 
     */
    public advertisingPlatformServiceUnarchiveTarget(body: V2UnarchiveTargetRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUnarchiveTarget(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUnarchiveTarget(rsp)));
            }));
    }

    /**
     * Update Target
     * @param targetId The Target&#39;s ID.
     * @param orgId The Organization where this Target belongs to.
     * @param target The target to update.
     * @param updateMask List of fields to be updated
     */
    public advertisingPlatformServiceUpdateTarget(targetId: string, orgId: string, target: TheTargetToUpdate, updateMask?: string, _options?: Configuration): Observable<V2Target> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateTarget(targetId, orgId, target, updateMask, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateTarget(rsp)));
            }));
    }

    /**
     * ### Description: This endpoint is used for uploading the source file. Once uploaded, the file will undergo processing, and its status will change accordingly.  ---  ### Expected Response: - **Status Code**: 200 or 202 - **Response Body**: Includes the JSON key `'status': 'TARGET_STATUS_SUBMITTED'`, indicating that the target file has been successfully submitted.  ---  ### Unexpected Responses: #### 500 (Internal Server Error): - **Action**: Wait briefly and retry once. - **Exponential Backoff**: If the issue persists after the retry, use an exponential backoff strategy (e.g., retry after 1s, 2s, 4s, and 8s). - **Escalation**: If unresolved, submit a support ticket to ElToro, including the request CURL and file.  #### 503 (Service Unavailable): - **Action**: Retry up to 4 times using exponential backoff with increasing delay (e.g., retry after 1s, 2s, 4s, and 8s). - **Escalation**: If unresolved, submit a support ticket to ElToro with the request CURL and file.  #### Troubleshooting: - **If retries still fail**: Perform basic troubleshooting to check for issues like file format or size. - **Escalation**: If no identifiable issue is found, escalate by submitting a support ticket to ElToro with the request CURL and file.  ---  ### Recommended Polling Strategy: - **Initial Delay**: Start with a 5-second delay between requests. - **Subsequent Delays**: Increase the delay progressively, e.g., 10s, 20s, 40s, up to 60s. - **Reset on Update**: After receiving an update, reset the delay to the initial 5-second interval for further polling.  ---  ### Expected Status Progression: - **TARGET_STATUS_SUBMITTED**: The file is in the submission process. - **TARGET_STATUS_TARGETABLE**: The file is ready for audience creation and generation. - **Other statuses**: May include `TARGET_STATUS_PROCESSING`, `TARGET_STATUS_FAILED`, etc., depending on the file's processing state. 
     * Upload Target File
     * @param body  (streaming inputs)
     */
    public advertisingPlatformServiceUploadTargetFile(body: V2UploadTargetFileRequest, _options?: Configuration): Observable<V2Target> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUploadTargetFile(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUploadTargetFile(rsp)));
            }));
    }

}

import { TermsOfServiceApiRequestFactory, TermsOfServiceApiResponseProcessor} from "../apis/TermsOfServiceApi";
export class ObservableTermsOfServiceApi {
    private requestFactory: TermsOfServiceApiRequestFactory;
    private responseProcessor: TermsOfServiceApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: TermsOfServiceApiRequestFactory,
        responseProcessor?: TermsOfServiceApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new TermsOfServiceApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new TermsOfServiceApiResponseProcessor();
    }

    /**
     * Download File
     * @param filename Filename  The name of the TOS file.
     * @param orgId Org ID  The id of the org
     * @param userId User ID  The id of the user who signed the file.
     */
    public advertisingPlatformServiceDownloadTOSAgreement(filename?: string, orgId?: string, userId?: string, _options?: Configuration): Observable<StreamResultOfV1DownloadTOSAgreementResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDownloadTOSAgreement(filename, orgId, userId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDownloadTOSAgreement(rsp)));
            }));
    }

    /**
     * Get user's IP address
     */
    public advertisingPlatformServiceGetUserIPAddress(_options?: Configuration): Observable<V1GetUserIPResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetUserIPAddress(_options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetUserIPAddress(rsp)));
            }));
    }

    /**
     * Upload TOS Agreement
     * @param orgId Org ID  The id of the org
     * @param userId User ID  The id of the user who signed the file.
     */
    public advertisingPlatformServiceListTOSAgreements(orgId?: string, userId?: string, _options?: Configuration): Observable<V1ListTOSAgreementsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListTOSAgreements(orgId, userId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListTOSAgreements(rsp)));
            }));
    }

    /**
     * Upload TOS Agreement
     * @param body  (streaming inputs)
     */
    public advertisingPlatformServiceUploadTOSAgreement(body: V1UploadTOSAgreementRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUploadTOSAgreement(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUploadTOSAgreement(rsp)));
            }));
    }

}

import { UsersApiRequestFactory, UsersApiResponseProcessor} from "../apis/UsersApi";
export class ObservableUsersApi {
    private requestFactory: UsersApiRequestFactory;
    private responseProcessor: UsersApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: UsersApiRequestFactory,
        responseProcessor?: UsersApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new UsersApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new UsersApiResponseProcessor();
    }

    /**
     * @param user 
     */
    public advertisingPlatformServiceCreateUser(user: Hagridv1User, _options?: Configuration): Observable<Hagridv1User> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateUser(user, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateUser(rsp)));
            }));
    }

    /**
     * @param id ID of a User
     */
    public advertisingPlatformServiceDeleteUser(id: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteUser(id, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteUser(rsp)));
            }));
    }

    /**
     * @param userId ID of a User
     */
    public advertisingPlatformServiceGetUser(userId: string, _options?: Configuration): Observable<Hagridv1User> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetUser(userId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetUser(rsp)));
            }));
    }

    /**
     * @param pageSize The maximum number of resources to return. The service may return fewer than this value. If unspecified, at most 16 resources will be returned. The maximum value is 100; values above 100 will be coerced to 100.
     * @param pageToken A page token, received from a previous &#x60;ListOrgs&#x60; request. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListOrgs&#x60; must match the request that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     * @param email Email of a User. This is not required. Only use this if you want to get one user by their email
     */
    public advertisingPlatformServiceListUsers(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, email?: string, _options?: Configuration): Observable<Hagridv1ListUsersResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListUsers(pageSize, pageToken, orderBy, filter, email, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListUsers(rsp)));
            }));
    }

    /**
     * List users
     * @param pageSize 
     * @param pageToken 
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListUsersV2(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Observable<Orgmanagerv2ListUsersResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListUsersV2(pageSize, pageToken, orderBy, filter, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListUsersV2(rsp)));
            }));
    }

    /**
     * @param userId ID of a User
     * @param user Existing user with new field values
     * @param updateMask Indicates which user fields to update
     */
    public advertisingPlatformServiceUpdateUser(userId: string, user: ExistingUserWithNewFieldValues, updateMask?: string, _options?: Configuration): Observable<Hagridv1User> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateUser(userId, user, updateMask, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateUser(rsp)));
            }));
    }

}

import { WebToHomeApiRequestFactory, WebToHomeApiResponseProcessor} from "../apis/WebToHomeApi";
export class ObservableWebToHomeApi {
    private requestFactory: WebToHomeApiRequestFactory;
    private responseProcessor: WebToHomeApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: WebToHomeApiRequestFactory,
        responseProcessor?: WebToHomeApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new WebToHomeApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new WebToHomeApiResponseProcessor();
    }

    /**
     * Attach an org-owned address-exclusion file to a subscription (subscription_id set) or to a pixel (pixel_id only)
     * Attach an org-owned address-exclusion file to a subscription or a pixel
     * @param body 
     */
    public advertisingPlatformServiceAttachExcludedAddresses(body: V1AttachExcludedAddressesRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceAttachExcludedAddresses(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceAttachExcludedAddresses(rsp)));
            }));
    }

    /**
     * Create a ftp in pixel
     * Create an FTP
     * @param publisherId 
     * @param ftp 
     * @param orgId 
     */
    public advertisingPlatformServiceCreateFTP(publisherId: string, ftp: V1FTP, orgId?: string, _options?: Configuration): Observable<V1FTP> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateFTP(publisherId, ftp, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateFTP(rsp)));
            }));
    }

    /**
     * Create a pixel in pixel
     * Create a Pixel
     * @param pixel 
     * @param orgId 
     */
    public advertisingPlatformServiceCreatePixel(pixel: V1Pixel, orgId?: string, _options?: Configuration): Observable<V1Pixel> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreatePixel(pixel, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreatePixel(rsp)));
            }));
    }

    /**
     * Create Pixel's Note
     * @param pixelId 
     * @param note 
     * @param orgId 
     */
    public advertisingPlatformServiceCreatePixelNote(pixelId: string, note: V1PixelNote, orgId?: string, _options?: Configuration): Observable<V1PixelNote> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreatePixelNote(pixelId, note, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreatePixelNote(rsp)));
            }));
    }

    /**
     * Create a publisher in pixel
     * Create a Publisher
     * @param publisher 
     * @param orgId 
     */
    public advertisingPlatformServiceCreatePublisher(publisher: V1Publisher, orgId?: string, _options?: Configuration): Observable<V1Publisher> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreatePublisher(publisher, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreatePublisher(rsp)));
            }));
    }

    /**
     * Create a rule in pixel
     * Create an Rule
     * @param pixelId 
     * @param subscriptionId 
     * @param ruleSetId 
     * @param rule 
     * @param orgId 
     */
    public advertisingPlatformServiceCreateRule(pixelId: string, subscriptionId: string, ruleSetId: string, rule: V1Rule, orgId?: string, _options?: Configuration): Observable<V1Rule> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateRule(pixelId, subscriptionId, ruleSetId, rule, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateRule(rsp)));
            }));
    }

    /**
     * Create a rule_set in pixel
     * Create an RuleSet
     * @param pixelId 
     * @param subscriptionId 
     * @param ruleSet 
     * @param orgId 
     */
    public advertisingPlatformServiceCreateRuleSet(pixelId: string, subscriptionId: string, ruleSet: V1RuleSet, orgId?: string, _options?: Configuration): Observable<V1RuleSet> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateRuleSet(pixelId, subscriptionId, ruleSet, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateRuleSet(rsp)));
            }));
    }

    /**
     * Create a subscription in pixel
     * Create a Subscription
     * @param pixelId 
     * @param subscription 
     * @param orgId 
     */
    public advertisingPlatformServiceCreateSubscription(pixelId: string, subscription: V1Subscription, orgId?: string, _options?: Configuration): Observable<V1Subscription> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateSubscription(pixelId, subscription, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateSubscription(rsp)));
            }));
    }

    /**
     * Create Subscription's Note
     * @param pixelId 
     * @param subscriptionId 
     * @param note 
     * @param orgId 
     */
    public advertisingPlatformServiceCreateSubscriptionNote(pixelId: string, subscriptionId: string, note: V1SubscriptionNote, orgId?: string, _options?: Configuration): Observable<V1SubscriptionNote> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreateSubscriptionNote(pixelId, subscriptionId, note, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreateSubscriptionNote(rsp)));
            }));
    }

    /**
     * Hard-delete an org-owned address-exclusion file
     * Hard-delete an org-owned address-exclusion file (admin only)
     * @param fileId 
     */
    public advertisingPlatformServiceDeleteExclusionAddresses(fileId: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteExclusionAddresses(fileId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteExclusionAddresses(rsp)));
            }));
    }

    /**
     * Delete an ftp in pixel
     * Delete an FTP
     * @param publisherId 
     * @param ftpId 
     * @param orgId 
     */
    public advertisingPlatformServiceDeleteFTP(publisherId: string, ftpId: string, orgId?: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteFTP(publisherId, ftpId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteFTP(rsp)));
            }));
    }

    /**
     * Delete a pixel in pixel
     * Delete a Pixel
     * @param pixelId 
     * @param orgId 
     */
    public advertisingPlatformServiceDeletePixel(pixelId: string, orgId?: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeletePixel(pixelId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeletePixel(rsp)));
            }));
    }

    /**
     * Delete a Pixel's Note
     * Delete a PixelNote
     * @param pixelId 
     * @param noteId 
     * @param orgId 
     */
    public advertisingPlatformServiceDeletePixelNote(pixelId: string, noteId: string, orgId?: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeletePixelNote(pixelId, noteId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeletePixelNote(rsp)));
            }));
    }

    /**
     * Delete a publisher in pixel
     * Delete a Publisher
     * @param publisherId 
     * @param orgId 
     */
    public advertisingPlatformServiceDeletePublisher(publisherId: string, orgId?: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeletePublisher(publisherId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeletePublisher(rsp)));
            }));
    }

    /**
     * Delete an rule in pixel
     * Delete an Rule
     * @param pixelId 
     * @param subscriptionId 
     * @param ruleSetId 
     * @param ruleId 
     * @param orgId 
     */
    public advertisingPlatformServiceDeleteRule(pixelId: string, subscriptionId: string, ruleSetId: string, ruleId: string, orgId?: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteRule(pixelId, subscriptionId, ruleSetId, ruleId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteRule(rsp)));
            }));
    }

    /**
     * Delete an rule_set in pixel
     * Delete an RuleSet
     * @param pixelId 
     * @param subscriptionId 
     * @param ruleSetId 
     * @param orgId 
     */
    public advertisingPlatformServiceDeleteRuleSet(pixelId: string, subscriptionId: string, ruleSetId: string, orgId?: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteRuleSet(pixelId, subscriptionId, ruleSetId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteRuleSet(rsp)));
            }));
    }

    /**
     * Delete a subscription in pixel
     * Delete a Subscription
     * @param pixelId 
     * @param subscriptionId 
     * @param orgId 
     */
    public advertisingPlatformServiceDeleteSubscription(pixelId: string, subscriptionId: string, orgId?: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteSubscription(pixelId, subscriptionId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteSubscription(rsp)));
            }));
    }

    /**
     * Delete a Subscription's Note
     * Delete a SubscriptionNote
     * @param pixelId 
     * @param subscriptionId 
     * @param noteId 
     * @param orgId 
     */
    public advertisingPlatformServiceDeleteSubscriptionNote(pixelId: string, subscriptionId: string, noteId: string, orgId?: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeleteSubscriptionNote(pixelId, subscriptionId, noteId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeleteSubscriptionNote(rsp)));
            }));
    }

    /**
     * Detach an org-owned address-exclusion file from a subscription or a pixel
     * Detach an org-owned address-exclusion file from a subscription or a pixel
     * @param body 
     */
    public advertisingPlatformServiceDetachExcludedAddresses(body: V1DetachExcludedAddressesRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDetachExcludedAddresses(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDetachExcludedAddresses(rsp)));
            }));
    }

    /**
     * Download an org-owned address-exclusion file by id as text/csv. `org_id` is a required query parameter.
     * Download Exclusion Addresses
     * @param fileId 
     * @param orgId 
     */
    public advertisingPlatformServiceDownloadExclusionAddresses(fileId: string, orgId?: string, _options?: Configuration): Observable<StreamResultOfV1DownloadExclusionAddressesResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDownloadExclusionAddresses(fileId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDownloadExclusionAddresses(rsp)));
            }));
    }

    /**
     * List all ftps associated with a publisher
     * Get FTP
     * @param publisherId 
     * @param ftpId 
     * @param orgId 
     */
    public advertisingPlatformServiceGetFTP(publisherId: string, ftpId: string, orgId?: string, _options?: Configuration): Observable<V1FTP> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetFTP(publisherId, ftpId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetFTP(rsp)));
            }));
    }

    /**
     * Get an org's pixels
     * Get a Pixel
     * @param pixelId 
     * @param orgId 
     */
    public advertisingPlatformServiceGetPixel(pixelId: string, orgId?: string, _options?: Configuration): Observable<V1Pixel> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetPixel(pixelId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetPixel(rsp)));
            }));
    }

    /**
     * Get a note made on the subscription by a publisher. This is a restricted endpoint and only available to print partners 
     * Get a PixelNote
     * @param pixelId 
     * @param noteId 
     * @param orgId 
     */
    public advertisingPlatformServiceGetPixelNote(pixelId: string, noteId: string, orgId?: string, _options?: Configuration): Observable<V1PixelNote> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetPixelNote(pixelId, noteId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetPixelNote(rsp)));
            }));
    }

    /**
     * Get a publisher in pixel
     * Get a Publisher
     * @param publisherId 
     * @param orgId 
     */
    public advertisingPlatformServiceGetPublisher(publisherId: string, orgId?: string, _options?: Configuration): Observable<V1Publisher> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetPublisher(publisherId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetPublisher(rsp)));
            }));
    }

    /**
     * Get a rule in pixel
     * Get an Rule
     * @param pixelId 
     * @param subscriptionId 
     * @param ruleSetId 
     * @param ruleId 
     * @param orgId 
     */
    public advertisingPlatformServiceGetRule(pixelId: string, subscriptionId: string, ruleSetId: string, ruleId: string, orgId?: string, _options?: Configuration): Observable<V1Rule> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetRule(pixelId, subscriptionId, ruleSetId, ruleId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetRule(rsp)));
            }));
    }

    /**
     * Get a rule set in pixel
     * Get a RuleSet
     * @param pixelId 
     * @param subscriptionId 
     * @param ruleSetId 
     * @param orgId 
     */
    public advertisingPlatformServiceGetRuleSet(pixelId: string, subscriptionId: string, ruleSetId: string, orgId?: string, _options?: Configuration): Observable<V1RuleSet> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetRuleSet(pixelId, subscriptionId, ruleSetId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetRuleSet(rsp)));
            }));
    }

    /**
     * Get a subscription in pixel
     * Get a Subscription
     * @param pixelId 
     * @param subscriptionId 
     * @param orgId 
     */
    public advertisingPlatformServiceGetSubscription(pixelId: string, subscriptionId: string, orgId?: string, _options?: Configuration): Observable<V1Subscription> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetSubscription(pixelId, subscriptionId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetSubscription(rsp)));
            }));
    }

    /**
     * Get a note made on the subscription by a publisher. This is a restricted endpoint and only available to print partners 
     * Get a SubscriptionNote
     * @param pixelId 
     * @param subscriptionId 
     * @param noteId 
     * @param orgId 
     */
    public advertisingPlatformServiceGetSubscriptionNote(pixelId: string, subscriptionId: string, noteId: string, orgId?: string, _options?: Configuration): Observable<V1SubscriptionNote> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetSubscriptionNote(pixelId, subscriptionId, noteId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetSubscriptionNote(rsp)));
            }));
    }

    /**
     * List the org-owned address-exclusion files for an org
     * List an org's address-exclusion files
     * @param orgId 
     */
    public advertisingPlatformServiceListExclusionAddresses(orgId?: string, _options?: Configuration): Observable<V1ListExclusionAddressesResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListExclusionAddresses(orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListExclusionAddresses(rsp)));
            }));
    }

    /**
     * Get a subscription in pixel
     * Get all subscriptions for an org
     * @param pageSize The maximum number of items to return.
     * @param pageToken 
     * @param orgId 
     * @param orderBy 
     * @param id 
     * @param name 
     * @param pixelId 
     * @param pixelName 
     * @param tags 
     */
    public advertisingPlatformServiceListOrgSubscriptions(pageSize?: number, pageToken?: string, orgId?: string, orderBy?: string, id?: string, name?: string, pixelId?: string, pixelName?: string, tags?: Array<string>, _options?: Configuration): Observable<V1ListOrgSubscriptionsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListOrgSubscriptions(pageSize, pageToken, orgId, orderBy, id, name, pixelId, pixelName, tags, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListOrgSubscriptions(rsp)));
            }));
    }

    /**
     * List an org's pixels
     * List Pixels
     * @param pageSize The maximum number of items to return.
     * @param pageToken 
     * @param orgId 
     * @param orderBy 
     * @param id 
     * @param name 
     * @param tags 
     */
    public advertisingPlatformServiceListPixels(pageSize?: number, pageToken?: string, orgId?: string, orderBy?: string, id?: string, name?: string, tags?: Array<string>, _options?: Configuration): Observable<V1ListPixelsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListPixels(pageSize, pageToken, orgId, orderBy, id, name, tags, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListPixels(rsp)));
            }));
    }

    /**
     * Get a publisher in pixel
     * List all Publishers
     * @param pageSize 
     * @param pageToken 
     * @param orderBy 
     * @param orgId 
     */
    public advertisingPlatformServiceListPublishers(pageSize?: number, pageToken?: string, orderBy?: string, orgId?: string, _options?: Configuration): Observable<V1ListPublishersResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListPublishers(pageSize, pageToken, orderBy, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListPublishers(rsp)));
            }));
    }

    /**
     * Get a rule in pixel
     * List Rules
     * @param pixelId 
     * @param subscriptionId 
     * @param ruleSetId 
     * @param pageSize The maximum number of items to return.
     * @param pageToken 
     * @param orderBy 
     * @param orgId 
     */
    public advertisingPlatformServiceListRules(pixelId: string, subscriptionId: string, ruleSetId: string, pageSize?: number, pageToken?: string, orderBy?: string, orgId?: string, _options?: Configuration): Observable<V1ListRulesResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListRules(pixelId, subscriptionId, ruleSetId, pageSize, pageToken, orderBy, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListRules(rsp)));
            }));
    }

    /**
     * Get all stats on a subscription or filter by the run date. returns in most recently ran order
     * List Subscription Stats
     * @param pixelId 
     * @param subscriptionId 
     * @param pageSize The maximum number of items to return.
     * @param pageToken 
     * @param orgId 
     * @param startReportDate 
     * @param endReportDate 
     * @param orderBy 
     * @param returnDuplicates 
     */
    public advertisingPlatformServiceListStats(pixelId: string, subscriptionId: string, pageSize?: number, pageToken?: string, orgId?: string, startReportDate?: string, endReportDate?: string, orderBy?: string, returnDuplicates?: boolean, _options?: Configuration): Observable<V1ListStatsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListStats(pixelId, subscriptionId, pageSize, pageToken, orgId, startReportDate, endReportDate, orderBy, returnDuplicates, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListStats(rsp)));
            }));
    }

    /**
     * Get a subscription in pixel
     * List Subscriptions
     * @param pixelId 
     * @param pageSize The maximum number of items to return.
     * @param pageToken 
     * @param orgId 
     * @param orderBy 
     */
    public advertisingPlatformServiceListSubscriptions(pixelId: string, pageSize?: number, pageToken?: string, orgId?: string, orderBy?: string, _options?: Configuration): Observable<V1ListSubscriptionsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListSubscriptions(pixelId, pageSize, pageToken, orgId, orderBy, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListSubscriptions(rsp)));
            }));
    }

    /**
     * Get stats. returns in most recently ran order
     * List Stats
     * @param pageSize The maximum number of items to return.
     * @param pageToken 
     * @param orgId 
     * @param publisherId 
     * @param pixelId 
     * @param subscriptionId 
     * @param startReportDate 
     * @param endReportDate 
     * @param orderBy 
     * @param returnDuplicates 
     */
    public advertisingPlatformServiceListTotalStats(pageSize?: number, pageToken?: string, orgId?: string, publisherId?: string, pixelId?: string, subscriptionId?: string, startReportDate?: string, endReportDate?: string, orderBy?: string, returnDuplicates?: boolean, _options?: Configuration): Observable<V1ListTotalStatsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListTotalStats(pageSize, pageToken, orgId, publisherId, pixelId, subscriptionId, startReportDate, endReportDate, orderBy, returnDuplicates, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListTotalStats(rsp)));
            }));
    }

    /**
     * Run all subscriptions in pixel
     * Get all Subscriptions
     * @param reportDate 
     */
    public advertisingPlatformServiceRunAllSubscriptions(reportDate?: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceRunAllSubscriptions(reportDate, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceRunAllSubscriptions(rsp)));
            }));
    }

    /**
     * Run all subscriptions in pixel
     * Get a Subscription
     * @param pixelId 
     * @param subscriptionId 
     * @param body 
     */
    public advertisingPlatformServiceRunOneSubscription(pixelId: string, subscriptionId: string, body: AdvertisingPlatformServiceRunOneSubscriptionRequest, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceRunOneSubscription(pixelId, subscriptionId, body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceRunOneSubscription(rsp)));
            }));
    }

    /**
     * Update an ftp in pixel
     * Update an FTP
     * @param publisherId 
     * @param ftpId Id of the ftp server
     * @param ftp 
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdateFTP(publisherId: string, ftpId: string, ftp: AdvertisingPlatformServiceUpdateFTPRequest, updateMask?: string, orgId?: string, _options?: Configuration): Observable<V1FTP> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateFTP(publisherId, ftpId, ftp, updateMask, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateFTP(rsp)));
            }));
    }

    /**
     * Update a pixel in pixel
     * Update a Pixel
     * @param pixelId Id of the pixel
     * @param pixel 
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdatePixel(pixelId: string, pixel: AdvertisingPlatformServiceUpdatePixelRequest, updateMask?: string, orgId?: string, _options?: Configuration): Observable<V1Pixel> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdatePixel(pixelId, pixel, updateMask, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdatePixel(rsp)));
            }));
    }

    /**
     * Update Pixel's Note
     * @param pixelId 
     * @param noteId The Note ID.
     * @param note PixelNote
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdatePixelNote(pixelId: string, noteId: string, note: PixelNote, updateMask?: string, orgId?: string, _options?: Configuration): Observable<V1PixelNote> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdatePixelNote(pixelId, noteId, note, updateMask, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdatePixelNote(rsp)));
            }));
    }

    /**
     * Update a publisher in pixel
     * Update a Publisher
     * @param publisherId Id of the publisher
     * @param publisher 
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdatePublisher(publisherId: string, publisher: AdvertisingPlatformServiceUpdatePublisherRequest, updateMask?: string, orgId?: string, _options?: Configuration): Observable<V1Publisher> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdatePublisher(publisherId, publisher, updateMask, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdatePublisher(rsp)));
            }));
    }

    /**
     * Update a rule in pixel
     * Update an Rule
     * @param pixelId 
     * @param subscriptionId 
     * @param ruleSetId 
     * @param ruleId Id of the ruleset
     * @param rule 
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdateRule(pixelId: string, subscriptionId: string, ruleSetId: string, ruleId: string, rule: AdvertisingPlatformServiceUpdateRuleRequest, updateMask?: string, orgId?: string, _options?: Configuration): Observable<V1Rule> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateRule(pixelId, subscriptionId, ruleSetId, ruleId, rule, updateMask, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateRule(rsp)));
            }));
    }

    /**
     * Update a rule set in pixel
     * Update an RuleSet
     * @param pixelId 
     * @param subscriptionId 
     * @param ruleSetId Id of the ruleset
     * @param ruleSet 
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdateRuleSet(pixelId: string, subscriptionId: string, ruleSetId: string, ruleSet: AdvertisingPlatformServiceUpdateRuleSetRequest, updateMask?: string, orgId?: string, _options?: Configuration): Observable<V1RuleSet> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateRuleSet(pixelId, subscriptionId, ruleSetId, ruleSet, updateMask, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateRuleSet(rsp)));
            }));
    }

    /**
     * Update a subscription in pixel
     * Update a Subscription
     * @param pixelId 
     * @param subscriptionId Id of the subscription
     * @param subscription 
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdateSubscription(pixelId: string, subscriptionId: string, subscription: AdvertisingPlatformServiceUpdateSubscriptionRequest, updateMask?: string, orgId?: string, _options?: Configuration): Observable<V1Subscription> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateSubscription(pixelId, subscriptionId, subscription, updateMask, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateSubscription(rsp)));
            }));
    }

    /**
     * Update Subscription's Note
     * @param pixelId 
     * @param subscriptionId 
     * @param noteId The Note ID.
     * @param note SubscriptionNote
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdateSubscriptionNote(pixelId: string, subscriptionId: string, noteId: string, note: SubscriptionNote, updateMask?: string, orgId?: string, _options?: Configuration): Observable<V1SubscriptionNote> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdateSubscriptionNote(pixelId, subscriptionId, noteId, note, updateMask, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdateSubscriptionNote(rsp)));
            }));
    }

    /**
     * Upload a raw address CSV (multipart/form-data, field `file`) as a new org-owned address-exclusion file. The CSV header must be exactly `address1,address2,city,state,zip`. `org_id` is a required query parameter. Returns 202 Accepted; the raw file is staged to S3 and a geocode workflow runs asynchronously, later populating `s3_url`. Associate the file with a subscription via the `:attach` endpoint.
     * Upload Exclusion Addresses
     * @param body  (streaming inputs)
     */
    public advertisingPlatformServiceUploadExclusionAddresses(body: V1UploadExclusionAddressesRequest, _options?: Configuration): Observable<V1ExclusionAddresses> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUploadExclusionAddresses(body, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUploadExclusionAddresses(rsp)));
            }));
    }

}

import { WebToHomePrintPartnerOnlyApiRequestFactory, WebToHomePrintPartnerOnlyApiResponseProcessor} from "../apis/WebToHomePrintPartnerOnlyApi";
export class ObservableWebToHomePrintPartnerOnlyApi {
    private requestFactory: WebToHomePrintPartnerOnlyApiRequestFactory;
    private responseProcessor: WebToHomePrintPartnerOnlyApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: WebToHomePrintPartnerOnlyApiRequestFactory,
        responseProcessor?: WebToHomePrintPartnerOnlyApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new WebToHomePrintPartnerOnlyApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new WebToHomePrintPartnerOnlyApiResponseProcessor();
    }

    /**
     * Subscriptions - Notes - Create
     * @param publisherId 
     * @param subscriptionId 
     * @param note 
     * @param orgId 
     */
    public advertisingPlatformServiceCreatePublisherSubscriptionNote(publisherId: string, subscriptionId: string, note: V1SubscriptionNote, orgId?: string, _options?: Configuration): Observable<V1SubscriptionNote> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceCreatePublisherSubscriptionNote(publisherId, subscriptionId, note, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceCreatePublisherSubscriptionNote(rsp)));
            }));
    }

    /**
     * Delete a Subscription Note
     * Subscriptions - Notes - Delete
     * @param publisherId 
     * @param subscriptionId 
     * @param noteId 
     * @param orgId 
     */
    public advertisingPlatformServiceDeletePublisherSubscriptionNote(publisherId: string, subscriptionId: string, noteId: string, orgId?: string, _options?: Configuration): Observable<any> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceDeletePublisherSubscriptionNote(publisherId, subscriptionId, noteId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceDeletePublisherSubscriptionNote(rsp)));
            }));
    }

    /**
     * Get a subscription in which the user/org is the print partner. This is a restricted endpoint and only available to print partners Only the fields the print partner has access to view are returned. 
     * Subscriptions - Get
     * @param publisherId 
     * @param subscriptionId 
     * @param orgId 
     */
    public advertisingPlatformServiceGetPublisherSubscription(publisherId: string, subscriptionId: string, orgId?: string, _options?: Configuration): Observable<V1PublisherSubscription> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetPublisherSubscription(publisherId, subscriptionId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetPublisherSubscription(rsp)));
            }));
    }

    /**
     * Get a note made on the subscription. This is a restricted endpoint and only available to print partners 
     * Subscriptions - Notes - Get
     * @param publisherId 
     * @param subscriptionId 
     * @param noteId 
     * @param orgId 
     */
    public advertisingPlatformServiceGetPublisherSubscriptionNote(publisherId: string, subscriptionId: string, noteId: string, orgId?: string, _options?: Configuration): Observable<V1SubscriptionNote> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceGetPublisherSubscriptionNote(publisherId, subscriptionId, noteId, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceGetPublisherSubscriptionNote(rsp)));
            }));
    }

    /**
     * Get all stats on a subscription or filter by the run date. returns in most recently ran order This is a restricted endpoint and only available to print partners Only the stats for subscriptions the user/org is the print partner can be accessed. The only valid filters to use fight now are start_report_date and end_report_date. These are formatted as strings. If you pass start_report_date but not end_report_date, you will get all stats for runs after start_report_date. If you pass start_report_date and end_report_date, you will get all stats for runs after start_report_date and before the end_report_date. If you pass only the end_report_date, you will get all stats for runs that occurred before the end_report_date. 
     * Subscriptions - Stats - List
     * @param publisherId 
     * @param subscriptionId 
     * @param pageSize The maximum number of items to return.
     * @param pageToken 
     * @param orgId 
     * @param startReportDate 
     * @param endReportDate 
     * @param orderBy 
     * @param returnDuplicates 
     */
    public advertisingPlatformServiceListPublisherSubscriptionStats(publisherId: string, subscriptionId: string, pageSize?: number, pageToken?: string, orgId?: string, startReportDate?: string, endReportDate?: string, orderBy?: string, returnDuplicates?: boolean, _options?: Configuration): Observable<V1ListStatsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListPublisherSubscriptionStats(publisherId, subscriptionId, pageSize, pageToken, orgId, startReportDate, endReportDate, orderBy, returnDuplicates, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListPublisherSubscriptionStats(rsp)));
            }));
    }

    /**
     * List all the subscriptions in which the user/org is the print partner  This is a restricted endpoint and only available to print partners Only the fields the print partner has access to view are returned. 
     * Subscriptions - List
     * @param publisherId 
     * @param pageSize The maximum number of items to return.
     * @param pageToken 
     * @param orgId 
     * @param orderBy 
     * @param name 
     * @param id 
     * @param tags 
     */
    public advertisingPlatformServiceListPublisherSubscriptions(publisherId: string, pageSize?: number, pageToken?: string, orgId?: string, orderBy?: string, name?: string, id?: string, tags?: Array<string>, _options?: Configuration): Observable<V1ListPublisherSubscriptionsResponse> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceListPublisherSubscriptions(publisherId, pageSize, pageToken, orgId, orderBy, name, id, tags, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceListPublisherSubscriptions(rsp)));
            }));
    }

    /**
     * Update a subscription in pixel which the user/org is the print partner  This is a restricted endpoint and only available to print partners Only the fields the print partner can update are: enabled and ftp_path. notes can be managed via the notes endpoint.  
     * Subscriptions - Update
     * @param publisherId 
     * @param subscriptionId 
     * @param subscription 
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdatePublisherSubscription(publisherId: string, subscriptionId: string, subscription: AdvertisingPlatformServiceUpdatePublisherSubscriptionRequest, updateMask?: string, orgId?: string, _options?: Configuration): Observable<V1PublisherSubscription> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdatePublisherSubscription(publisherId, subscriptionId, subscription, updateMask, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdatePublisherSubscription(rsp)));
            }));
    }

    /**
     * Subscriptions - Notes - Update
     * @param publisherId 
     * @param subscriptionId 
     * @param noteId The Note ID.
     * @param note SubscriptionNote
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdatePublisherSubscriptionNote(publisherId: string, subscriptionId: string, noteId: string, note: SubscriptionNote, updateMask?: string, orgId?: string, _options?: Configuration): Observable<V1SubscriptionNote> {
        const requestContextPromise = this.requestFactory.advertisingPlatformServiceUpdatePublisherSubscriptionNote(publisherId, subscriptionId, noteId, note, updateMask, orgId, _options);

        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (let middleware of this.configuration.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (let middleware of this.configuration.middleware) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.advertisingPlatformServiceUpdatePublisherSubscriptionNote(rsp)));
            }));
    }

}
